/* ADDED BY BTOWNWEB FOR SURCHARGE PRODUCTS */
var surcharge_data = (function() { try { return JSON.parse($('[data-btown-surcharge]').text()); } catch(e) { return { variant_id: 0, cutoff_point: 0 }; } })();
var SURCHARGE_VARIANT_ID = surcharge_data.variant_id,
    SURCHARGE_CUTOFF = surcharge_data.cutoff_point;
function calculateTotalInArray(source){
  var total = 0;
  for(var i = 0; i < source.length; i++){
    total += parseInt(source[i]);
  }
  return total;
}
/* END */

//	@license | Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
(function(){function a(a,b){return a.set(b[0],b[1]),a}function b(a,b){return a.add(b),a}function c(a,b,c){switch(c.length){case 0:return a.call(b);case 1:return a.call(b,c[0]);case 2:return a.call(b,c[0],c[1]);case 3:return a.call(b,c[0],c[1],c[2])}return a.apply(b,c)}function d(a,b,c,d){for(var e=-1,f=null==a?0:a.length;++e<f;){var g=a[e];b(d,g,c(g),a)}return d}function e(a,b){for(var c=-1,d=null==a?0:a.length;++c<d&&!1!==b(a[c],c,a););return a}function f(a,b){for(var c=null==a?0:a.length;c--&&!1!==b(a[c],c,a););return a}function g(a,b){for(var c=-1,d=null==a?0:a.length;++c<d;)if(!b(a[c],c,a))return!1;return!0}function h(a,b){for(var c=-1,d=null==a?0:a.length,e=0,f=[];++c<d;){var g=a[c];b(g,c,a)&&(f[e++]=g)}return f}function i(a,b){return!(null==a||!a.length)&&-1<r(a,b,0)}function j(a,b,c){for(var d=-1,e=null==a?0:a.length;++d<e;)if(c(b,a[d]))return!0;return!1}function k(a,b){for(var c=-1,d=null==a?0:a.length,e=Array(d);++c<d;)e[c]=b(a[c],c,a);return e}function l(a,b){for(var c=-1,d=b.length,e=a.length;++c<d;)a[e+c]=b[c];return a}function m(a,b,c,d){var e=-1,f=null==a?0:a.length;for(d&&f&&(c=a[++e]);++e<f;)c=b(c,a[e],e,a);return c}function n(a,b,c,d){var e=null==a?0:a.length;for(d&&e&&(c=a[--e]);e--;)c=b(c,a[e],e,a);return c}function o(a,b){for(var c=-1,d=null==a?0:a.length;++c<d;)if(b(a[c],c,a))return!0;return!1}function p(a,b,c){var d;return c(a,function(a,c,e){if(b(a,c,e))return d=c,!1}),d}function q(a,b,c,d){var e=a.length;for(c+=d?1:-1;d?c--:++c<e;)if(b(a[c],c,a))return c;return-1}function r(a,b,c){if(b===b)a:{--c;for(var d=a.length;++c<d;)if(a[c]===b){a=c;break a}a=-1}else a=q(a,t,c);return a}function s(a,b,c,d){--c;for(var e=a.length;++c<e;)if(d(a[c],b))return c;return-1}function t(a){return a!==a}function u(a,b){var c=null==a?0:a.length;return c?z(a,b)/c:R}function v(a){return function(b){return null==b?P:b[a]}}function w(a){return function(b){return null==a?P:a[b]}}function x(a,b,c,d,e){return e(a,function(a,e,f){c=d?(d=!1,a):b(c,a,e,f)}),c}function y(a,b){var c=a.length;for(a.sort(b);c--;)a[c]=a[c].c;return a}function z(a,b){for(var c,d=-1,e=a.length;++d<e;){var f=b(a[d]);f!==P&&(c=c===P?f:c+f)}return c}function A(a,b){for(var c=-1,d=Array(a);++c<a;)d[c]=b(c);return d}function B(a,b){return k(b,function(b){return[b,a[b]]})}function C(a){return function(b){return a(b)}}function D(a,b){return k(b,function(b){return a[b]})}function E(a,b){return a.has(b)}function F(a,b){for(var c=-1,d=a.length;++c<d&&-1<r(b,a[c],0););return c}function G(a,b){for(var c=a.length;c--&&-1<r(b,a[c],0););return c}function H(a){return"\\"+Ma[a]}function I(a){var b=-1,c=Array(a.size);return a.forEach(function(a,d){c[++b]=[d,a]}),c}function J(a,b){return function(c){return a(b(c))}}function K(a,b){for(var c=-1,d=a.length,e=0,f=[];++c<d;){var g=a[c];g!==b&&"__lodash_placeholder__"!==g||(a[c]="__lodash_placeholder__",f[e++]=c)}return f}function L(a){var b=-1,c=Array(a.size);return a.forEach(function(a){c[++b]=a}),c}function M(a){var b=-1,c=Array(a.size);return a.forEach(function(a){c[++b]=[a,a]}),c}function N(a){if(Ga.test(a)){for(var b=Ea.lastIndex=0;Ea.test(a);)++b;a=b}else a=ab(a);return a}function O(a){return Ga.test(a)?a.match(Ea)||[]:a.split("")}var P,Q=1/0,R=NaN,S=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],T=/\b__p\+='';/g,U=/\b(__p\+=)''\+/g,V=/(__e\(.*?\)|\b__t\))\+'';/g,W=/&(?:amp|lt|gt|quot|#39);/g,X=/[&<>"']/g,Y=RegExp(W.source),Z=RegExp(X.source),$=/<%-([\s\S]+?)%>/g,_=/<%([\s\S]+?)%>/g,aa=/<%=([\s\S]+?)%>/g,ba=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,ca=/^\w*$/,da=/^\./,ea=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,fa=/[\\^$.*+?()[\]{}|]/g,ga=RegExp(fa.source),ha=/^\s+|\s+$/g,ia=/^\s+/,ja=/\s+$/,ka=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,la=/\{\n\/\* \[wrapped with (.+)\] \*/,ma=/,? & /,na=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,oa=/\\(\\)?/g,pa=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,qa=/\w*$/,ra=/^[-+]0x[0-9a-f]+$/i,sa=/^0b[01]+$/i,ta=/^\[object .+?Constructor\]$/,ua=/^0o[0-7]+$/i,va=/^(?:0|[1-9]\d*)$/,wa=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,xa=/($^)/,ya=/['\n\r\u2028\u2029\\]/g,za="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",Aa="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+za,Ba="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",Ca=RegExp("['’]","g"),Da=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),Ea=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+Ba+za,"g"),Fa=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)|\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)|\\d+",Aa].join("|"),"g"),Ga=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),Ha=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Ia="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Ja={};Ja["[object Float32Array]"]=Ja["[object Float64Array]"]=Ja["[object Int8Array]"]=Ja["[object Int16Array]"]=Ja["[object Int32Array]"]=Ja["[object Uint8Array]"]=Ja["[object Uint8ClampedArray]"]=Ja["[object Uint16Array]"]=Ja["[object Uint32Array]"]=!0,Ja["[object Arguments]"]=Ja["[object Array]"]=Ja["[object ArrayBuffer]"]=Ja["[object Boolean]"]=Ja["[object DataView]"]=Ja["[object Date]"]=Ja["[object Error]"]=Ja["[object Function]"]=Ja["[object Map]"]=Ja["[object Number]"]=Ja["[object Object]"]=Ja["[object RegExp]"]=Ja["[object Set]"]=Ja["[object String]"]=Ja["[object WeakMap]"]=!1;var Ka={};Ka["[object Arguments]"]=Ka["[object Array]"]=Ka["[object ArrayBuffer]"]=Ka["[object DataView]"]=Ka["[object Boolean]"]=Ka["[object Date]"]=Ka["[object Float32Array]"]=Ka["[object Float64Array]"]=Ka["[object Int8Array]"]=Ka["[object Int16Array]"]=Ka["[object Int32Array]"]=Ka["[object Map]"]=Ka["[object Number]"]=Ka["[object Object]"]=Ka["[object RegExp]"]=Ka["[object Set]"]=Ka["[object String]"]=Ka["[object Symbol]"]=Ka["[object Uint8Array]"]=Ka["[object Uint8ClampedArray]"]=Ka["[object Uint16Array]"]=Ka["[object Uint32Array]"]=!0,Ka["[object Error]"]=Ka["[object Function]"]=Ka["[object WeakMap]"]=!1;var La,Ma={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Na=parseFloat,Oa=parseInt,Pa="object"==typeof global&&global&&global.Object===Object&&global,Qa="object"==typeof self&&self&&self.Object===Object&&self,Ra=Pa||Qa||Function("return this")(),Sa="object"==typeof exports&&exports&&!exports.nodeType&&exports,Ta=Sa&&"object"==typeof module&&module&&!module.nodeType&&module,Ua=Ta&&Ta.exports===Sa,Va=Ua&&Pa.process;a:{try{La=Va&&Va.binding&&Va.binding("util");break a}catch(a){}La=void 0}var Wa=La&&La.isArrayBuffer,Xa=La&&La.isDate,Ya=La&&La.isMap,Za=La&&La.isRegExp,$a=La&&La.isSet,_a=La&&La.isTypedArray,ab=v("length"),bb=w({"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"s"}),cb=w({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),db=w({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),eb=function w(za){function Aa(a){if(te(a)&&!hh(a)&&!(a instanceof La)){if(a instanceof Ea)return a;if(hf.call(a,"__wrapped__"))return Qd(a)}return new Ea(a)}function Ba(){}function Ea(a,b){this.__wrapped__=a,this.__actions__=[],this.__chain__=!!b,this.__index__=0,this.__values__=P}function La(a){this.__wrapped__=a,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Ma(a){var b=-1,c=null==a?0:a.length;for(this.clear();++b<c;){var d=a[b];this.set(d[0],d[1])}}function Pa(a){var b=-1,c=null==a?0:a.length;for(this.clear();++b<c;){var d=a[b];this.set(d[0],d[1])}}function Qa(a){var b=-1,c=null==a?0:a.length;for(this.clear();++b<c;){var d=a[b];this.set(d[0],d[1])}}function Sa(a){var b=-1,c=null==a?0:a.length;for(this.__data__=new Qa;++b<c;)this.add(a[b])}function Ta(a){this.size=(this.__data__=new Pa(a)).size}function Va(a,b){var c,d=hh(a),e=!d&&gh(a),f=!d&&!e&&jh(a),g=!d&&!e&&!f&&oh(a),e=(d=d||e||f||g)?A(a.length,bf):[],h=e.length;for(c in a)!b&&!hf.call(a,c)||d&&("length"==c||f&&("offset"==c||"parent"==c)||g&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||Dd(c,h))||e.push(c);return e}function ab(a){var b=a.length;return b?a[hc(0,b-1)]:P}function fb(a,b){return Md(Lc(a),pb(b,0,a.length))}function gb(a){return Md(Lc(a))}function hb(a,b,c){(c===P||le(a[b],c))&&(c!==P||b in a)||nb(a,b,c)}function ib(a,b,c){var d=a[b];hf.call(a,b)&&le(d,c)&&(c!==P||b in a)||nb(a,b,c)}function jb(a,b){for(var c=a.length;c--;)if(le(a[c][0],b))return c;return-1}function kb(a,b,c,d){return gg(a,function(a,e,f){b(d,a,c(a),f)}),d}function lb(a,b){return a&&Mc(b,He(b),a)}function mb(a,b){return a&&Mc(b,Ie(b),a)}function nb(a,b,c){"__proto__"==b&&Af?Af(a,b,{configurable:!0,enumerable:!0,value:c,writable:!0}):a[b]=c}function ob(a,b){for(var c=-1,d=b.length,e=We(d),f=null==a;++c<d;)e[c]=f?P:Fe(a,b[c]);return e}function pb(a,b,c){return a===a&&(c!==P&&(a=a<=c?a:c),b!==P&&(a=a>=b?a:b)),a}function qb(a,b,c,d,f,g){var h,i=1&b,j=2&b,k=4&b;if(c&&(h=f?c(a,d,f,g):c(a)),h!==P)return h;if(!se(a))return a;if(d=hh(a)){if(h=zd(a),!i)return Lc(a,h)}else{var l=rg(a),m="[object Function]"==l||"[object GeneratorFunction]"==l;if(jh(a))return Fc(a,i);if("[object Object]"==l||"[object Arguments]"==l||m&&!f){if(h=j||m?{}:Ad(a),!i)return j?Oc(a,mb(h,a)):Nc(a,lb(h,a))}else{if(!Ka[l])return f?a:{};h=Bd(a,l,qb,i)}}if(g||(g=new Ta),f=g.get(a))return f;g.set(a,h);var j=k?j?rd:qd:j?Ie:He,n=d?P:j(a);return e(n||a,function(d,e){n&&(e=d,d=a[e]),ib(h,e,qb(d,b,c,e,a,g))}),h}function rb(a){var b=He(a);return function(c){return sb(c,a,b)}}function sb(a,b,c){var d=c.length;if(null==a)return!d;for(a=_e(a);d--;){var e=c[d],f=b[e],g=a[e];if(g===P&&!(e in a)||!f(g))return!1}return!0}function tb(a,b,c){if("function"!=typeof a)throw new cf("Expected a function");return ug(function(){a.apply(P,c)},b)}function ub(a,b,c,d){var e=-1,f=i,g=!0,h=a.length,l=[],m=b.length;if(!h)return l;c&&(b=k(b,C(c))),d?(f=j,g=!1):200<=b.length&&(f=E,g=!1,b=new Sa(b));a:for(;++e<h;){var n=a[e],o=null==c?n:c(n),n=d||0!==n?n:0;if(g&&o===o){for(var p=m;p--;)if(b[p]===o)continue a;l.push(n)}else f(b,o,d)||l.push(n)}return l}function vb(a,b){var c=!0;return gg(a,function(a,d,e){return c=!!b(a,d,e)}),c}function wb(a,b,c){for(var d=-1,e=a.length;++d<e;){var f=a[d],g=b(f);if(null!=g&&(h===P?g===g&&!xe(g):c(g,h)))var h=g,i=f}return i}function xb(a,b){var c=[];return gg(a,function(a,d,e){b(a,d,e)&&c.push(a)}),c}function yb(a,b,c,d,e){var f=-1,g=a.length;for(c||(c=Cd),e||(e=[]);++f<g;){var h=a[f];0<b&&c(h)?1<b?yb(h,b-1,c,d,e):l(e,h):d||(e[e.length]=h)}return e}function zb(a,b){return a&&ig(a,b,He)}function Ab(a,b){return a&&jg(a,b,He)}function Bb(a,b){return h(b,function(b){return pe(a[b])})}function Cb(a,b){b=Dc(b,a);for(var c=0,d=b.length;null!=a&&c<d;)a=a[Nd(b[c++])];return c&&c==d?a:P}function Db(a,b,c){return b=b(a),hh(a)?b:l(b,c(a))}function Eb(a){if(null==a)a=a===P?"[object Undefined]":"[object Null]";else if(zf&&zf in _e(a)){var b=hf.call(a,zf),c=a[zf];try{a[zf]=P;var d=!0}catch(a){}var e=lf.call(a);d&&(b?a[zf]=c:delete a[zf]),a=e}else a=lf.call(a);return a}function Fb(a,b){return a>b}function Gb(a,b){return null!=a&&hf.call(a,b)}function Hb(a,b){return null!=a&&b in _e(a)}function Ib(a,b,c){for(var d=c?j:i,e=a[0].length,f=a.length,g=f,h=We(f),l=1/0,m=[];g--;){var n=a[g];g&&b&&(n=k(n,C(b))),l=Mf(n.length,l),h[g]=!c&&(b||120<=e&&120<=n.length)?new Sa(g&&n):P}var n=a[0],o=-1,p=h[0];a:for(;++o<e&&m.length<l;){var q=n[o],r=b?b(q):q,q=c||0!==q?q:0;if(p?!E(p,r):!d(m,r,c)){for(g=f;--g;){var s=h[g];if(s?!E(s,r):!d(a[g],r,c))continue a}p&&p.push(r),m.push(q)}}return m}function Jb(a,b,c){var d={};return zb(a,function(a,e,f){b(d,c(a),e,f)}),d}function Kb(a,b,d){return b=Dc(b,a),a=2>b.length?a:Cb(a,oc(b,0,-1)),b=null==a?a:a[Nd(Vd(b))],null==b?P:c(b,a,d)}function Lb(a){return te(a)&&"[object Arguments]"==Eb(a)}function Mb(a){return te(a)&&"[object ArrayBuffer]"==Eb(a)}function Nb(a){return te(a)&&"[object Date]"==Eb(a)}function Ob(a,b,c,d,e){if(a===b)b=!0;else if(null==a||null==b||!te(a)&&!te(b))b=a!==a&&b!==b;else a:{var f=hh(a),g=hh(b),h=f?"[object Array]":rg(a),i=g?"[object Array]":rg(b),h="[object Arguments]"==h?"[object Object]":h,i="[object Arguments]"==i?"[object Object]":i,j="[object Object]"==h,g="[object Object]"==i;if((i=h==i)&&jh(a)){if(!jh(b)){b=!1;break a}f=!0,j=!1}if(i&&!j)e||(e=new Ta),b=f||oh(a)?nd(a,b,c,d,Ob,e):od(a,b,h,c,d,Ob,e);else{if(!(1&c)&&(f=j&&hf.call(a,"__wrapped__"),h=g&&hf.call(b,"__wrapped__"),f||h)){a=f?a.value():a,b=h?b.value():b,e||(e=new Ta),b=Ob(a,b,c,d,e);break a}if(i)b:if(e||(e=new Ta),f=1&c,h=qd(a),g=h.length,i=qd(b).length,g==i||f){for(j=g;j--;){var k=h[j];if(!(f?k in b:hf.call(b,k))){b=!1;break b}}if((i=e.get(a))&&e.get(b))b=i==b;else{i=!0,e.set(a,b),e.set(b,a);for(var l=f;++j<g;){var k=h[j],m=a[k],n=b[k];if(d)var o=f?d(n,m,k,b,a,e):d(m,n,k,a,b,e);if(o===P?m!==n&&!Ob(m,n,c,d,e):!o){i=!1;break}l||(l="constructor"==k)}i&&!l&&(c=a.constructor,d=b.constructor,c!=d&&"constructor"in a&&"constructor"in b&&!("function"==typeof c&&c instanceof c&&"function"==typeof d&&d instanceof d)&&(i=!1)),e.delete(a),e.delete(b),b=i}}else b=!1;else b=!1}}return b}function Pb(a){return te(a)&&"[object Map]"==rg(a)}function Qb(a,b,c,d){var e=c.length,f=e,g=!d;if(null==a)return!f;for(a=_e(a);e--;){var h=c[e];if(g&&h[2]?h[1]!==a[h[0]]:!(h[0]in a))return!1}for(;++e<f;){var h=c[e],i=h[0],j=a[i],k=h[1];if(g&&h[2]){if(j===P&&!(i in a))return!1}else{if(h=new Ta,d)var l=d(j,k,i,a,b,h);if(l===P?!Ob(k,j,3,d,h):!l)return!1}}return!0}function Rb(a){return!(!se(a)||kf&&kf in a)&&(pe(a)?of:ta).test(Od(a))}function Sb(a){return te(a)&&"[object RegExp]"==Eb(a)}function Tb(a){return te(a)&&"[object Set]"==rg(a)}function Ub(a){return te(a)&&re(a.length)&&!!Ja[Eb(a)]}function Vb(a){return"function"==typeof a?a:null==a?Pe:"object"==typeof a?hh(a)?$b(a[0],a[1]):Zb(a):Te(a)}function Wb(a){if(!Hd(a))return Kf(a);var b,c=[];for(b in _e(a))hf.call(a,b)&&"constructor"!=b&&c.push(b);return c}function Xb(a,b){return a<b}function Yb(a,b){var c=-1,d=me(a)?We(a.length):[];return gg(a,function(a,e,f){d[++c]=b(a,e,f)}),d}function Zb(a){var b=wd(a);return 1==b.length&&b[0][2]?Id(b[0][0],b[0][1]):function(c){return c===a||Qb(c,a,b)}}function $b(a,b){return Fd(a)&&b===b&&!se(b)?Id(Nd(a),b):function(c){var d=Fe(c,a);return d===P&&d===b?Ge(c,a):Ob(b,d,3)}}function _b(a,b,c,d,e){a!==b&&ig(b,function(f,g){if(se(f)){e||(e=new Ta);var h=e,i=a[g],j=b[g],k=h.get(j);if(k)hb(a,g,k);else{var k=d?d(i,j,g+"",a,b,h):P,l=k===P;if(l){var m=hh(j),n=!m&&jh(j),o=!m&&!n&&oh(j),k=j;m||n||o?hh(i)?k=i:ne(i)?k=Lc(i):n?(l=!1,k=Fc(j,!0)):o?(l=!1,k=Hc(j,!0)):k=[]:ve(j)||gh(j)?(k=i,gh(i)?k=De(i):(!se(i)||c&&pe(i))&&(k=Ad(j))):l=!1}l&&(h.set(j,k),_b(k,j,c,d,h),h.delete(j)),hb(a,g,k)}}else h=d?d(a[g],f,g+"",a,b,e):P,h===P&&(h=f),hb(a,g,h)},Ie)}function ac(a,b){var c=a.length;if(c)return b+=0>b?c:0,Dd(b,c)?a[b]:P}function bc(a,b,c){var d=-1;return b=k(b.length?b:[Pe],C(ud())),a=Yb(a,function(a){return{a:k(b,function(b){return b(a)}),b:++d,c:a}}),y(a,function(a,b){var d;a:{d=-1;for(var e=a.a,f=b.a,g=e.length,h=c.length;++d<g;){var i=Ic(e[d],f[d]);if(i){d=d>=h?i:i*("desc"==c[d]?-1:1);break a}}d=a.b-b.b}return d})}function cc(a,b){return dc(a,b,function(b,c){return Ge(a,c)})}function dc(a,b,c){for(var d=-1,e=b.length,f={};++d<e;){var g=b[d],h=Cb(a,g);c(h,g)&&mc(f,Dc(g,a),h)}return f}function ec(a){return function(b){return Cb(b,a)}}function fc(a,b,c,d){var e=d?s:r,f=-1,g=b.length,h=a;for(a===b&&(b=Lc(b)),c&&(h=k(a,C(c)));++f<g;)for(var i=0,j=b[f],j=c?c(j):j;-1<(i=e(h,j,i,d));)h!==a&&wf.call(h,i,1),wf.call(a,i,1);return a}function gc(a,b){for(var c=a?b.length:0,d=c-1;c--;){var e=b[c];if(c==d||e!==f){var f=e;Dd(e)?wf.call(a,e,1):wc(a,e)}}}function hc(a,b){return a+Ff(Pf()*(b-a+1))}function ic(a,b){var c="";if(!a||1>b||9007199254740991<b)return c;do{b%2&&(c+=a),(b=Ff(b/2))&&(a+=a)}while(b);return c}function jc(a,b){return vg(Jd(a,b,Pe),a+"")}function kc(a){return ab(Ke(a))}function lc(a,b){var c=Ke(a);return Md(c,pb(b,0,c.length))}function mc(a,b,c,d){if(!se(a))return a;b=Dc(b,a);for(var e=-1,f=b.length,g=f-1,h=a;null!=h&&++e<f;){var i=Nd(b[e]),j=c;if(e!=g){var k=h[i],j=d?d(k,i,h):P;j===P&&(j=se(k)?k:Dd(b[e+1])?[]:{})}ib(h,i,j),h=h[i]}return a}function nc(a){return Md(Ke(a))}function oc(a,b,c){var d=-1,e=a.length;for(0>b&&(b=-b>e?0:e+b),c=c>e?e:c,0>c&&(c+=e),e=b>c?0:c-b>>>0,b>>>=0,c=We(e);++d<e;)c[d]=a[d+b];return c}function pc(a,b){var c;return gg(a,function(a,d,e){return!(c=b(a,d,e))}),!!c}function qc(a,b,c){var d=0,e=null==a?d:a.length;if("number"==typeof b&&b===b&&2147483647>=e){for(;d<e;){var f=d+e>>>1,g=a[f];null!==g&&!xe(g)&&(c?g<=b:g<b)?d=f+1:e=f}return e}return rc(a,b,Pe,c)}function rc(a,b,c,d){b=c(b);for(var e=0,f=null==a?0:a.length,g=b!==b,h=null===b,i=xe(b),j=b===P;e<f;){var k=Ff((e+f)/2),l=c(a[k]),m=l!==P,n=null===l,o=l===l,p=xe(l);(g?d||o:j?o&&(d||m):h?o&&m&&(d||!n):i?o&&m&&!n&&(d||!p):n||p?0:d?l<=b:l<b)?e=k+1:f=k}return Mf(f,4294967294)}function sc(a,b){for(var c=-1,d=a.length,e=0,f=[];++c<d;){var g=a[c],h=b?b(g):g;if(!c||!le(h,i)){var i=h;f[e++]=0===g?0:g}}return f}function tc(a){return"number"==typeof a?a:xe(a)?R:+a}function uc(a){if("string"==typeof a)return a;if(hh(a))return k(a,uc)+"";if(xe(a))return eg?eg.call(a):"";var b=a+"";return"0"==b&&1/a==-Q?"-0":b}function vc(a,b,c){var d=-1,e=i,f=a.length,g=!0,h=[],k=h;if(c)g=!1,e=j;else if(200<=f){if(e=b?null:ng(a))return L(e);g=!1,e=E,k=new Sa}else k=b?[]:h;a:for(;++d<f;){var l=a[d],m=b?b(l):l,l=c||0!==l?l:0;if(g&&m===m){for(var n=k.length;n--;)if(k[n]===m)continue a;b&&k.push(m),h.push(l)}else e(k,m,c)||(k!==h&&k.push(m),h.push(l))}return h}function wc(a,b){return b=Dc(b,a),null==(a=2>b.length?a:Cb(a,oc(b,0,-1)))||delete a[Nd(Vd(b))]}function xc(a,b,c,d){for(var e=a.length,f=d?e:-1;(d?f--:++f<e)&&b(a[f],f,a););return c?oc(a,d?0:f,d?f+1:e):oc(a,d?f+1:0,d?e:f)}function yc(a,b){var c=a;return c instanceof La&&(c=c.value()),m(b,function(a,b){return b.func.apply(b.thisArg,l([a],b.args))},c)}function zc(a,b,c){var d=a.length;if(2>d)return d?vc(a[0]):[];for(var e=-1,f=We(d);++e<d;)for(var g=a[e],h=-1;++h<d;)h!=e&&(f[e]=ub(f[e]||g,a[h],b,c));return vc(yb(f,1),b,c)}function Ac(a,b,c){for(var d=-1,e=a.length,f=b.length,g={};++d<e;)c(g,a[d],d<f?b[d]:P);return g}function Bc(a){return ne(a)?a:[]}function Cc(a){return"function"==typeof a?a:Pe}function Dc(a,b){return hh(a)?a:Fd(a,b)?[a]:wg(Ee(a))}function Ec(a,b,c){var d=a.length;return c=c===P?d:c,!b&&c>=d?a:oc(a,b,c)}function Fc(a,b){if(b)return a.slice();var c=a.length,c=sf?sf(c):new a.constructor(c);return a.copy(c),c}function Gc(a){var b=new a.constructor(a.byteLength);return new rf(b).set(new rf(a)),b}function Hc(a,b){return new a.constructor(b?Gc(a.buffer):a.buffer,a.byteOffset,a.length)}function Ic(a,b){if(a!==b){var c=a!==P,d=null===a,e=a===a,f=xe(a),g=b!==P,h=null===b,i=b===b,j=xe(b);if(!h&&!j&&!f&&a>b||f&&g&&i&&!h&&!j||d&&g&&i||!c&&i||!e)return 1;if(!d&&!f&&!j&&a<b||j&&c&&e&&!d&&!f||h&&c&&e||!g&&e||!i)return-1}return 0}function Jc(a,b,c,d){var e=-1,f=a.length,g=c.length,h=-1,i=b.length,j=Lf(f-g,0),k=We(i+j);for(d=!d;++h<i;)k[h]=b[h];for(;++e<g;)(d||e<f)&&(k[c[e]]=a[e]);for(;j--;)k[h++]=a[e++];return k}function Kc(a,b,c,d){var e=-1,f=a.length,g=-1,h=c.length,i=-1,j=b.length,k=Lf(f-h,0),l=We(k+j);for(d=!d;++e<k;)l[e]=a[e];for(k=e;++i<j;)l[k+i]=b[i];for(;++g<h;)(d||e<f)&&(l[k+c[g]]=a[e++]);return l}function Lc(a,b){var c=-1,d=a.length;for(b||(b=We(d));++c<d;)b[c]=a[c];return b}function Mc(a,b,c,d){var e=!c;c||(c={});for(var f=-1,g=b.length;++f<g;){var h=b[f],i=d?d(c[h],a[h],h,c,a):P;i===P&&(i=a[h]),e?nb(c,h,i):ib(c,h,i)}return c}function Nc(a,b){return Mc(a,pg(a),b)}function Oc(a,b){return Mc(a,qg(a),b)}function Pc(a,b){return function(c,e){var f=hh(c)?d:kb,g=b?b():{};return f(c,a,ud(e,2),g)}}function Qc(a){return jc(function(b,c){var d=-1,e=c.length,f=1<e?c[e-1]:P,g=2<e?c[2]:P,f=3<a.length&&"function"==typeof f?(e--,f):P;for(g&&Ed(c[0],c[1],g)&&(f=3>e?P:f,e=1),b=_e(b);++d<e;)(g=c[d])&&a(b,g,d,f);return b})}function Rc(a,b){return function(c,d){if(null==c)return c;if(!me(c))return a(c,d);for(var e=c.length,f=b?e:-1,g=_e(c);(b?f--:++f<e)&&!1!==d(g[f],f,g););return c}}function Sc(a){return function(b,c,d){var e=-1,f=_e(b);d=d(b);for(var g=d.length;g--;){var h=d[a?g:++e];if(!1===c(f[h],h,f))break}return b}}function Tc(a,b,c){function d(){return(this&&this!==Ra&&this instanceof d?f:a).apply(e?c:this,arguments)}var e=1&b,f=Wc(a);return d}function Uc(a){return function(b){b=Ee(b);var c=Ga.test(b)?O(b):P,d=c?c[0]:b.charAt(0);return b=c?Ec(c,1).join(""):b.slice(1),d[a]()+b}}function Vc(a){return function(b){return m(Ne(Me(b).replace(Ca,"")),a,"")}}function Wc(a){return function(){var b=arguments;switch(b.length){case 0:return new a;case 1:return new a(b[0]);case 2:return new a(b[0],b[1]);case 3:return new a(b[0],b[1],b[2]);case 4:return new a(b[0],b[1],b[2],b[3]);case 5:return new a(b[0],b[1],b[2],b[3],b[4]);case 6:return new a(b[0],b[1],b[2],b[3],b[4],b[5]);case 7:return new a(b[0],b[1],b[2],b[3],b[4],b[5],b[6])}var c=fg(a.prototype),b=a.apply(c,b);return se(b)?b:c}}function Xc(a,b,d){function e(){for(var g=arguments.length,h=We(g),i=g,j=td(e);i--;)h[i]=arguments[i];return i=3>g&&h[0]!==j&&h[g-1]!==j?[]:K(h,j),g-=i.length,g<d?gd(a,b,$c,e.placeholder,P,h,i,P,P,d-g):c(this&&this!==Ra&&this instanceof e?f:a,this,h)}var f=Wc(a);return e}function Yc(a){return function(b,c,d){var e=_e(b);if(!me(b)){var f=ud(c,3);b=He(b),c=function(a){return f(e[a],a,e)}}return c=a(b,c,d),-1<c?e[f?b[c]:c]:P}}function Zc(a){return pd(function(b){var c=b.length,d=c,e=Ea.prototype.thru;for(a&&b.reverse();d--;){var f=b[d];if("function"!=typeof f)throw new cf("Expected a function");if(e&&!g&&"wrapper"==sd(f))var g=new Ea([],!0)}for(d=g?d:c;++d<c;)var f=b[d],e=sd(f),h="wrapper"==e?og(f):P,g=h&&Gd(h[0])&&424==h[1]&&!h[4].length&&1==h[9]?g[sd(h[0])].apply(g,h[3]):1==f.length&&Gd(f)?g[e]():g.thru(f);return function(){var a=arguments,d=a[0];if(g&&1==a.length&&hh(d))return g.plant(d).value();for(var e=0,a=c?b[e].apply(this,a):d;++e<c;)a=b[e].call(this,a);return a}})}function $c(a,b,c,d,e,f,g,h,i,j){function k(){for(var r=arguments.length,s=We(r),t=r;t--;)s[t]=arguments[t];if(o){var u,v=td(k),t=s.length;for(u=0;t--;)s[t]===v&&++u}if(d&&(s=Jc(s,d,e,o)),f&&(s=Kc(s,f,g,o)),r-=u,o&&r<j)return v=K(s,v),gd(a,b,$c,k.placeholder,c,s,v,h,i,j-r);if(v=m?c:this,t=n?v[a]:a,r=s.length,h){u=s.length;for(var w=Mf(h.length,u),x=Lc(s);w--;){var y=h[w];s[w]=Dd(y,u)?x[y]:P}}else p&&1<r&&s.reverse();return l&&i<r&&(s.length=i),this&&this!==Ra&&this instanceof k&&(t=q||Wc(t)),t.apply(v,s)}var l=128&b,m=1&b,n=2&b,o=24&b,p=512&b,q=n?P:Wc(a);return k}function _c(a,b){return function(c,d){return Jb(c,a,b(d))}}function ad(a,b){return function(c,d){var e;if(c===P&&d===P)return b;if(c!==P&&(e=c),d!==P){if(e===P)return d;"string"==typeof c||"string"==typeof d?(c=uc(c),d=uc(d)):(c=tc(c),d=tc(d)),e=a(c,d)}return e}}function bd(a){return pd(function(b){return b=k(b,C(ud())),jc(function(d){var e=this;return a(b,function(a){return c(a,e,d)})})})}function cd(a,b){b=b===P?" ":uc(b);var c=b.length;return 2>c?c?ic(b,a):b:(c=ic(b,Ef(a/N(b))),Ga.test(b)?Ec(O(c),0,a).join(""):c.slice(0,a))}function dd(a,b,d,e){function f(){for(var b=-1,i=arguments.length,j=-1,k=e.length,l=We(k+i),m=this&&this!==Ra&&this instanceof f?h:a;++j<k;)l[j]=e[j];for(;i--;)l[j++]=arguments[++b];return c(m,g?d:this,l)}var g=1&b,h=Wc(a);return f}function ed(a){return function(b,c,d){d&&"number"!=typeof d&&Ed(b,c,d)&&(c=d=P),b=ze(b),c===P?(c=b,b=0):c=ze(c),d=d===P?b<c?1:-1:ze(d);var e=-1;c=Lf(Ef((c-b)/(d||1)),0);for(var f=We(c);c--;)f[a?c:++e]=b,b+=d;return f}}function fd(a){return function(b,c){return"string"==typeof b&&"string"==typeof c||(b=Ce(b),c=Ce(c)),a(b,c)}}function gd(a,b,c,d,e,f,g,h,i,j){var k=8&b,l=k?g:P;g=k?P:g;var m=k?f:P;return f=k?P:f,b=(b|(k?32:64))&~(k?64:32),4&b||(b&=-4),e=[a,b,e,m,l,f,g,h,i,j],c=c.apply(P,e),Gd(a)&&tg(c,e),c.placeholder=d,Kd(c,a,b)}function hd(a){var b=$e[a];return function(a,c){if(a=Ce(a),c=null==c?0:Mf(Ae(c),292)){var d=(Ee(a)+"e").split("e"),d=b(d[0]+"e"+(+d[1]+c)),d=(Ee(d)+"e").split("e");return+(d[0]+"e"+(+d[1]-c))}return b(a)}}function id(a){return function(b){var c=rg(b);return"[object Map]"==c?I(b):"[object Set]"==c?M(b):B(b,a(b))}}function jd(a,b,c,d,e,f,g,h){var i=2&b;if(!i&&"function"!=typeof a)throw new cf("Expected a function");var j=d?d.length:0;if(j||(b&=-97,d=e=P),g=g===P?g:Lf(Ae(g),0),h=h===P?h:Ae(h),j-=e?e.length:0,64&b){var k=d,l=e;d=e=P}var m=i?P:og(a);return f=[a,b,c,d,e,k,l,f,g,h],m&&(c=f[1],a=m[1],b=c|a,d=128==a&&8==c||128==a&&256==c&&f[7].length<=m[8]||384==a&&m[7].length<=m[8]&&8==c,131>b||d)&&(1&a&&(f[2]=m[2],b|=1&c?0:4),(c=m[3])&&(d=f[3],f[3]=d?Jc(d,c,m[4]):c,f[4]=d?K(f[3],"__lodash_placeholder__"):m[4]),(c=m[5])&&(d=f[5],f[5]=d?Kc(d,c,m[6]):c,f[6]=d?K(f[5],"__lodash_placeholder__"):m[6]),(c=m[7])&&(f[7]=c),128&a&&(f[8]=null==f[8]?m[8]:Mf(f[8],m[8])),null==f[9]&&(f[9]=m[9]),f[0]=m[0],f[1]=b),a=f[0],b=f[1],c=f[2],d=f[3],e=f[4],h=f[9]=f[9]===P?i?0:a.length:Lf(f[9]-j,0),!h&&24&b&&(b&=-25),Kd((m?kg:tg)(b&&1!=b?8==b||16==b?Xc(a,b,h):32!=b&&33!=b||e.length?$c.apply(P,f):dd(a,b,c,d):Tc(a,b,c),f),a,b)}function kd(a,b,c,d){return a===P||le(a,ef[c])&&!hf.call(d,c)?b:a}function ld(a,b,c,d,e,f){return se(a)&&se(b)&&(f.set(b,a),_b(a,b,P,ld,f),f.delete(b)),a}function md(a){return ve(a)?P:a}function nd(a,b,c,d,e,f){var g=1&c,h=a.length,i=b.length;if(h!=i&&!(g&&i>h))return!1;if((i=f.get(a))&&f.get(b))return i==b;var i=-1,j=!0,k=2&c?new Sa:P;for(f.set(a,b),f.set(b,a);++i<h;){var l=a[i],m=b[i];if(d)var n=g?d(m,l,i,b,a,f):d(l,m,i,a,b,f);if(n!==P){if(n)continue;j=!1;break}if(k){if(!o(b,function(a,b){if(!E(k,b)&&(l===a||e(l,a,c,d,f)))return k.push(b)})){j=!1;break}}else if(l!==m&&!e(l,m,c,d,f)){j=!1;break}}return f.delete(a),f.delete(b),j}function od(a,b,c,d,e,f,g){switch(c){case"[object DataView]":if(a.byteLength!=b.byteLength||a.byteOffset!=b.byteOffset)break;a=a.buffer,b=b.buffer;case"[object ArrayBuffer]":if(a.byteLength!=b.byteLength||!f(new rf(a),new rf(b)))break;return!0;case"[object Boolean]":case"[object Date]":case"[object Number]":return le(+a,+b);case"[object Error]":return a.name==b.name&&a.message==b.message;case"[object RegExp]":case"[object String]":return a==b+"";case"[object Map]":var h=I;case"[object Set]":if(h||(h=L),a.size!=b.size&&!(1&d))break;return(c=g.get(a))?c==b:(d|=2,g.set(a,b),b=nd(h(a),h(b),d,e,f,g),g.delete(a),b);case"[object Symbol]":if(dg)return dg.call(a)==dg.call(b)}return!1}function pd(a){return vg(Jd(a,P,Td),a+"")}function qd(a){return Db(a,He,pg)}function rd(a){return Db(a,Ie,qg)}function sd(a){for(var b=a.name+"",c=Yf[b],d=hf.call(Yf,b)?c.length:0;d--;){var e=c[d],f=e.func;if(null==f||f==a)return e.name}return b}function td(a){return(hf.call(Aa,"placeholder")?Aa:a).placeholder}function ud(){var a=Aa.iteratee||Qe,a=a===Qe?Vb:a;return arguments.length?a(arguments[0],arguments[1]):a}function vd(a,b){var c=a.__data__,d=typeof b;return("string"==d||"number"==d||"symbol"==d||"boolean"==d?"__proto__"!==b:null===b)?c["string"==typeof b?"string":"hash"]:c.map}function wd(a){for(var b=He(a),c=b.length;c--;){var d=b[c],e=a[d];b[c]=[d,e,e===e&&!se(e)]}return b}function xd(a,b){var c=null==a?P:a[b];return Rb(c)?c:P}function yd(a,b,c){b=Dc(b,a);for(var d=-1,e=b.length,f=!1;++d<e;){var g=Nd(b[d]);if(!(f=null!=a&&c(a,g)))break;a=a[g]}return f||++d!=e?f:!!(e=null==a?0:a.length)&&re(e)&&Dd(g,e)&&(hh(a)||gh(a))}function zd(a){var b=a.length,c=a.constructor(b);return b&&"string"==typeof a[0]&&hf.call(a,"index")&&(c.index=a.index,c.input=a.input),c}function Ad(a){return"function"!=typeof a.constructor||Hd(a)?{}:fg(tf(a))}function Bd(c,d,e,f){var g=c.constructor;switch(d){case"[object ArrayBuffer]":return Gc(c);case"[object Boolean]":case"[object Date]":return new g(+c);case"[object DataView]":return d=f?Gc(c.buffer):c.buffer,new c.constructor(d,c.byteOffset,c.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return Hc(c,f);case"[object Map]":return d=f?e(I(c),1):I(c),m(d,a,new c.constructor);case"[object Number]":case"[object String]":return new g(c);case"[object RegExp]":return d=new c.constructor(c.source,qa.exec(c)),d.lastIndex=c.lastIndex,d;case"[object Set]":return d=f?e(L(c),1):L(c),m(d,b,new c.constructor);case"[object Symbol]":return dg?_e(dg.call(c)):{}}}function Cd(a){return hh(a)||gh(a)||!!(xf&&a&&a[xf])}function Dd(a,b){return!!(b=null==b?9007199254740991:b)&&("number"==typeof a||va.test(a))&&-1<a&&0==a%1&&a<b}function Ed(a,b,c){if(!se(c))return!1;var d=typeof b;return!!("number"==d?me(c)&&Dd(b,c.length):"string"==d&&b in c)&&le(c[b],a)}function Fd(a,b){if(hh(a))return!1;var c=typeof a;return!("number"!=c&&"symbol"!=c&&"boolean"!=c&&null!=a&&!xe(a))||ca.test(a)||!ba.test(a)||null!=b&&a in _e(b)}function Gd(a){var b=sd(a),c=Aa[b];return"function"==typeof c&&b in La.prototype&&(a===c||!!(b=og(c))&&a===b[0])}function Hd(a){var b=a&&a.constructor;return a===("function"==typeof b&&b.prototype||ef)}function Id(a,b){return function(c){return null!=c&&c[a]===b&&(b!==P||a in _e(c))}}function Jd(a,b,d){return b=Lf(b===P?a.length-1:b,0),function(){for(var e=arguments,f=-1,g=Lf(e.length-b,0),h=We(g);++f<g;)h[f]=e[b+f];for(f=-1,g=We(b+1);++f<b;)g[f]=e[f];return g[b]=d(h),c(a,this,g)}}function Kd(a,b,c){var d=b+"";b=vg;var e,f=Pd;return e=(e=d.match(la))?e[1].split(ma):[],c=f(e,c),(f=c.length)&&(e=f-1,c[e]=(1<f?"& ":"")+c[e],c=c.join(2<f?", ":" "),d=d.replace(ka,"{\n/* [wrapped with "+c+"] */\n")),b(a,d)}function Ld(a){var b=0,c=0;return function(){var d=Nf(),e=16-(d-c);if(c=d,0<e){if(800<=++b)return arguments[0]}else b=0;return a.apply(P,arguments)}}function Md(a,b){var c=-1,d=a.length,e=d-1;for(b=b===P?d:b;++c<b;){var d=hc(c,e),f=a[d];a[d]=a[c],a[c]=f}return a.length=b,a}function Nd(a){if("string"==typeof a||xe(a))return a;var b=a+"";return"0"==b&&1/a==-Q?"-0":b}function Od(a){if(null!=a){try{return gf.call(a)}catch(a){}return a+""}return""}function Pd(a,b){return e(S,function(c){var d="_."+c[0];b&c[1]&&!i(a,d)&&a.push(d)}),a.sort()}function Qd(a){if(a instanceof La)return a.clone();var b=new Ea(a.__wrapped__,a.__chain__);return b.__actions__=Lc(a.__actions__),b.__index__=a.__index__,b.__values__=a.__values__,b}function Rd(a,b,c){var d=null==a?0:a.length;return d?(c=null==c?0:Ae(c),0>c&&(c=Lf(d+c,0)),q(a,ud(b,3),c)):-1}function Sd(a,b,c){var d=null==a?0:a.length;if(!d)return-1;var e=d-1;return c!==P&&(e=Ae(c),e=0>c?Lf(d+e,0):Mf(e,d-1)),q(a,ud(b,3),e,!0)}function Td(a){return(null==a?0:a.length)?yb(a,1):[]}function Ud(a){return a&&a.length?a[0]:P}function Vd(a){var b=null==a?0:a.length;return b?a[b-1]:P}function Wd(a,b){return a&&a.length&&b&&b.length?fc(a,b):a}function Xd(a){return null==a?a:Qf.call(a)}function Yd(a){if(!a||!a.length)return[];var b=0;return a=h(a,function(a){if(ne(a))return b=Lf(a.length,b),!0}),A(b,function(b){return k(a,v(b))})}function Zd(a,b){if(!a||!a.length)return[];var d=Yd(a);return null==b?d:k(d,function(a){return c(b,P,a)})}function $d(a){return a=Aa(a),a.__chain__=!0,a}function _d(a,b){return b(a)}function ae(){return this}function be(a,b){return(hh(a)?e:gg)(a,ud(b,3))}function ce(a,b){return(hh(a)?f:hg)(a,ud(b,3))}function de(a,b){return(hh(a)?k:Yb)(a,ud(b,3))}function ee(a,b,c){return b=c?P:b,b=a&&null==b?a.length:b,jd(a,128,P,P,P,P,b)}function fe(a,b){var c;if("function"!=typeof b)throw new cf("Expected a function");return a=Ae(a),function(){return 0<--a&&(c=b.apply(this,arguments)),1>=a&&(b=P),c}}function ge(a,b,c){return b=c?P:b,a=jd(a,8,P,P,P,P,P,b),a.placeholder=ge.placeholder,a}function he(a,b,c){return b=c?P:b,a=jd(a,16,P,P,P,P,P,b),a.placeholder=he.placeholder,a}function ie(a,b,c){function d(b){var c=i,d=j;return i=j=P,o=b,l=a.apply(d,c)}function e(a){var c=a-n;return a-=o,n===P||c>=b||0>c||q&&a>=k}function f(){var a=Xg();if(e(a))return g(a);var c,d=ug;c=a-o,a=b-(a-n),c=q?Mf(a,k-c):a,m=d(f,c)}function g(a){return m=P,r&&i?d(a):(i=j=P,l)}function h(){var a=Xg(),c=e(a);if(i=arguments,j=this,n=a,c){if(m===P)return o=a=n,m=ug(f,b),p?d(a):l;if(q)return m=ug(f,b),d(n)}return m===P&&(m=ug(f,b)),l}var i,j,k,l,m,n,o=0,p=!1,q=!1,r=!0;if("function"!=typeof a)throw new cf("Expected a function");return b=Ce(b)||0,se(c)&&(p=!!c.leading,k=(q="maxWait"in c)?Lf(Ce(c.maxWait)||0,b):k,r="trailing"in c?!!c.trailing:r),h.cancel=function(){m!==P&&mg(m),o=0,i=n=j=m=P},h.flush=function(){return m===P?l:g(Xg())},h}function je(a,b){function c(){var d=arguments,e=b?b.apply(this,d):d[0],f=c.cache;return f.has(e)?f.get(e):(d=a.apply(this,d),c.cache=f.set(e,d)||f,d)}if("function"!=typeof a||null!=b&&"function"!=typeof b)throw new cf("Expected a function");return c.cache=new(je.Cache||Qa),c}function ke(a){if("function"!=typeof a)throw new cf("Expected a function");return function(){var b=arguments;switch(b.length){case 0:return!a.call(this);case 1:return!a.call(this,b[0]);case 2:return!a.call(this,b[0],b[1]);case 3:return!a.call(this,b[0],b[1],b[2])}return!a.apply(this,b)}}function le(a,b){return a===b||a!==a&&b!==b}function me(a){return null!=a&&re(a.length)&&!pe(a)}function ne(a){return te(a)&&me(a)}function oe(a){if(!te(a))return!1;var b=Eb(a);return"[object Error]"==b||"[object DOMException]"==b||"string"==typeof a.message&&"string"==typeof a.name&&!ve(a)}function pe(a){return!!se(a)&&("[object Function]"==(a=Eb(a))||"[object GeneratorFunction]"==a||"[object AsyncFunction]"==a||"[object Proxy]"==a)}function qe(a){return"number"==typeof a&&a==Ae(a)}function re(a){return"number"==typeof a&&-1<a&&0==a%1&&9007199254740991>=a}function se(a){var b=typeof a;return null!=a&&("object"==b||"function"==b)}function te(a){return null!=a&&"object"==typeof a}function ue(a){return"number"==typeof a||te(a)&&"[object Number]"==Eb(a)}function ve(a){return!(!te(a)||"[object Object]"!=Eb(a))&&(null===(a=tf(a))||"function"==typeof(a=hf.call(a,"constructor")&&a.constructor)&&a instanceof a&&gf.call(a)==mf)}function we(a){return"string"==typeof a||!hh(a)&&te(a)&&"[object String]"==Eb(a)}function xe(a){return"symbol"==typeof a||te(a)&&"[object Symbol]"==Eb(a)}function ye(a){if(!a)return[];if(me(a))return we(a)?O(a):Lc(a);if(yf&&a[yf]){a=a[yf]();for(var b,c=[];!(b=a.next()).done;)c.push(b.value);return c}return b=rg(a),("[object Map]"==b?I:"[object Set]"==b?L:Ke)(a)}function ze(a){return a?(a=Ce(a),a===Q||a===-Q?1.7976931348623157e308*(0>a?-1:1):a===a?a:0):0===a?a:0}function Ae(a){a=ze(a);var b=a%1;return a===a?b?a-b:a:0}function Be(a){return a?pb(Ae(a),0,4294967295):0}function Ce(a){if("number"==typeof a)return a;if(xe(a))return R;if(se(a)&&(a="function"==typeof a.valueOf?a.valueOf():a,a=se(a)?a+"":a),"string"!=typeof a)return 0===a?a:+a;a=a.replace(ha,"");var b=sa.test(a);return b||ua.test(a)?Oa(a.slice(2),b?2:8):ra.test(a)?R:+a}function De(a){return Mc(a,Ie(a))}function Ee(a){return null==a?"":uc(a)}function Fe(a,b,c){return a=null==a?P:Cb(a,b),a===P?c:a}function Ge(a,b){return null!=a&&yd(a,b,Hb)}function He(a){return me(a)?Va(a):Wb(a)}function Ie(a){if(me(a))a=Va(a,!0);else if(se(a)){var b,c=Hd(a),d=[];for(b in a)("constructor"!=b||!c&&hf.call(a,b))&&d.push(b);a=d}else{if(b=[],null!=a)for(c in _e(a))b.push(c);a=b}return a}function Je(a,b){if(null==a)return{};var c=k(rd(a),function(a){return[a]});return b=ud(b),dc(a,c,function(a,c){return b(a,c[0])})}function Ke(a){return null==a?[]:D(a,He(a))}function Le(a){return Oh(Ee(a).toLowerCase())}function Me(a){return(a=Ee(a))&&a.replace(wa,bb).replace(Da,"")}function Ne(a,b,c){return a=Ee(a),b=c?P:b,b===P?Ha.test(a)?a.match(Fa)||[]:a.match(na)||[]:a.match(b)||[]}function Oe(a){return function(){return a}}function Pe(a){return a}function Qe(a){return Vb("function"==typeof a?a:qb(a,1))}function Re(a,b,c){var d=He(b),f=Bb(b,d);null!=c||se(b)&&(f.length||!d.length)||(c=b,b=a,a=this,f=Bb(b,He(b)));var g=!(se(c)&&"chain"in c&&!c.chain),h=pe(a);return e(f,function(c){var d=b[c];a[c]=d,h&&(a.prototype[c]=function(){var b=this.__chain__;if(g||b){var c=a(this.__wrapped__);return(c.__actions__=Lc(this.__actions__)).push({func:d,args:arguments,thisArg:a}),c.__chain__=b,c}return d.apply(a,l([this.value()],arguments))})}),a}function Se(){}function Te(a){return Fd(a)?v(Nd(a)):ec(a)}function Ue(){return[]}function Ve(){return!1}za=null==za?Ra:eb.defaults(Ra.Object(),za,eb.pick(Ra,Ia));var We=za.Array,Xe=za.Date,Ye=za.Error,Ze=za.Function,$e=za.Math,_e=za.Object,af=za.RegExp,bf=za.String,cf=za.TypeError,df=We.prototype,ef=_e.prototype,ff=za["__core-js_shared__"],gf=Ze.prototype.toString,hf=ef.hasOwnProperty,jf=0,kf=function(){var a=/[^.]+$/.exec(ff&&ff.keys&&ff.keys.IE_PROTO||"");return a?"Symbol(src)_1."+a:""}(),lf=ef.toString,mf=gf.call(_e),nf=Ra._,of=af("^"+gf.call(hf).replace(fa,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),pf=Ua?za.Buffer:P,qf=za.Symbol,rf=za.Uint8Array,sf=pf?pf.f:P,tf=J(_e.getPrototypeOf,_e),uf=_e.create,vf=ef.propertyIsEnumerable,wf=df.splice,xf=qf?qf.isConcatSpreadable:P,yf=qf?qf.iterator:P,zf=qf?qf.toStringTag:P,Af=function(){try{var a=xd(_e,"defineProperty");return a({},"",{}),a}catch(a){}}(),Bf=za.clearTimeout!==Ra.clearTimeout&&za.clearTimeout,Cf=Xe&&Xe.now!==Ra.Date.now&&Xe.now,Df=za.setTimeout!==Ra.setTimeout&&za.setTimeout,Ef=$e.ceil,Ff=$e.floor,Gf=_e.getOwnPropertySymbols,Hf=pf?pf.isBuffer:P,If=za.isFinite,Jf=df.join,Kf=J(_e.keys,_e),Lf=$e.max,Mf=$e.min,Nf=Xe.now,Of=za.parseInt,Pf=$e.random,Qf=df.reverse,Rf=xd(za,"DataView"),Sf=xd(za,"Map"),Tf=xd(za,"Promise"),Uf=xd(za,"Set"),Vf=xd(za,"WeakMap"),Wf=xd(_e,"create"),Xf=Vf&&new Vf,Yf={},Zf=Od(Rf),$f=Od(Sf),_f=Od(Tf),ag=Od(Uf),bg=Od(Vf),cg=qf?qf.prototype:P,dg=cg?cg.valueOf:P,eg=cg?cg.toString:P,fg=function(){function a(){}return function(b){return se(b)?uf?uf(b):(a.prototype=b,b=new a,a.prototype=P,b):{}}}();Aa.templateSettings={escape:$,evaluate:_,interpolate:aa,variable:"",imports:{_:Aa}},Aa.prototype=Ba.prototype,Aa.prototype.constructor=Aa,Ea.prototype=fg(Ba.prototype),Ea.prototype.constructor=Ea,La.prototype=fg(Ba.prototype),La.prototype.constructor=La,Ma.prototype.clear=function(){this.__data__=Wf?Wf(null):{},this.size=0},Ma.prototype.delete=function(a){return a=this.has(a)&&delete this.__data__[a],this.size-=a?1:0,a},Ma.prototype.get=function(a){var b=this.__data__;return Wf?(a=b[a],"__lodash_hash_undefined__"===a?P:a):hf.call(b,a)?b[a]:P},Ma.prototype.has=function(a){var b=this.__data__;return Wf?b[a]!==P:hf.call(b,a)},Ma.prototype.set=function(a,b){var c=this.__data__;return this.size+=this.has(a)?0:1,c[a]=Wf&&b===P?"__lodash_hash_undefined__":b,this},Pa.prototype.clear=function(){this.__data__=[],this.size=0},Pa.prototype.delete=function(a){var b=this.__data__;return!(0>(a=jb(b,a))||(a==b.length-1?b.pop():wf.call(b,a,1),--this.size,0))},Pa.prototype.get=function(a){var b=this.__data__;return a=jb(b,a),0>a?P:b[a][1]},Pa.prototype.has=function(a){return-1<jb(this.__data__,a)},Pa.prototype.set=function(a,b){var c=this.__data__,d=jb(c,a);return 0>d?(++this.size,c.push([a,b])):c[d][1]=b,this},Qa.prototype.clear=function(){this.size=0,this.__data__={hash:new Ma,map:new(Sf||Pa),string:new Ma}},Qa.prototype.delete=function(a){return a=vd(this,a).delete(a),this.size-=a?1:0,a},Qa.prototype.get=function(a){return vd(this,a).get(a)},Qa.prototype.has=function(a){return vd(this,a).has(a)},Qa.prototype.set=function(a,b){var c=vd(this,a),d=c.size;return c.set(a,b),this.size+=c.size==d?0:1,this},Sa.prototype.add=Sa.prototype.push=function(a){return this.__data__.set(a,"__lodash_hash_undefined__"),this},Sa.prototype.has=function(a){return this.__data__.has(a)},Ta.prototype.clear=function(){this.__data__=new Pa,this.size=0},Ta.prototype.delete=function(a){var b=this.__data__;return a=b.delete(a),this.size=b.size,a},Ta.prototype.get=function(a){return this.__data__.get(a)},Ta.prototype.has=function(a){return this.__data__.has(a)},Ta.prototype.set=function(a,b){var c=this.__data__;if(c instanceof Pa){var d=c.__data__;if(!Sf||199>d.length)return d.push([a,b]),this.size=++c.size,this;c=this.__data__=new Qa(d)}return c.set(a,b),this.size=c.size,this};var gg=Rc(zb),hg=Rc(Ab,!0),ig=Sc(),jg=Sc(!0),kg=Xf?function(a,b){return Xf.set(a,b),a}:Pe,lg=Af?function(a,b){return Af(a,"toString",{configurable:!0,enumerable:!1,value:Oe(b),writable:!0})}:Pe,mg=Bf||function(a){return Ra.clearTimeout(a)},ng=Uf&&1/L(new Uf([,-0]))[1]==Q?function(a){return new Uf(a)}:Se,og=Xf?function(a){return Xf.get(a)}:Se,pg=Gf?function(a){return null==a?[]:(a=_e(a),h(Gf(a),function(b){return vf.call(a,b)}))}:Ue,qg=Gf?function(a){for(var b=[];a;)l(b,pg(a)),a=tf(a);return b}:Ue,rg=Eb;(Rf&&"[object DataView]"!=rg(new Rf(new ArrayBuffer(1)))||Sf&&"[object Map]"!=rg(new Sf)||Tf&&"[object Promise]"!=rg(Tf.resolve())||Uf&&"[object Set]"!=rg(new Uf)||Vf&&"[object WeakMap]"!=rg(new Vf))&&(rg=function(a){var b=Eb(a);if(a=(a="[object Object]"==b?a.constructor:P)?Od(a):"")switch(a){case Zf:return"[object DataView]";case $f:return"[object Map]";case _f:return"[object Promise]";case ag:return"[object Set]";case bg:return"[object WeakMap]"}return b});var sg=ff?pe:Ve,tg=Ld(kg),ug=Df||function(a,b){return Ra.setTimeout(a,b)},vg=Ld(lg),wg=function(a){a=je(a,function(a){return 500===b.size&&b.clear(),a});var b=a.cache;return a}(function(a){var b=[];return da.test(a)&&b.push(""),a.replace(ea,function(a,c,d,e){b.push(d?e.replace(oa,"$1"):c||a)}),b}),xg=jc(function(a,b){return ne(a)?ub(a,yb(b,1,ne,!0)):[]}),yg=jc(function(a,b){var c=Vd(b);return ne(c)&&(c=P),ne(a)?ub(a,yb(b,1,ne,!0),ud(c,2)):[]}),zg=jc(function(a,b){var c=Vd(b);return ne(c)&&(c=P),ne(a)?ub(a,yb(b,1,ne,!0),P,c):[]}),Ag=jc(function(a){var b=k(a,Bc);return b.length&&b[0]===a[0]?Ib(b):[]}),Bg=jc(function(a){var b=Vd(a),c=k(a,Bc);return b===Vd(c)?b=P:c.pop(),c.length&&c[0]===a[0]?Ib(c,ud(b,2)):[]}),Cg=jc(function(a){var b=Vd(a),c=k(a,Bc);return(b="function"==typeof b?b:P)&&c.pop(),c.length&&c[0]===a[0]?Ib(c,P,b):[]}),Dg=jc(Wd),Eg=pd(function(a,b){var c=null==a?0:a.length,d=ob(a,b);return gc(a,k(b,function(a){return Dd(a,c)?+a:a}).sort(Ic)),d}),Fg=jc(function(a){return vc(yb(a,1,ne,!0))}),Gg=jc(function(a){var b=Vd(a);return ne(b)&&(b=P),vc(yb(a,1,ne,!0),ud(b,2))}),Hg=jc(function(a){var b=Vd(a),b="function"==typeof b?b:P;return vc(yb(a,1,ne,!0),P,b)}),Ig=jc(function(a,b){return ne(a)?ub(a,b):[]}),Jg=jc(function(a){return zc(h(a,ne))}),Kg=jc(function(a){var b=Vd(a);return ne(b)&&(b=P),zc(h(a,ne),ud(b,2))}),Lg=jc(function(a){var b=Vd(a),b="function"==typeof b?b:P;return zc(h(a,ne),P,b)}),Mg=jc(Yd),Ng=jc(function(a){var b=a.length,b=1<b?a[b-1]:P,b="function"==typeof b?(a.pop(),b):P;return Zd(a,b)}),Og=pd(function(a){function b(b){return ob(b,a)}var c=a.length,d=c?a[0]:0,e=this.__wrapped__;return!(1<c||this.__actions__.length)&&e instanceof La&&Dd(d)?(e=e.slice(d,+d+(c?1:0)),e.__actions__.push({func:_d,args:[b],thisArg:P}),new Ea(e,this.__chain__).thru(function(a){return c&&!a.length&&a.push(P),a})):this.thru(b)}),Pg=Pc(function(a,b,c){hf.call(a,c)?++a[c]:nb(a,c,1)}),Qg=Yc(Rd),Rg=Yc(Sd),Sg=Pc(function(a,b,c){hf.call(a,c)?a[c].push(b):nb(a,c,[b])}),Tg=jc(function(a,b,d){var e=-1,f="function"==typeof b,g=me(a)?We(a.length):[];return gg(a,function(a){g[++e]=f?c(b,a,d):Kb(a,b,d)}),g}),Ug=Pc(function(a,b,c){nb(a,c,b)}),Vg=Pc(function(a,b,c){a[c?0:1].push(b)},function(){return[[],[]]}),Wg=jc(function(a,b){if(null==a)return[];var c=b.length;return 1<c&&Ed(a,b[0],b[1])?b=[]:2<c&&Ed(b[0],b[1],b[2])&&(b=[b[0]]),bc(a,yb(b,1),[])}),Xg=Cf||function(){return Ra.Date.now()},Yg=jc(function(a,b,c){var d=1;if(c.length)var e=K(c,td(Yg)),d=32|d;return jd(a,d,b,c,e)}),Zg=jc(function(a,b,c){var d=3;if(c.length)var e=K(c,td(Zg)),d=32|d;return jd(b,d,a,c,e)}),$g=jc(function(a,b){return tb(a,1,b)}),_g=jc(function(a,b,c){return tb(a,Ce(b)||0,c)});je.Cache=Qa;var ah=jc(function(a,b){b=1==b.length&&hh(b[0])?k(b[0],C(ud())):k(yb(b,1),C(ud()));var d=b.length;return jc(function(e){for(var f=-1,g=Mf(e.length,d);++f<g;)e[f]=b[f].call(this,e[f]);return c(a,this,e)})}),bh=jc(function(a,b){return jd(a,32,P,b,K(b,td(bh)))}),ch=jc(function(a,b){return jd(a,64,P,b,K(b,td(ch)))}),dh=pd(function(a,b){return jd(a,256,P,P,P,b)}),eh=fd(Fb),fh=fd(function(a,b){return a>=b}),gh=Lb(function(){return arguments}())?Lb:function(a){return te(a)&&hf.call(a,"callee")&&!vf.call(a,"callee")},hh=We.isArray,ih=Wa?C(Wa):Mb,jh=Hf||Ve,kh=Xa?C(Xa):Nb,lh=Ya?C(Ya):Pb,mh=Za?C(Za):Sb,nh=$a?C($a):Tb,oh=_a?C(_a):Ub,ph=fd(Xb),qh=fd(function(a,b){return a<=b}),rh=Qc(function(a,b){if(Hd(b)||me(b))Mc(b,He(b),a);else for(var c in b)hf.call(b,c)&&ib(a,c,b[c])}),sh=Qc(function(a,b){Mc(b,Ie(b),a)}),th=Qc(function(a,b,c,d){Mc(b,Ie(b),a,d)}),uh=Qc(function(a,b,c,d){Mc(b,He(b),a,d)}),vh=pd(ob),wh=jc(function(a){return a.push(P,kd),c(th,P,a)}),xh=jc(function(a){return a.push(P,ld),c(Ch,P,a)}),yh=_c(function(a,b,c){a[b]=c},Oe(Pe)),zh=_c(function(a,b,c){hf.call(a,b)?a[b].push(c):a[b]=[c]},ud),Ah=jc(Kb),Bh=Qc(function(a,b,c){_b(a,b,c)}),Ch=Qc(function(a,b,c,d){_b(a,b,c,d)}),Dh=pd(function(a,b){var c={};if(null==a)return c;var d=!1;b=k(b,function(b){return b=Dc(b,a),d||(d=1<b.length),b}),Mc(a,rd(a),c),d&&(c=qb(c,7,md));for(var e=b.length;e--;)wc(c,b[e]);return c}),Eh=pd(function(a,b){return null==a?{}:cc(a,b)}),Fh=id(He),Gh=id(Ie),Hh=Vc(function(a,b,c){return b=b.toLowerCase(),a+(c?Le(b):b)}),Ih=Vc(function(a,b,c){return a+(c?"-":"")+b.toLowerCase()}),Jh=Vc(function(a,b,c){return a+(c?" ":"")+b.toLowerCase()}),Kh=Uc("toLowerCase"),Lh=Vc(function(a,b,c){return a+(c?"_":"")+b.toLowerCase()}),Mh=Vc(function(a,b,c){return a+(c?" ":"")+Oh(b)}),Nh=Vc(function(a,b,c){return a+(c?" ":"")+b.toUpperCase()}),Oh=Uc("toUpperCase"),Ph=jc(function(a,b){try{return c(a,P,b)}catch(a){return oe(a)?a:new Ye(a)}}),Qh=pd(function(a,b){return e(b,function(b){b=Nd(b),nb(a,b,Yg(a[b],a))}),a}),Rh=Zc(),Sh=Zc(!0),Th=jc(function(a,b){return function(c){return Kb(c,a,b)}}),Uh=jc(function(a,b){return function(c){return Kb(a,c,b)}}),Vh=bd(k),Wh=bd(g),Xh=bd(o),Yh=ed(),Zh=ed(!0),$h=ad(function(a,b){return a+b},0),_h=hd("ceil"),ai=ad(function(a,b){return a/b},1),bi=hd("floor"),ci=ad(function(a,b){return a*b},1),di=hd("round"),ei=ad(function(a,b){return a-b},0);return Aa.after=function(a,b){if("function"!=typeof b)throw new cf("Expected a function");return a=Ae(a),function(){if(1>--a)return b.apply(this,arguments)}},Aa.ary=ee,Aa.assign=rh,Aa.assignIn=sh,Aa.assignInWith=th,Aa.assignWith=uh,Aa.at=vh,Aa.before=fe,Aa.bind=Yg,Aa.bindAll=Qh,Aa.bindKey=Zg,Aa.castArray=function(){if(!arguments.length)return[];var a=arguments[0];return hh(a)?a:[a]},Aa.chain=$d,Aa.chunk=function(a,b,c){if(b=(c?Ed(a,b,c):b===P)?1:Lf(Ae(b),0),!(c=null==a?0:a.length)||1>b)return[];for(var d=0,e=0,f=We(Ef(c/b));d<c;)f[e++]=oc(a,d,d+=b);return f},Aa.compact=function(a){for(var b=-1,c=null==a?0:a.length,d=0,e=[];++b<c;){var f=a[b];f&&(e[d++]=f)}return e},Aa.concat=function(){var a=arguments.length;if(!a)return[];for(var b=We(a-1),c=arguments[0];a--;)b[a-1]=arguments[a];return l(hh(c)?Lc(c):[c],yb(b,1))},Aa.cond=function(a){var b=null==a?0:a.length,d=ud();return a=b?k(a,function(a){if("function"!=typeof a[1])throw new cf("Expected a function");return[d(a[0]),a[1]]}):[],jc(function(d){for(var e=-1;++e<b;){var f=a[e];if(c(f[0],this,d))return c(f[1],this,d)}})},Aa.conforms=function(a){return rb(qb(a,1))},Aa.constant=Oe,Aa.countBy=Pg,Aa.create=function(a,b){var c=fg(a);return null==b?c:lb(c,b)},Aa.curry=ge,Aa.curryRight=he,Aa.debounce=ie,Aa.defaults=wh,Aa.defaultsDeep=xh,Aa.defer=$g,Aa.delay=_g,Aa.difference=xg,Aa.differenceBy=yg,Aa.differenceWith=zg,Aa.drop=function(a,b,c){var d=null==a?0:a.length;return d?(b=c||b===P?1:Ae(b),oc(a,0>b?0:b,d)):[]},Aa.dropRight=function(a,b,c){var d=null==a?0:a.length;return d?(b=c||b===P?1:Ae(b),b=d-b,oc(a,0,0>b?0:b)):[]},Aa.dropRightWhile=function(a,b){return a&&a.length?xc(a,ud(b,3),!0,!0):[]},Aa.dropWhile=function(a,b){return a&&a.length?xc(a,ud(b,3),!0):[]},Aa.fill=function(a,b,c,d){var e=null==a?0:a.length;if(!e)return[];for(c&&"number"!=typeof c&&Ed(a,b,c)&&(c=0,d=e),e=a.length,c=Ae(c),0>c&&(c=-c>e?0:e+c),d=d===P||d>e?e:Ae(d),0>d&&(d+=e),d=c>d?0:Be(d);c<d;)a[c++]=b;return a},Aa.filter=function(a,b){return(hh(a)?h:xb)(a,ud(b,3))},Aa.flatMap=function(a,b){return yb(de(a,b),1)},Aa.flatMapDeep=function(a,b){return yb(de(a,b),Q)},Aa.flatMapDepth=function(a,b,c){return c=c===P?1:Ae(c),yb(de(a,b),c)},Aa.flatten=Td,Aa.flattenDeep=function(a){return(null==a?0:a.length)?yb(a,Q):[]},Aa.flattenDepth=function(a,b){return null!=a&&a.length?(b=b===P?1:Ae(b),yb(a,b)):[]},Aa.flip=function(a){return jd(a,512)},Aa.flow=Rh,Aa.flowRight=Sh,Aa.fromPairs=function(a){for(var b=-1,c=null==a?0:a.length,d={};++b<c;){var e=a[b];d[e[0]]=e[1]}return d},Aa.functions=function(a){return null==a?[]:Bb(a,He(a))},Aa.functionsIn=function(a){return null==a?[]:Bb(a,Ie(a))},Aa.groupBy=Sg,Aa.initial=function(a){return(null==a?0:a.length)?oc(a,0,-1):[]},Aa.intersection=Ag,Aa.intersectionBy=Bg,Aa.intersectionWith=Cg,Aa.invert=yh,Aa.invertBy=zh,Aa.invokeMap=Tg,Aa.iteratee=Qe,Aa.keyBy=Ug,Aa.keys=He,Aa.keysIn=Ie,Aa.map=de,Aa.mapKeys=function(a,b){var c={};return b=ud(b,3),zb(a,function(a,d,e){nb(c,b(a,d,e),a)}),c},Aa.mapValues=function(a,b){var c={};return b=ud(b,3),zb(a,function(a,d,e){nb(c,d,b(a,d,e))}),c},Aa.matches=function(a){return Zb(qb(a,1))},Aa.matchesProperty=function(a,b){return $b(a,qb(b,1))},Aa.memoize=je,Aa.merge=Bh,Aa.mergeWith=Ch,Aa.method=Th,Aa.methodOf=Uh,Aa.mixin=Re,Aa.negate=ke,Aa.nthArg=function(a){return a=Ae(a),jc(function(b){return ac(b,a)})},Aa.omit=Dh,Aa.omitBy=function(a,b){return Je(a,ke(ud(b)))},Aa.once=function(a){return fe(2,a)},Aa.orderBy=function(a,b,c,d){return null==a?[]:(hh(b)||(b=null==b?[]:[b]),c=d?P:c,hh(c)||(c=null==c?[]:[c]),bc(a,b,c))},Aa.over=Vh,Aa.overArgs=ah,Aa.overEvery=Wh,Aa.overSome=Xh,Aa.partial=bh,Aa.partialRight=ch,Aa.partition=Vg,Aa.pick=Eh,Aa.pickBy=Je,Aa.property=Te,Aa.propertyOf=function(a){return function(b){return null==a?P:Cb(a,b)}},Aa.pull=Dg,Aa.pullAll=Wd,Aa.pullAllBy=function(a,b,c){return a&&a.length&&b&&b.length?fc(a,b,ud(c,2)):a},Aa.pullAllWith=function(a,b,c){return a&&a.length&&b&&b.length?fc(a,b,P,c):a},Aa.pullAt=Eg,Aa.range=Yh,Aa.rangeRight=Zh,Aa.rearg=dh,Aa.reject=function(a,b){return(hh(a)?h:xb)(a,ke(ud(b,3)))},Aa.remove=function(a,b){var c=[];if(!a||!a.length)return c;var d=-1,e=[],f=a.length;for(b=ud(b,3);++d<f;){var g=a[d];b(g,d,a)&&(c.push(g),e.push(d))}return gc(a,e),c},Aa.rest=function(a,b){if("function"!=typeof a)throw new cf("Expected a function");return b=b===P?b:Ae(b),jc(a,b)},Aa.reverse=Xd,Aa.sampleSize=function(a,b,c){return b=(c?Ed(a,b,c):b===P)?1:Ae(b),(hh(a)?fb:lc)(a,b)},Aa.set=function(a,b,c){return null==a?a:mc(a,b,c)},Aa.setWith=function(a,b,c,d){return d="function"==typeof d?d:P,null==a?a:mc(a,b,c,d)},Aa.shuffle=function(a){return(hh(a)?gb:nc)(a)},Aa.slice=function(a,b,c){var d=null==a?0:a.length;return d?(c&&"number"!=typeof c&&Ed(a,b,c)?(b=0,c=d):(b=null==b?0:Ae(b),c=c===P?d:Ae(c)),oc(a,b,c)):[]},Aa.sortBy=Wg,Aa.sortedUniq=function(a){return a&&a.length?sc(a):[]},Aa.sortedUniqBy=function(a,b){return a&&a.length?sc(a,ud(b,2)):[]},Aa.split=function(a,b,c){return c&&"number"!=typeof c&&Ed(a,b,c)&&(b=c=P),c=c===P?4294967295:c>>>0,c?(a=Ee(a))&&("string"==typeof b||null!=b&&!mh(b))&&!(b=uc(b))&&Ga.test(a)?Ec(O(a),0,c):a.split(b,c):[]},Aa.spread=function(a,b){if("function"!=typeof a)throw new cf("Expected a function");return b=null==b?0:Lf(Ae(b),0),jc(function(d){var e=d[b];return d=Ec(d,0,b),e&&l(d,e),c(a,this,d)})},Aa.tail=function(a){var b=null==a?0:a.length;return b?oc(a,1,b):[]},Aa.take=function(a,b,c){return a&&a.length?(b=c||b===P?1:Ae(b),oc(a,0,0>b?0:b)):[]},Aa.takeRight=function(a,b,c){var d=null==a?0:a.length;return d?(b=c||b===P?1:Ae(b),b=d-b,oc(a,0>b?0:b,d)):[]},Aa.takeRightWhile=function(a,b){return a&&a.length?xc(a,ud(b,3),!1,!0):[]},Aa.takeWhile=function(a,b){return a&&a.length?xc(a,ud(b,3)):[]},Aa.tap=function(a,b){return b(a),a},Aa.throttle=function(a,b,c){var d=!0,e=!0;if("function"!=typeof a)throw new cf("Expected a function");return se(c)&&(d="leading"in c?!!c.leading:d,e="trailing"in c?!!c.trailing:e),ie(a,b,{leading:d,maxWait:b,trailing:e})},Aa.thru=_d,Aa.toArray=ye,Aa.toPairs=Fh,Aa.toPairsIn=Gh,Aa.toPath=function(a){return hh(a)?k(a,Nd):xe(a)?[a]:Lc(wg(Ee(a)))},Aa.toPlainObject=De,Aa.transform=function(a,b,c){var d=hh(a),f=d||jh(a)||oh(a);if(b=ud(b,4),null==c){var g=a&&a.constructor;c=f?d?new g:[]:se(a)&&pe(g)?fg(tf(a)):{}}return(f?e:zb)(a,function(a,d,e){return b(c,a,d,e)}),c},Aa.unary=function(a){return ee(a,1)},Aa.union=Fg,Aa.unionBy=Gg,Aa.unionWith=Hg,Aa.uniq=function(a){return a&&a.length?vc(a):[]},Aa.uniqBy=function(a,b){return a&&a.length?vc(a,ud(b,2)):[]},Aa.uniqWith=function(a,b){return b="function"==typeof b?b:P,a&&a.length?vc(a,P,b):[]},Aa.unset=function(a,b){return null==a||wc(a,b)},Aa.unzip=Yd,Aa.unzipWith=Zd,Aa.update=function(a,b,c){return null==a?a:mc(a,b,Cc(c)(Cb(a,b)),void 0)},Aa.updateWith=function(a,b,c,d){return d="function"==typeof d?d:P,null!=a&&(a=mc(a,b,Cc(c)(Cb(a,b)),d)),a},Aa.values=Ke,Aa.valuesIn=function(a){return null==a?[]:D(a,Ie(a))},Aa.without=Ig,Aa.words=Ne,Aa.wrap=function(a,b){return bh(Cc(b),a)},Aa.xor=Jg,Aa.xorBy=Kg,Aa.xorWith=Lg,Aa.zip=Mg,Aa.zipObject=function(a,b){return Ac(a||[],b||[],ib)},Aa.zipObjectDeep=function(a,b){return Ac(a||[],b||[],mc)},Aa.zipWith=Ng,Aa.entries=Fh,Aa.entriesIn=Gh,Aa.extend=sh,Aa.extendWith=th,Re(Aa,Aa),Aa.add=$h,Aa.attempt=Ph,Aa.camelCase=Hh,Aa.capitalize=Le,Aa.ceil=_h,Aa.clamp=function(a,b,c){return c===P&&(c=b,b=P),c!==P&&(c=Ce(c),c=c===c?c:0),b!==P&&(b=Ce(b),b=b===b?b:0),pb(Ce(a),b,c)},Aa.clone=function(a){return qb(a,4)},Aa.cloneDeep=function(a){return qb(a,5)},Aa.cloneDeepWith=function(a,b){return b="function"==typeof b?b:P,qb(a,5,b)},Aa.cloneWith=function(a,b){return b="function"==typeof b?b:P,qb(a,4,b)},Aa.conformsTo=function(a,b){return null==b||sb(a,b,He(b))},Aa.deburr=Me,Aa.defaultTo=function(a,b){return null==a||a!==a?b:a},Aa.divide=ai,Aa.endsWith=function(a,b,c){a=Ee(a),b=uc(b);var d=a.length,d=c=c===P?d:pb(Ae(c),0,d);return 0<=(c-=b.length)&&a.slice(c,d)==b},Aa.eq=le,Aa.escape=function(a){return(a=Ee(a))&&Z.test(a)?a.replace(X,cb):a},Aa.escapeRegExp=function(a){return(a=Ee(a))&&ga.test(a)?a.replace(fa,"\\$&"):a},Aa.every=function(a,b,c){var d=hh(a)?g:vb;return c&&Ed(a,b,c)&&(b=P),d(a,ud(b,3))},Aa.find=Qg,Aa.findIndex=Rd,Aa.findKey=function(a,b){return p(a,ud(b,3),zb)},Aa.findLast=Rg,Aa.findLastIndex=Sd,Aa.findLastKey=function(a,b){return p(a,ud(b,3),Ab)},Aa.floor=bi,Aa.forEach=be,Aa.forEachRight=ce,Aa.forIn=function(a,b){return null==a?a:ig(a,ud(b,3),Ie)},Aa.forInRight=function(a,b){return null==a?a:jg(a,ud(b,3),Ie)},Aa.forOwn=function(a,b){return a&&zb(a,ud(b,3))},Aa.forOwnRight=function(a,b){return a&&Ab(a,ud(b,3))},Aa.get=Fe,Aa.gt=eh,Aa.gte=fh,Aa.has=function(a,b){return null!=a&&yd(a,b,Gb)},Aa.hasIn=Ge,Aa.head=Ud,Aa.identity=Pe,Aa.includes=function(a,b,c,d){return a=me(a)?a:Ke(a),c=c&&!d?Ae(c):0,d=a.length,0>c&&(c=Lf(d+c,0)),we(a)?c<=d&&-1<a.indexOf(b,c):!!d&&-1<r(a,b,c)},Aa.indexOf=function(a,b,c){var d=null==a?0:a.length;return d?(c=null==c?0:Ae(c),0>c&&(c=Lf(d+c,0)),r(a,b,c)):-1},Aa.inRange=function(a,b,c){return b=ze(b),c===P?(c=b,b=0):c=ze(c),(a=Ce(a))>=Mf(b,c)&&a<Lf(b,c)},Aa.invoke=Ah,Aa.isArguments=gh,Aa.isArray=hh,Aa.isArrayBuffer=ih,Aa.isArrayLike=me,Aa.isArrayLikeObject=ne,Aa.isBoolean=function(a){return!0===a||!1===a||te(a)&&"[object Boolean]"==Eb(a)},Aa.isBuffer=jh,Aa.isDate=kh,Aa.isElement=function(a){return te(a)&&1===a.nodeType&&!ve(a)},Aa.isEmpty=function(a){if(null==a)return!0;if(me(a)&&(hh(a)||"string"==typeof a||"function"==typeof a.splice||jh(a)||oh(a)||gh(a)))return!a.length;var b=rg(a);if("[object Map]"==b||"[object Set]"==b)return!a.size;if(Hd(a))return!Wb(a).length;for(var c in a)if(hf.call(a,c))return!1;return!0},Aa.isEqual=function(a,b){return Ob(a,b)},Aa.isEqualWith=function(a,b,c){var d=(c="function"==typeof c?c:P)?c(a,b):P;return d===P?Ob(a,b,P,c):!!d},Aa.isError=oe,Aa.isFinite=function(a){return"number"==typeof a&&If(a)},Aa.isFunction=pe,Aa.isInteger=qe,Aa.isLength=re,Aa.isMap=lh,Aa.isMatch=function(a,b){return a===b||Qb(a,b,wd(b))},Aa.isMatchWith=function(a,b,c){return c="function"==typeof c?c:P,Qb(a,b,wd(b),c)},Aa.isNaN=function(a){return ue(a)&&a!=+a},Aa.isNative=function(a){if(sg(a))throw new Ye("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Rb(a)},Aa.isNil=function(a){return null==a},Aa.isNull=function(a){return null===a},Aa.isNumber=ue,Aa.isObject=se,Aa.isObjectLike=te,Aa.isPlainObject=ve,Aa.isRegExp=mh,Aa.isSafeInteger=function(a){return qe(a)&&-9007199254740991<=a&&9007199254740991>=a},Aa.isSet=nh,Aa.isString=we,Aa.isSymbol=xe,Aa.isTypedArray=oh,Aa.isUndefined=function(a){return a===P},Aa.isWeakMap=function(a){return te(a)&&"[object WeakMap]"==rg(a)},Aa.isWeakSet=function(a){return te(a)&&"[object WeakSet]"==Eb(a)},Aa.join=function(a,b){return null==a?"":Jf.call(a,b)},Aa.kebabCase=Ih,Aa.last=Vd,Aa.lastIndexOf=function(a,b,c){var d=null==a?0:a.length;if(!d)return-1;var e=d;if(c!==P&&(e=Ae(c),e=0>e?Lf(d+e,0):Mf(e,d-1)),b===b){for(c=e+1;c--&&a[c]!==b;);a=c}else a=q(a,t,e,!0);return a},Aa.lowerCase=Jh,Aa.lowerFirst=Kh,Aa.lt=ph,Aa.lte=qh,Aa.max=function(a){return a&&a.length?wb(a,Pe,Fb):P},Aa.maxBy=function(a,b){return a&&a.length?wb(a,ud(b,2),Fb):P},Aa.mean=function(a){return u(a,Pe)},Aa.meanBy=function(a,b){return u(a,ud(b,2))},Aa.min=function(a){return a&&a.length?wb(a,Pe,Xb):P},Aa.minBy=function(a,b){return a&&a.length?wb(a,ud(b,2),Xb):P},Aa.stubArray=Ue,Aa.stubFalse=Ve,Aa.stubObject=function(){return{}},Aa.stubString=function(){return""},Aa.stubTrue=function(){return!0},Aa.multiply=ci,Aa.nth=function(a,b){return a&&a.length?ac(a,Ae(b)):P},Aa.noConflict=function(){return Ra._===this&&(Ra._=nf),this},Aa.noop=Se,Aa.now=Xg,Aa.pad=function(a,b,c){a=Ee(a);var d=(b=Ae(b))?N(a):0;return!b||d>=b?a:(b=(b-d)/2,cd(Ff(b),c)+a+cd(Ef(b),c))},Aa.padEnd=function(a,b,c){a=Ee(a);var d=(b=Ae(b))?N(a):0;return b&&d<b?a+cd(b-d,c):a},Aa.padStart=function(a,b,c){a=Ee(a);var d=(b=Ae(b))?N(a):0;return b&&d<b?cd(b-d,c)+a:a},Aa.parseInt=function(a,b,c){return c||null==b?b=0:b&&(b=+b),Of(Ee(a).replace(ia,""),b||0)},Aa.random=function(a,b,c){if(c&&"boolean"!=typeof c&&Ed(a,b,c)&&(b=c=P),c===P&&("boolean"==typeof b?(c=b,b=P):"boolean"==typeof a&&(c=a,a=P)),a===P&&b===P?(a=0,b=1):(a=ze(a),b===P?(b=a,a=0):b=ze(b)),a>b){var d=a;a=b,b=d}return c||a%1||b%1?(c=Pf(),Mf(a+c*(b-a+Na("1e-"+((c+"").length-1))),b)):hc(a,b)},Aa.reduce=function(a,b,c){var d=hh(a)?m:x,e=3>arguments.length;return d(a,ud(b,4),c,e,gg)},Aa.reduceRight=function(a,b,c){var d=hh(a)?n:x,e=3>arguments.length;return d(a,ud(b,4),c,e,hg)},Aa.repeat=function(a,b,c){return b=(c?Ed(a,b,c):b===P)?1:Ae(b),ic(Ee(a),b)},Aa.replace=function(){var a=arguments,b=Ee(a[0]);return 3>a.length?b:b.replace(a[1],a[2])},Aa.result=function(a,b,c){b=Dc(b,a);var d=-1,e=b.length;for(e||(e=1,a=P);++d<e;){var f=null==a?P:a[Nd(b[d])];f===P&&(d=e,f=c),a=pe(f)?f.call(a):f}return a},Aa.round=di,Aa.runInContext=w,Aa.sample=function(a){return(hh(a)?ab:kc)(a)},Aa.size=function(a){if(null==a)return 0;if(me(a))return we(a)?N(a):a.length;var b=rg(a);return"[object Map]"==b||"[object Set]"==b?a.size:Wb(a).length},Aa.snakeCase=Lh,Aa.some=function(a,b,c){var d=hh(a)?o:pc;return c&&Ed(a,b,c)&&(b=P),d(a,ud(b,3))},Aa.sortedIndex=function(a,b){return qc(a,b)},Aa.sortedIndexBy=function(a,b,c){return rc(a,b,ud(c,2))},Aa.sortedIndexOf=function(a,b){var c=null==a?0:a.length;if(c){var d=qc(a,b);if(d<c&&le(a[d],b))return d}return-1},Aa.sortedLastIndex=function(a,b){return qc(a,b,!0)},Aa.sortedLastIndexBy=function(a,b,c){return rc(a,b,ud(c,2),!0)},Aa.sortedLastIndexOf=function(a,b){if(null==a?0:a.length){var c=qc(a,b,!0)-1;if(le(a[c],b))return c}return-1},Aa.startCase=Mh,Aa.startsWith=function(a,b,c){return a=Ee(a),c=null==c?0:pb(Ae(c),0,a.length),b=uc(b),a.slice(c,c+b.length)==b},Aa.subtract=ei,Aa.sum=function(a){return a&&a.length?z(a,Pe):0},Aa.sumBy=function(a,b){return a&&a.length?z(a,ud(b,2)):0},Aa.template=function(a,b,c){var d=Aa.templateSettings;c&&Ed(a,b,c)&&(b=P),a=Ee(a),b=th({},b,d,kd),c=th({},b.imports,d.imports,kd);var e,f,g=He(c),h=D(c,g),i=0;c=b.interpolate||xa;var j="__p+='";c=af((b.escape||xa).source+"|"+c.source+"|"+(c===aa?pa:xa).source+"|"+(b.evaluate||xa).source+"|$","g");var k="sourceURL"in b?"//# sourceURL="+b.sourceURL+"\n":"";if(a.replace(c,function(b,c,d,g,h,k){return d||(d=g),j+=a.slice(i,k).replace(ya,H),c&&(e=!0,j+="'+__e("+c+")+'"),h&&(f=!0,j+="';"+h+";\n__p+='"),d&&(j+="'+((__t=("+d+"))==null?'':__t)+'"),i=k+b.length,b}),j+="';",(b=b.variable)||(j="with(obj){"+j+"}"),j=(f?j.replace(T,""):j).replace(U,"$1").replace(V,"$1;"),j="function("+(b||"obj")+"){"+(b?"":"obj||(obj={});")+"var __t,__p=''"+(e?",__e=_.escape":"")+(f?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+j+"return __p}",b=Ph(function(){return Ze(g,k+"return "+j).apply(P,h)}),b.source=j,oe(b))throw b;return b},Aa.times=function(a,b){if(1>(a=Ae(a))||9007199254740991<a)return[];var c=4294967295,d=Mf(a,4294967295);for(b=ud(b),a-=4294967295,d=A(d,b);++c<a;)b(c);return d},Aa.toFinite=ze,Aa.toInteger=Ae,Aa.toLength=Be,Aa.toLower=function(a){return Ee(a).toLowerCase()},Aa.toNumber=Ce,Aa.toSafeInteger=function(a){return a?pb(Ae(a),-9007199254740991,9007199254740991):0===a?a:0},Aa.toString=Ee,Aa.toUpper=function(a){return Ee(a).toUpperCase()},Aa.trim=function(a,b,c){return(a=Ee(a))&&(c||b===P)?a.replace(ha,""):a&&(b=uc(b))?(a=O(a),c=O(b),b=F(a,c),c=G(a,c)+1,Ec(a,b,c).join("")):a},Aa.trimEnd=function(a,b,c){return(a=Ee(a))&&(c||b===P)?a.replace(ja,""):a&&(b=uc(b))?(a=O(a),b=G(a,O(b))+1,Ec(a,0,b).join("")):a},Aa.trimStart=function(a,b,c){return(a=Ee(a))&&(c||b===P)?a.replace(ia,""):a&&(b=uc(b))?(a=O(a),b=F(a,O(b)),Ec(a,b).join("")):a},Aa.truncate=function(a,b){var c=30,d="...";if(se(b))var e="separator"in b?b.separator:e,c="length"in b?Ae(b.length):c,d="omission"in b?uc(b.omission):d;a=Ee(a);var f=a.length;if(Ga.test(a))var g=O(a),f=g.length;if(c>=f)return a;if(1>(f=c-N(d)))return d;if(c=g?Ec(g,0,f).join(""):a.slice(0,f),e===P)return c+d;if(g&&(f+=c.length-f),mh(e)){if(a.slice(f).search(e)){var h=c;for(e.global||(e=af(e.source,Ee(qa.exec(e))+"g")),e.lastIndex=0;g=e.exec(h);)var i=g.index;c=c.slice(0,i===P?f:i)}}else a.indexOf(uc(e),f)!=f&&-1<(e=c.lastIndexOf(e))&&(c=c.slice(0,e));return c+d},Aa.unescape=function(a){return(a=Ee(a))&&Y.test(a)?a.replace(W,db):a},Aa.uniqueId=function(a){var b=++jf;return Ee(a)+b},Aa.upperCase=Nh,Aa.upperFirst=Oh,Aa.each=be,Aa.eachRight=ce,Aa.first=Ud,Re(Aa,function(){var a={};return zb(Aa,function(b,c){hf.call(Aa.prototype,c)||(a[c]=b)}),a}(),{chain:!1}),Aa.VERSION="4.17.4",e("bind bindKey curry curryRight partial partialRight".split(" "),function(a){Aa[a].placeholder=Aa}),e(["drop","take"],function(a,b){La.prototype[a]=function(c){c=c===P?1:Lf(Ae(c),0);var d=this.__filtered__&&!b?new La(this):this.clone();return d.__filtered__?d.__takeCount__=Mf(c,d.__takeCount__):d.__views__.push({size:Mf(c,4294967295),type:a+(0>d.__dir__?"Right":"")}),d},La.prototype[a+"Right"]=function(b){return this.reverse()[a](b).reverse()}}),e(["filter","map","takeWhile"],function(a,b){var c=b+1,d=1==c||3==c;La.prototype[a]=function(a){var b=this.clone();return b.__iteratees__.push({iteratee:ud(a,3),type:c}),b.__filtered__=b.__filtered__||d,b}}),e(["head","last"],function(a,b){var c="take"+(b?"Right":"");La.prototype[a]=function(){return this[c](1).value()[0]}}),e(["initial","tail"],function(a,b){var c="drop"+(b?"":"Right");La.prototype[a]=function(){return this.__filtered__?new La(this):this[c](1)}}),La.prototype.compact=function(){return this.filter(Pe)},La.prototype.find=function(a){return this.filter(a).head()},La.prototype.findLast=function(a){return this.reverse().find(a)},La.prototype.invokeMap=jc(function(a,b){return"function"==typeof a?new La(this):this.map(function(c){return Kb(c,a,b)})}),La.prototype.reject=function(a){return this.filter(ke(ud(a)))},La.prototype.slice=function(a,b){a=Ae(a);var c=this;return c.__filtered__&&(0<a||0>b)?new La(c):(0>a?c=c.takeRight(-a):a&&(c=c.drop(a)),b!==P&&(b=Ae(b),c=0>b?c.dropRight(-b):c.take(b-a)),c)},La.prototype.takeRightWhile=function(a){return this.reverse().takeWhile(a).reverse()},La.prototype.toArray=function(){return this.take(4294967295)},zb(La.prototype,function(a,b){var c=/^(?:filter|find|map|reject)|While$/.test(b),d=/^(?:head|last)$/.test(b),e=Aa[d?"take"+("last"==b?"Right":""):b],f=d||/^find/.test(b);e&&(Aa.prototype[b]=function(){function b(a){return a=e.apply(Aa,l([a],h)),d&&m?a[0]:a}var g=this.__wrapped__,h=d?[1]:arguments,i=g instanceof La,j=h[0],k=i||hh(g);k&&c&&"function"==typeof j&&1!=j.length&&(i=k=!1);var m=this.__chain__,n=!!this.__actions__.length,j=f&&!m,i=i&&!n;return!f&&k?(g=i?g:new La(this),g=a.apply(g,h),g.__actions__.push({func:_d,args:[b],thisArg:P}),new Ea(g,m)):j&&i?a.apply(this,h):(g=this.thru(b),j?d?g.value()[0]:g.value():g)})}),e("pop push shift sort splice unshift".split(" "),function(a){var b=df[a],c=/^(?:push|sort|unshift)$/.test(a)?"tap":"thru",d=/^(?:pop|shift)$/.test(a);Aa.prototype[a]=function(){var a=arguments;if(d&&!this.__chain__){var e=this.value();return b.apply(hh(e)?e:[],a)}return this[c](function(c){return b.apply(hh(c)?c:[],a)})}}),zb(La.prototype,function(a,b){var c=Aa[b];if(c){var d=c.name+"";(Yf[d]||(Yf[d]=[])).push({name:b,func:c})}}),Yf[$c(P,2).name]=[{name:"wrapper",func:P}],La.prototype.clone=function(){var a=new La(this.__wrapped__);return a.__actions__=Lc(this.__actions__),a.__dir__=this.__dir__,a.__filtered__=this.__filtered__,a.__iteratees__=Lc(this.__iteratees__),a.__takeCount__=this.__takeCount__,a.__views__=Lc(this.__views__),a},La.prototype.reverse=function(){if(this.__filtered__){var a=new La(this);a.__dir__=-1,a.__filtered__=!0}else a=this.clone(),a.__dir__*=-1;return a},La.prototype.value=function(){var a,b=this.__wrapped__.value(),c=this.__dir__,d=hh(b),e=0>c,f=d?b.length:0;a=f;for(var g=this.__views__,h=0,i=-1,j=g.length;++i<j;){var k=g[i],l=k.size;switch(k.type){case"drop":h+=l;break;case"dropRight":a-=l;break;case"take":a=Mf(a,h+l);break;case"takeRight":h=Lf(h,a-l)}}if(a={start:h,end:a},g=a.start,h=a.end,a=h-g,g=e?h:g-1,h=this.__iteratees__,i=h.length,j=0,k=Mf(a,this.__takeCount__),!d||!e&&f==a&&k==a)return yc(b,this.__actions__);d=[];a:for(;a--&&j<k;){for(g+=c,e=-1,f=b[g];++e<i;){var m=h[e],l=m.type,m=(0,m.iteratee)(f);if(2==l)f=m;else if(!m){if(1==l)continue a;break a}}d[j++]=f}return d},Aa.prototype.at=Og,Aa.prototype.chain=function(){return $d(this)},Aa.prototype.commit=function(){return new Ea(this.value(),this.__chain__)},Aa.prototype.next=function(){this.__values__===P&&(this.__values__=ye(this.value()));var a=this.__index__>=this.__values__.length;return{done:a,value:a?P:this.__values__[this.__index__++]}},Aa.prototype.plant=function(a){for(var b,c=this;c instanceof Ba;){var d=Qd(c);d.__index__=0,d.__values__=P,b?e.__wrapped__=d:b=d;var e=d,c=c.__wrapped__}return e.__wrapped__=a,b},Aa.prototype.reverse=function(){var a=this.__wrapped__;return a instanceof La?(this.__actions__.length&&(a=new La(this)),a=a.reverse(),a.__actions__.push({func:_d,args:[Xd],thisArg:P}),new Ea(a,this.__chain__)):this.thru(Xd)},Aa.prototype.toJSON=Aa.prototype.valueOf=Aa.prototype.value=function(){return yc(this.__wrapped__,this.__actions__)},Aa.prototype.first=Aa.prototype.head,yf&&(Aa.prototype[yf]=ae),Aa}();"function"==typeof define&&"object"==typeof define.amd&&define.amd?(Ra._=eb,define(function(){return eb})):Ta?((Ta.exports=eb)._=eb,Sa._=eb):Ra._=eb}).call(this);
window.theme = window.theme || {};
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container),
        id = $container.attr('data-section-id'),
        type = $container.attr('data-section-type');
    constructor = constructor || this.constructors[type];
    if (_.isUndefined(constructor)) {
      return;
    }
    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  },
  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },
  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.originalEvent.detail.sectionId);
      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },
  _onSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },
  _onDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },
  _onBlockSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },
  _onBlockDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },
  register: function(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
theme.language = {
  collections_general_update_cart: "Update Cart",
  collections_general_update_cart_message: "There are products in your cart.",
  collections_general_update_cart_label_message: "In the cart",
  collections_sidebar_less: "- Less",
  collections_sidebar_more: "+ More",
  contact_form_send: "Send",
  layout_general_next: "Next",
  layout_general_unavailable: "Unavailable",
  products_general_inv_msg_1: "Only",
  products_general_inv_msg_2: "left!",
  products_general_per: " per ",
  products_product_add_to_cart: "Add to Cart",
  products_product_ajax_added: "Added to cart!",
  products_product_ajax_adding: "Adding...",
  products_product_ajax_view: "View cart",
  products_product_available: "Available Now!",
  products_product_disabled_add_to_cart: "Unavailable",
  products_product_free: "Free",
  products_product_sku: "SKU: ",
  products_product_sold_out: "Sold Out",
  general_search_see_results: "See all results",
  general_validation_required: "This field is required",
  general_validation_fix_field: "Please fix this field",
  general_validation_valid_email: "Please enter a valid email address",
  general_validation_valid_url: "Please enter a valid URL",
  general_validation_valid_date: "Please enter a valid date",
  general_validation_valid_iso: "Please enter a valid date (ISO)",
  general_validation_valid_number: "Please enter a valid number",
  general_validation_only_digits: "Please enter only digits",
  general_validation_same_value: "Please enter the same value again",
  general_validation_characters_exceed: "Characters cannot exceed",
  general_validation_characters_min: "Minimum character count is",
  general_validation_characters_range: "Character range is",
  general_validation_value_less: "Value must be less than or equal to",
  general_validation_value_greater: "Value must be greater than or equal to",
  general_validation_value_range: "Value range is",
  general_validation_multiple: "Please enter a multiple of",
  general_validation_browser_oodate: "Your browser is out-of-date!",
  general_validation_browser_msg: "Update your browser to view this website correctly",
  general_validation_browser_update: "Update my browser now",
  general_validation_close: "Translation missing: en.general.validation.close"
};
theme.adjustMenu = function () {
  var top = $('.sticky-navigation').offset().top,
      sticky_top = $('.header-toolbar').outerHeight(),
      sticky_navigation = $('.sticky-navigation-container').outerHeight(),
      innerHeight = window.innerHeight,
      innerWidth = window.innerWidth;
  $('.responsiveMenu').css({maxHeight:innerHeight - sticky_navigation - 20 + 'px' });
  if($('.sticky-navigation-container').hasClass('sticky')){
    var target = window.location.hash
    $('.responsiveMenu .parent-level-ul').css({maxHeight:innerHeight - sticky_top - 40 + 'px' });
    if ( target != '' ){
      var $target = jQuery(target);
      $target.css({paddingTop:sticky_navigation + 'px'}).css({marginTop:sticky_navigation * -1 + 'px'});
      $('a').on('click', function() {
        $target.css({paddingTop:'0'}).css({marginTop:'0'});
      });
    }
    $(window).on('load', function() {
      $(window).scroll(function() {
        if ( target != '' ){
          $target.css({paddingTop:'0'}).css({marginTop:'0'});
        }
      });
    });
    function sticktothetop() {
      var top = $('.sticky-navigation').offset().top;
      if ($(window).scrollTop() >= top) {
        $('.sticky-navigation-container.sticky').addClass('stuck');
      } else {
        $('.sticky-navigation-container.sticky').removeClass('stuck');
      }
    }
    $(function() {
      $(window).scroll(sticktothetop);
      sticktothetop();
    });
    $(window).bind('resize orientationchange', function() {
      if ( target != '' ){
        $target.css({paddingTop:'0'}).css({marginTop:'0'});
      }
      if($('body').hasClass('desktop-only')){
        $('.toggleMenu').removeClass('active');
        $('.responsiveMenu').removeClass('active');
        $('body').removeClass('no-scroll').css('position','').css('left','auto').css('right','auto').css('top','auto');
      };
    });
  };
  function updateNav() {
    var availableSpace = $('.header-navigation .container').width(),
        logowidth = $('.logo a').width(),
        totalwidth = availableSpace - logowidth,
        navwidth = $('.header-navigation-width').width();
    if (navwidth > totalwidth) {
      return true;
    } else {
      return false;
    }
  }
  function detectmob() {
    if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)){
      return true;
    } else {
      return false;
    }
  }
  var maxMobileWidth = parseInt($('.responsiveMenu').data('maxmobilewidth'));
  $('.responsiveMenu > li > ul > li.parent > ul').each(function(){$(this).children('li').last().addClass('last')});
  if (innerWidth <= maxMobileWidth || updateNav() || detectmob()) {
    $('body').removeClass('desktop-only').addClass('mobile-only');
    $('.toggleMenu').removeClass('isDesktop').addClass('isMobile');
    if (!$('.toggleMenu').hasClass('active')) {
      $('.responsiveMenu').hide().removeClass('isDesktop').addClass('isMobile');
    } else {
      $('.responsiveMenu').show().removeClass('isDesktop').addClass('isMobile');
    }
    $('.responsiveMenu .parent-level-ul').removeAttr('style');
    $('.responsiveMenu li').unbind('mouseenter mouseleave').removeClass('isDesktop').addClass('isMobile');
    $('.responsiveMenu li.has-dropdown a.parent').unbind('click').bind('click', function(e) {
      e.preventDefault();
      $(this).parent('li').toggleClass('hover');
    });
    $('.responsiveMenu li a.parent span').click(function(){
      if((typeof $(this).parent().attr('href') != 'undefined') && $(this).parent().attr('href') != '#'){
        $(this).parent().unbind('click');
        myLink = $(this).parent().attr('href');
        window.location.href = myLink;
      }
    });
  } else if (innerWidth > maxMobileWidth) {
    var hoverTimeout;
    $('body').removeClass('mobile-only').addClass('desktop-only');
    $('.sticky-navigation-container.sticky').removeClass('stuck');
    $('.toggleMenu').removeClass('isMobile').addClass('isDesktop');
    $('.responsiveMenu').show().removeClass('isMobile').addClass('isDesktop');
    $('.responsiveMenu li').removeClass('hover isMobile').addClass('isDesktop');
    $('.responsiveMenu li a').unbind('click');
    $('.responsiveMenu li.parent').unbind('mouseenter').bind('mouseenter', function () {
      clearTimeout(hoverTimeout);
      $('.responsiveMenu li.hover').removeClass('hover');
      $(this).addClass('hover');
    });
    $('.responsiveMenu li.parent').unbind('mouseleave').bind('mouseleave', function () {
      var $this=$(this);
      hoverTimeout = setTimeout(function() {
        $this.removeClass('hover');
      },250);
    });
  }
  var links = document.links;
  /*for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].href.indexOf('javascript:')) {
      links[i].target = '_blank';
    }
  }*/
};
theme.product_options = function ($container) {
  var sectionId = this.sectionId = $container.attr('data-section-id'),
      productId = this.productId = $container.attr('data-product-id'),
      productJson = JSON.parse($('#ProductJson-' + sectionId).html()),
      productSelect = 'product-select-' + sectionId,
      productPrice = '#price-' + sectionId,
      productSavings = '#savings-' + sectionId,
      productCompare = '#compare-' + sectionId,
      productAdd = '#add-to-cart-' + sectionId,
      productStock = '#error_' + sectionId,
      productQuantity = '#updates_' + sectionId,
      productInventory = '#inventory-' + sectionId,
      productInventoryCutoff = $('#inventory-' + sectionId).data('inv'),
      productSKU = '#sku-' + sectionId,
      productOffer = '#offer-' + sectionId,
      productSeparator = '#product-logistics-' + sectionId + ' .separator',
      productSlide = '#product-carousel-' + sectionId;

  var practitionerPrices = $(".practitioner-price");
  selectCallback = function(variant) {
    var productForm = $('form.product_form-' + sectionId ),
        productInventoryAmt = $('#product-select-' + sectionId + ' option:selected').data('inv'),
        money = '';
        var skuSelector = '.practitioner-price[data-sku="' + variant.sku + '"]';
        var practitionerPrice = $(skuSelector).data("practitionerPrice");
        if (variant && variant.available == true) {
          if (practitionerPrice) {
            $(productPrice).html(Shopify.formatMoney(practitionerPrice, theme.moneyFormat));
            $('.product-price').html(Shopify.formatMoney(variant.price.toString(), theme.moneyFormat));
            $(productSavings).addClass('hidden');
          } else {
            if (variant.compare_at_price > variant.price) {
              if (variant.price == '0') {
                $(productPrice).html(theme.language.products_product_free + ' <del>' + Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</del>');
                $(productCompare).html(Shopify.formatMoney(variant.compare_at_price - variant.price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
                $(productSavings).removeClass('hidden');
              } else {
                $(productPrice).html(Shopify.formatMoney(variant.price, theme.moneyFormat) + ' <del>' + Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</del>');
                $(productCompare).html(Shopify.formatMoney(variant.compare_at_price - variant.price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
                $(productSavings).removeClass('hidden');
              }
            } else if (variant.price == '0') {
              $(productPrice).text(theme.language.products_product_free)
              $(productSavings).addClass('hidden');
            } else {
              $(productPrice).html(Shopify.formatMoney(variant.price, theme.moneyFormat));
              $(productSavings).addClass('hidden');
            }
          }
          $(productAdd).val(theme.language.products_product_add_to_cart).removeClass('disabled outline').attr('disabled', false);
          $(productStock).hide();
          $(productQuantity).val(1);
        } else if (variant && variant.available == false) {
          if(variant.compare_at_price > variant.price){
            if(variant.price == '0') {
              $(productPrice).html(theme.language.products_product_free + ' <del>' + Shopify.formatMoney(variant.compare_at_price,theme.moneyFormat) + '</del>');
              $(productCompare).html(Shopify.formatMoney(variant.compare_at_price - variant.price,theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
              $(productSavings).removeClass('hidden');
            } else {
              $(productPrice).html(Shopify.formatMoney(variant.price,theme.moneyFormat) + ' <del>' + Shopify.formatMoney(variant.compare_at_price,theme.moneyFormat) + '</del>');
              $(productCompare).html(Shopify.formatMoney(variant.compare_at_price - variant.price,theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
              $(productSavings).removeClass('hidden');
            }
          } else if(variant.price == '0') {
            $(productPrice).html(theme.language.products_product_free)
            $(productCompare).html(Shopify.formatMoney(variant.compare_at_price - variant.price,theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
            $(productSavings).addClass('hidden');
          } else {
            $(productPrice).html(Shopify.formatMoney(variant.price,theme.moneyFormat));
          }
          $(productAdd).val(theme.language.products_product_disabled_add_to_cart).addClass('disabled outline').attr('disabled', true);
          //$(productSavings).addClass('hidden');
          $(productStock).hide();
          $(productQuantity).val(0);
        }  else {
          $(productAdd).val(theme.language.products_product_disabled_add_to_cart).addClass('disabled outline').attr('disabled', true);
          $(productInventory).empty();
          $(productPrice).empty();
          $(productSKU).empty();
          $(productSeparator).addClass('hidden');
          $(productSavings).addClass('hidden');
          $(productStock).hide();
          $(productQuantity).val(0).attr({'max' : -1}).attr({'min' : 0});
        }
    if (variant) {
      if (variant.sku) {
        $(productSKU).html(theme.language.products_product_sku + '&nbsp;' + variant.sku);
        $(productSeparator).removeClass('hidden');
      } else {
        $(productSKU).empty();
        $(productSeparator).addClass('hidden');
      }
      if (variant.inventory_management == 'shopify') {
        if (productInventoryAmt > 0 && productInventoryAmt < productInventoryCutoff) {
          $(productInventory).html('<h4>' + theme.language.products_general_inv_msg_1 + '&nbsp;' + productInventoryAmt + '&nbsp;' + theme.language.products_general_inv_msg_2 + '</h4>');
          $(productQuantity).attr({'min' : 1});
        } else if (productInventoryAmt > productInventoryCutoff) {
          $(productInventory).html('<h4>' + theme.language.products_product_available + '</h4>');
          $(productQuantity).attr({'min' : 1});
        } else if (productInventoryAmt < 1) {
          if (variant.available) {
            $(productInventory).html('<h4>' + theme.language.products_product_available + '</h4>');
            $(productQuantity).attr({'min' : 1});
          } else {
            $(productInventory).html('<h4>' + theme.language.products_product_sold_out + '</h4>');
            $(productQuantity).attr({'min' : 0});
          }
        } else {
          $(productInventory).html('<h4>' + theme.language.products_product_available + '</h4>');
          $(productQuantity).attr({'min' : 1});
        }
        if (productInventoryAmt != null) {
          $(productQuantity).attr({'max' : productInventoryAmt});
        } else {
          $(productQuantity).removeAttr('max');
        };
      } else {
        $(productInventory).html('<h4>' + theme.language.products_product_available + '</h4>');
        $(productQuantity).removeAttr('max').attr({'min' : 1});
      }
      if (variant.unit_price_measurement) {
        if (variant.unit_price_measurement.reference_value != 1) {
          $(productOffer).html('<h4>' + Shopify.formatMoney(variant.unit_price,theme.moneyFormat) + theme.language.products_general_per + variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit + '</h4>').removeClass('hidden');
        } else {
          $(productOffer).html('<h4>' + Shopify.formatMoney(variant.unit_price,theme.moneyFormat) + theme.language.products_general_per + variant.unit_price_measurement.reference_unit + '</h4>').removeClass('hidden');
        }
      } else {
        $(productOffer).empty().addClass('hidden');
      }
      if (variant && variant.featured_image) {
        var newImg = variant.featured_image,
            $newImage = $('.variant-image-' + sectionId).filter('[data-image-id="' + newImg.id + '"]'),
            $otherImages = $('.variant-image-' + sectionId).not('[data-image-id="' + newImg.id + '"]');
        $newImage.removeClass('hidden');
        $otherImages.addClass('hidden');
      }
    } else {
      $(productSKU).empty();
      $(productInventory).empty();
      $(productOffer).empty();
    }
  };
  new Shopify.OptionSelectors(productSelect, {
    product: productJson,
    onVariantSelected: selectCallback,
    enableHistoryState: true
  });
  $('#product-id-' + sectionId + ' .selector-wrapper').each(function (i) {
    var var_select = $(this).find('select'),
        opt_length = var_select.find('option').length,
        opt_option = $('#product-select-' + sectionId).data('length');
    if (opt_length > opt_option) {
      var cols = $('#' + productSelect).attr('data-cols');
      $(this).wrap('<div class="' + cols + '" />');
    } else {
      $(this).hide();
    }
  });
  $('.thumb-image-' + sectionId).on('click keyup', function() {
    var newThb = $(this).find('img').attr('id').replace('image-thumb-',''),
        $newThumb = $('.variant-image-' + sectionId).filter('[data-image-id="' + newThb + '"]'),
        $otherThumbs = $('.variant-image-' + sectionId).not('[data-image-id="' + newThb + '"]');
    $newThumb.removeClass('hidden');
    $otherThumbs.addClass('hidden');
    $('#product-id-' + sectionId + ' .selector-wrapper').addClass('active');
  });
  $(function() {
    var thumbSwiper = new Swiper ('#thumbnails-'+ sectionId, {
      freeMode: true,
      freeModeMomentum: false,
      freeModeMomentumBounce: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      grabCursor: true,
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: '#swiper-button-next-thumbs',
        prevEl: '#swiper-button-prev-thumbs',
      }
    });
  });
  var $productImageWrapper = $('.variant-image-' + sectionId);
  $productImageWrapper.trigger('zoom.destroy');
  $productImageWrapper.each(function() {
    if($(this).find('img').attr('data-zoom')){
      $(this).addClass('image-zoom').zoom({
        url: $(this).find('img').attr('data-zoom')
      });
    }
  });
};
theme.qtyinput_quantity = function ($container) {
  var sectionId = this.sectionId = $container.attr('data-section-id'),
      productId = this.productId = $container.attr('data-product-id');
  
  $('#jshook_products_container').on("click", ".qtyplus_multi--filtered", function(e) {
    e.preventDefault();
    var fieldName = $(this).attr('field'),
        pricefieldName = $(this).attr('price-field'),
        priceid = parseInt($('input[id='+pricefieldName+']').attr('price')),
        key = document.getElementById(fieldName),
        error = document.getElementById($(key).attr('field')),
        max = parseInt($(key).attr('max')),
        currentVal = parseInt($(key).val());
    if (!isNaN(currentVal)) {
      var currentVal = parseInt($(key).val());
    } else {
      var currentVal = parseInt(0);
    };
    $(key).val(currentVal + 1);
    if (max != 0) {
      if (currentVal + 1 > max) {
        $(error).show().html(theme.language.products_general_inv_msg_1 + '&nbsp;' + max + '&nbsp;' + theme.language.products_general_inv_msg_2);
        parseInt($(key).val(max));
      }
    } else if (max < 0) {
      $(error).show().html(theme.language.products_product_disabled_add_to_cart);
      parseInt($(key).val(0));
    } else {
      $(error).show().html(theme.language.products_product_sold_out);
      parseInt($(key).val(0));
    }
    var newVal = parseInt($(key).val());
    $('input[id='+pricefieldName+']').val(newVal * priceid );
  });
  $('#jshook_products_container').on("click", ".qtyminus_multi--filtered", function(e) {
    e.preventDefault();
    var fieldName = $(this).attr('field'),
        pricefieldName = $(this).attr('price-field'),
        priceid = parseInt($('input[id='+pricefieldName+']').attr('price')),
        key = document.getElementById(fieldName),
        id = $(key).attr('field'),
        error = document.getElementById($(key).attr('field')),
        min = parseInt($(key).attr('min')),
        currentVal = parseInt($(key).val());
        
    if (!isNaN(currentVal)) {
      var currentVal = parseInt($(key).val());
    } else {
      var currentVal = parseInt(2);
    };
    $(error).hide();
    if (!isNaN(currentVal) && currentVal > min) {
      $(key).val(currentVal - 1);
    } else {
      $(key).val(min);
    }
    var newVal = parseInt($(key).val());
    $('input[id='+pricefieldName+']').val(newVal * priceid );
  });

  $('.qtyplus_' + sectionId + ',.qtyplus_multi').click(function(e) {
    e.preventDefault();
    var fieldName = $(this).attr('field'),
        pricefieldName = $(this).attr('price-field'),
        priceid = parseInt($('input[id='+pricefieldName+']').attr('price')),
        key = document.getElementById(fieldName),
        error = document.getElementById($(key).attr('field')),
        max = parseInt($(key).attr('max')),
        currentVal = parseInt($(key).val());
    if (!isNaN(currentVal)) {
      var currentVal = parseInt($(key).val());
    } else {
      var currentVal = parseInt(0);
    };
    $(key).val(currentVal + 1);
    if (max != 0) {
      if (currentVal + 1 > max) {
        $(error).show().html(theme.language.products_general_inv_msg_1 + '&nbsp;' + max + '&nbsp;' + theme.language.products_general_inv_msg_2);
        parseInt($(key).val(max));
      }
    } else if (max < 0) {
      $(error).show().html(theme.language.products_product_disabled_add_to_cart);
      parseInt($(key).val(0));
    } else {
      $(error).show().html(theme.language.products_product_sold_out);
      parseInt($(key).val(0));
    }
    var newVal = parseInt($(key).val());
    $('input[id='+pricefieldName+']').val(newVal * priceid );
  });
  $('.qtyminus_' + sectionId + ',.qtyminus_multi').click(function(e) {
    e.preventDefault();
    var fieldName = $(this).attr('field'),
        pricefieldName = $(this).attr('price-field'),
        priceid = parseInt($('input[id='+pricefieldName+']').attr('price')),
        key = document.getElementById(fieldName),
        id = $(key).attr('field'),
        error = document.getElementById($(key).attr('field')),
        min = parseInt($(key).attr('min')),
        currentVal = parseInt($(key).val());
        
    if (!isNaN(currentVal)) {
      var currentVal = parseInt($(key).val());
    } else {
      var currentVal = parseInt(2);
    };
    $(error).hide();
    if (!isNaN(currentVal) && currentVal > min) {
      $(key).val(currentVal - 1);
    } else {
      $(key).val(min);
    }
    var newVal = parseInt($(key).val());
    $('input[id='+pricefieldName+']').val(newVal * priceid );
  });

  $('.quantity').on('change, mouseup, keyup','[max]', function() {
    var error = document.getElementById($(this).attr('field')),
        max = parseInt($(this).attr('max'), 10),
        min = parseInt($(this).attr('min'), 10),
        value = parseInt($(this).val(), 10) || 0;
    $(error).hide();
    if (max != 0) {
      if (value > max) {
        $(error).show().html(theme.language.products_general_inv_msg_1 + '&nbsp;' + max + '&nbsp;' + theme.language.products_general_inv_msg_2);
        $(this).val(max);
      } else if (value < min) {
        $(error).hide();
        $(this).val(min);
      }
    } else {
      $(error).show().html(theme.language.products_product_sold_out);
      $(this).val(0);
    }

  });
};
theme.ajax_cart = function () {
  //	Copyright (c) 2015 Caroline Schnapp (11heavens.com) | Dual licensed under the MIT and GPL licenses: http://www.opensource.org/licenses/mit-license.php | http://www.gnu.org/licenses/gpl.html |
  Shopify.AjaxifyCart = (function($) {
    var _config = {
      addToCartBtnLabel: 'Add to Cart',
      addedToCartBtnLabel: 'Thank you!',
      addingToCartBtnLabel: 'Adding...',
      soldOutBtnLabel: 'Sold Out',
      howLongTillBtnReturnsToNormal: 1000,
      cartCountSelector: '.cartCountSelector',
      cartTotalSelector: '.cartTotalSelector',
      feedbackPosition: 'nextButton',
      addToCartBtnSelector: '[type="submit"]',
      addToCartFormSelector: 'form.go-to-cart',
      shopifyAjaxAddURL: '/cart/add.js',
      shopifyAjaxCartURL: '/cart.js',
      shopifyAjaxCollectionURL: $('#collection_url').attr('href')
    };
    var _showFeedback = function(success, html, $addToCartForm) {
      $('.ajaxified-cart-feedback').remove();
      var feedback = '<p class="ajaxified-cart-feedback ' + success + '"><span class="icon icon-check"></span>' + html + '</p>';
      switch (_config.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
          break;
      }
      $('.ajaxified-cart-feedback').slideDown();
    };
    var _setText = function($button, label) {
      if ($button.children().length) {
        $button.children().each(function() {
          if ($.trim($(this).text()) !== '') {
            $(this).text(label);
          }
        });
      }
      else {
        $button.val(label).text(label);
      }
    };
    var ajaxLoadPage = function (url) {
      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        complete: function (data) {
          $('#cart-count-desktop').html($('#cart-count-desktop', data.responseText).html());
          $('#cart-count-mobile').html($('#cart-count-mobile', data.responseText).html());
          $('.cartCountSelector').html($('.cartCountSelector', data.responseText).html());
          history.replaceState({
            page: url
          }, url, url);
        }
      });
    }
    var _init = function() {
      $(function() {
        $(_config.addToCartFormSelector).submit(function(e) {
          e.preventDefault();
          var $addToCartForm = $(this),
              $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
          _setText($addToCartBtn, _config.addingToCartBtnLabel);
          $addToCartBtn.addClass('disabled').prop('disabled', true);

          var postData = $addToCartForm.serialize();
          $.ajax({
            url: _config.shopifyAjaxAddURL,
            dataType: 'json',
            type: 'post',
            data: postData,
            success: function(itemData) {
              var $shop_currency = '';
              ajaxLoadPage();
              $addToCartBtn.addClass('inverted');
              _setText($addToCartBtn, _config.addedToCartBtnLabel);
              _showFeedback('cart-success',theme.language.products_product_ajax_added + '&nbsp;<a href="/cart">' + theme.language.products_product_ajax_view + '</a>',$addToCartForm);
              window.setTimeout(function(){
                $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
                _setText($addToCartBtn,_config.addToCartBtnLabel);
              }, _config.howLongTillBtnReturnsToNormal);
              
              if($addToCartForm.attr('data-has-surcharge') == 'yes'){
                var btownCartData = JSON.parse($('[data-btown-cart]').text());
                var variant_id = $('#product-select-product-template option:selected').val(),
                    newSurchargeQtyInCart = 0,
                    surchargeQty = 0,
                    qty = parseInt($('#updates_product-template').val());
                var surchargeItemIndex = btownCartData.variants.indexOf(variant_id.toString());
                if(surchargeItemIndex >= 0){
                  btownCartData.quantity[surchargeItemIndex] = parseInt(btownCartData.quantity[surchargeItemIndex]) + qty; // set new quantity for line item
                  newSurchargeQtyInCart = calculateTotalInArray(btownCartData.quantity);
                  surchargeQty = (newSurchargeQtyInCart == 0 || newSurchargeQtyInCart > SURCHARGE_CUTOFF) ? 0 : 1;
                }
                else{
                  surchargeQty = (qty > SURCHARGE_CUTOFF) ? 0 : 1;
                  btownCartData.variants.push(variant_id);
                }
                $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: 'updates['+SURCHARGE_VARIANT_ID+']='+surchargeQty,
                  dataType: 'json',
                  success: function (data) {
                    var line_items = data.items;
                    for(var i = 0; i < line_items.length; i++){
                      item = line_items[i];
                      if(item.variant_id == variant_id){
                        var surchargeItemIndex = btownCartData.variants.indexOf(variant_id.toString());
                        btownCartData.quantity[surchargeItemIndex] = item.quantity;
                        break;
                      }
                    }
                    $('[data-btown-cart]').text(JSON.stringify(btownCartData));
                  },
                  error: function (request, status, error) {
                    console.log(error);
                  }
                });
              }
              $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
                if (_config.cartCountSelector && $(_config.cartCountSelector).length) {
                  var value = $(_config.cartCountSelector).html() || '0';
                  $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden');
                }
                if (_config.cartTotalSelector && $(_config.cartTotalSelector).length) {
                  if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
                    var newCurrency = '';
                    if ($('[name="currencies"]').length) {
                      newCurrency = $('[name="currencies"]').val();
                    }
                    else if ($('#currencies span.selected').length) {
                      newCurrency = $('#currencies span.selected').attr('data-currency');
                    }
                    if (newCurrency) {
                      $(_config.cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, $shop_currency, newCurrency).replace(/((\,00)|(\.00))$/g, ''), Currency.money_format[newCurrency]) + '</span>');
                    }
                    else {
                      $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
                    }
                  }
                  else {
                    $(_config.cartTotalSelector).html(Shopify.formatMoney(cart.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
                  }
                };
              });
            },
            error: function(XMLHttpRequest) {
              var response = eval('(' + XMLHttpRequest.responseText + ')');
              response = response.description;
              if (response.slice(0,4) === 'All ') {
                _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
                $addToCartBtn.prop('disabled', false);
                _setText($addToCartBtn, _config.soldOutBtnLabel);
                $addToCartBtn.prop('disabled',true);
              }
              else {
                _showFeedback('error', response, $addToCartForm);
                $addToCartBtn.prop('disabled', false).removeClass('disabled');
                _setText($addToCartBtn, _config.addToCartBtnLabel);
              }
            }
          });
          return false;
        });
      });
    };
    return {
      init: function(params) {
        params = params || {};
        $.extend(_config, params);
        $(function() {
          _init();
        });
      },
      getConfig: function() {
        return _config;
      }
    }
  })($);
  Shopify.AjaxifyCart.init();
};
theme.wrap_options = function () {
  $(".content iframe[src*='youtube.com']:not('.no-container'),.content iframe[src*='vimeo.com']:not('.no-container')").wrap('<div class="youtube-container" />').addClass('no-container');
  $(".youtube-container:not('.no-container')").append('<div class="fancybox-loading" />').addClass('no-container');
  $("select:not('.no-select')").wrap('<span class="select" />').addClass('no-select');
};
theme.smooth_scroll = function () {
  $('a[href^="#"]').not('.swiper-slide').on('click', function(e) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({scrollTop: $(hash).offset().top}, 900, 'swing', function(){
        window.location.hash = hash;
      });
    }
  });
};
theme.quick_view = function ($container) {
  $(function() {
    $().fancybox({
      selector : '[data-fancybox].quick',
      touch: false,
      afterLoad : function(instance, current) {
        var $container = $('#product-id-product-template-quick');
        theme.product_options($container);
        theme.qtyinput_quantity($container);
        theme.ajax_cart($container);
        theme.wrap_options();
        Shopify.PaymentButton.init($container);
      }
    });
  });
};
theme.swiper_carousel = function ($container) {
  var sectionId = this.sectionId = $container.attr('data-section-id'),
      Carousel = this.Carousel = $('#swiper-carousel-'+sectionId),
      CarouselGrid = this.CarouselGrid = $('#swiper-carousel-'+sectionId+'-grid'),
      pagination = '#swiper-pagination-'+sectionId,
      next = '#swiper-button-next-'+sectionId,
      prev = '#swiper-button-prev-'+sectionId;
  $(function() {
    var mySwiper = new Swiper (Carousel, {
      centeredSlides: true,
      freeMode: true,
      freeModeMomentum: false,
      freeModeMomentumBounce: false,
      grabCursor: true,
      loop: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      slidesPerView: 4,
      breakpoints: {
        600: {
          slidesPerView: 2
        }
      },
    });
  });
  //  Based on: https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
  $(CarouselGrid).each(function () {
    const breakpoint = window.matchMedia( '(min-width:601px)' );
    let myGridSwiper;
    const breakpointChecker = function() {
      if ( breakpoint.matches === true ) {
        CarouselGrid.removeClass('swiper-enabled')
        if ( myGridSwiper !== undefined ) myGridSwiper.destroy( true, true );
        return;
      } else if ( breakpoint.matches === false ) {
        CarouselGrid.addClass('swiper-enabled')
        return enableSwiper();
      }
    };
    const enableSwiper = function() {
      CarouselGrid.addClass('swiper-enabled');
      $(function() {
        myGridSwiper = new Swiper (CarouselGrid, {
          centeredSlides: true,
          freeMode: true,
          freeModeMomentum: false,
          freeModeMomentumBounce: false,
          grabCursor: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          loop: true,
          slidesPerView: 2,
          navigation: {
            nextEl: next,
            prevEl: prev,
          }
        });
      });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  });
};
theme.swiper_carousel_loop = function ($container) {
  var sectionId = this.sectionId = $container.attr('data-section-id');
  $('.product-loop-' + sectionId).each(function () {
    var $loop_container = this.$loop_container = $(this),
        blockId = this.blockId = $loop_container.attr('data-block-id'),
        Carousel = this.Carousel = $('#swiper-carousel-'+blockId),
        CarouselGrid = this.CarouselGrid = $('#swiper-carousel-'+blockId+'-grid'),
        next = '#swiper-button-next-'+blockId,
        prev = '#swiper-button-prev-'+blockId;
    $(function() {
      var mySwiper = new Swiper (Carousel, {
        centeredSlides: true,
        freeMode: true,
        freeModeMomentum: false,
        freeModeMomentumBounce: false,
        grabCursor: true,
        loop: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        slidesPerView: 4,
        breakpoints: {
          600: {
            slidesPerView: 2
          }
        }
      });
    });
    //  Based on: https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
    $(CarouselGrid).each(function () {
      const breakpoint = window.matchMedia( '(min-width:601px)' );
      let myGridSwiper;
      const breakpointChecker = function() {
        if ( breakpoint.matches === true ) {
          if ( myGridSwiper !== undefined ) myGridSwiper.destroy( true, true );
          return;
        } else if ( breakpoint.matches === false ) {
          return enableSwiper();
        }
      };
      const enableSwiper = function() {
        $(function() {
          myGridSwiper= new Swiper (CarouselGrid, {
            centeredSlides: true,
            freeMode: true,
            freeModeMomentum: false,
            freeModeMomentumBounce: false,
            grabCursor: true,
            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },
            loop: true,
            slidesPerView: 2,
            navigation: {
              nextEl: next,
              prevEl: prev,
            }
          });
        });
      };
      breakpoint.addListener(breakpointChecker);
      breakpointChecker();
    });
  });
};
theme.tabs = function ($container) {
  var sectionId = this.sectionId = $container.attr('data-section-id'),
      Carousel = this.Carousel = $('#swiper-tabs-'+sectionId),
      next = '#swiper-button-next-'+sectionId,
      prev = '#swiper-button-prev-'+sectionId;
  $(function() {
    var mySwiper = new Swiper (Carousel, {
      freeMode: true,
      freeModeMomentum: false,
      freeModeMomentumBounce: false,
      grabCursor: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      slidesPerView: 'auto'
    });
  });
  $('.tabs-id-'+sectionId).each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    $(content).find('a,.tabindex').attr('tabindex','0');
    links.not('.first').each(function () {
      $($(this).attr('href')).addClass('hide').attr('aria-hidden','true').find('a,.tabindex').attr('tabindex','-1');
    });
    $(this).find('a').on('click', function(e) {
      e.preventDefault();
      links.removeClass('active');
      content.addClass('hide').find('a,.tabindex').attr('tabindex','-1');
      $('.tab-body-id-'+sectionId).addClass('hide').attr('aria-hidden','true');
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.removeClass('hide').attr('aria-hidden','false').find('a,.tabindex').attr('tabindex','0');
      return false;
    });
    $(this).find('a').on('focus', function(e) {
      links.not('.active').each(function () {
        $($(this).attr('href')).find('.tabindex').attr('tabindex','-1');
      });
    });
  });
};
theme.open_slide = function ($container) {
  var sectionId = this.sectionId = $container.attr('data-section-id');
  var w = $('.content').width();
  $(window).on('resize', function(){
    if (window.innerWidth==w) return;
    w = window.innerWidth;
    if(w > 600) {
      $('.open-slide,.open-slide-bullets').removeClass('active').show();
      $('header .open-slide').removeClass('active').hide();
      $('.open').removeClass('active');
    } else {
      $('.open-slide,.open-slide-bullets').hide();
      $('.open').removeClass('active');
    }
  });
  $('.open-' + sectionId).on('click', function(e) {
    var $btn = $(this),
        $container = $(this).closest('.open-container'),
        $comments = $container.children('.open-slide'),
        $search_field = $container.find('.search-field');
    $comments.stop().slideToggle('fast', function () {
      $comments.toggleClass('active', $btn.is(':visible'));
      $btn.toggleClass('active');
      $search_field.focus();
    });
    e.preventDefault();
  });
};
theme.add_this = function () {
  if (typeof(window.addthis) === 'object' && typeof(window.addthis.layers) === 'function' && typeof(window.addthis.layers.refresh) === 'function') {
    window.addthis.layers.refresh();
  }
};
theme.live_search = function () {
   //  Copyright (c) 2014 Caroline Schnapp (11heavens.com) | Dual licensed under the MIT and GPL licenses: http://www.opensource.org/licenses/mit-license.php & http://www.gnu.org/licenses/gpl.html
   var currentAjaxRequest=null,searchForms=$('form.search-form').css("position","relative").each(function(){var t=$(this).find('input[name="q"]'),e=t.position();$('<ul class="search-results inline unformatted"></ul>').css({position:"absolute",left:"0px"}).appendTo($(this)).hide(),t.attr("autocomplete","off").bind("keyup change",function(){var t=$(this).val(),e="/search?q="+t,a=$(this).closest("form").find(".search-results");t.length>3&&t!=$(this).attr("data-old-term")&&($(this).attr("data-old-term",t),null!=currentAjaxRequest&&currentAjaxRequest.abort(),currentAjaxRequest=$.getJSON(e+"&view=json",function(t){a.empty(),0==t.results_count?a.hide():($.each(t.results,function(t,e){var s=$("<a></a>").attr("href",e.url);e.thumbnail.indexOf("no-image")<=0&&s.append('<span class="thumbnail"><img src="'+e.thumbnail+'" /></span>').addClass('with-image'),s.append('<span class="title">'+e.title+"</span>"),s.wrap('<li class="six relative"></li>'),a.append(s.parent())}),t.results_count>10&&a.append('<li class="see-all twelve text-center"><a href="'+e+'">'+theme.language.general_search_see_results+' ('+t.results_count+")</a></li>"),a.fadeIn(200))}))})});$("body").bind("click",function(){$(".search-results").hide()});
};
theme.recently_viewed = function () {
  Shopify.Products=(function(){var a={howManyToShow:5,howManyToStoreInMemory:5,wrapperId:"recently-viewed-products",templateId:"recently-viewed-product-template",onComplete:null};var c=[];var h=null;var n;var d=null;var e=0;var b={configuration:{expires:90,path:"/",domain:window.location.hostname},name:"shopify_recently_viewed",write:function(i){$.cookie(this.name,i.join(" "),this.configuration)},read:function(){var i=[];var j=$.cookie(this.name);if(j!==null){i=j.split(" ")}return i},destroy:function(){$.cookie(this.name,null,this.configuration)},remove:function(k){var j=this.read();var i=$.inArray(k,j);if(i!==-1){j.splice(i,1);this.write(j)}}};var f=function(){h.addClass('active');if(a.onComplete){try{a.onComplete()}catch(i){}}};var g=function(){if(c.length&&e<a.howManyToShow){$.ajax({dataType:"json",url:"/products/"+c[0]+".js",cache:false,success:function(i){d.tmpl(i).appendTo(n);c.shift();e++;g()},error:function(){b.remove(c[0]);c.shift();g()}})}else{f()}};return{resizeImage:function(m,j){if (m!= null){var img = new Image();img.onload = function() {if (this.height > this.width) {$('img[data-img="' + m + '"]').addClass('vertical');}};img.src = m;if(j==null){return m}if(j=="master"){return m.replace(/http(s)?:/,"")}var i=m.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);if(i!=null){var k=m.split(i[0]);var l=i[0];return(k[0]+"_"+j+l).replace(/http(s)?:/,"")}else{return null}}else{var m = 'https://cdn.shopify.com/s/images/admin/no-image-2048x2048.gif';return m;}},showRecentlyViewed:function(i){var i=i||{};$.extend(a,i);c=b.read();d=$("#"+a.templateId);h=$("#"+a.wrapperId);n=$("#"+a.wrapperId+' .row');a.howManyToShow=Math.min(c.length,a.howManyToShow);if(a.howManyToShow&&d.length&&h.length){g()}},getConfig:function(){return a},clearList:function(){b.destroy()},recordRecentlyViewed:function(l){var l=l||{};$.extend(a,l);var j=b.read();if(window.location.pathname.indexOf("/products/")!==-1){var k=window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];var i=$.inArray(k,j);if(i===-1){j.unshift(k);j=j.splice(0,a.howManyToStoreInMemory)}else{j.splice(i,1);j.unshift(k)}b.write(j)}}}})();
};
theme.HeaderSection = (function() {
  function HeaderSection(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    $(function() {
      $('.toggleMenu').click(function(e) {
        e.preventDefault();
        if(!$(this).hasClass('active')){
          $('.toggleMenu').removeClass('active');
          $('.responsiveMenu').hide().removeClass('active');
          $('body').removeClass('no-scroll');
        }
        $(this).toggleClass('active');
        $('.responsiveMenu').toggle();
        $('body').toggleClass('no-scroll');
        if($('.sticky-navigation-container').hasClass('sticky')){
          var ycoord = $(window).scrollTop();
          if($('body.mobile-only').hasClass('no-scroll')){
            $('.no-scroll .sticky-navigation').data('ycoord',ycoord);
            ycoord = ycoord * -1;
            $('body.mobile-only').css('position','fixed').css('left','0px').css('right','0px').css('top',ycoord + 'px');
          } else {
            $('body.mobile-only').css('position','').css('left','auto').css('right','auto').css('top','auto');
            $(window).scrollTop($('.sticky-navigation').data('ycoord'));
          }
        };
        $('.header-searchbar.open-slide').hide().removeClass('active');
      });
    })
    $(window).bind('resize orientationchange', function() {
      theme.adjustMenu();
    });
    $('.open-' + sectionId).on('click', function(e) {
      var ycoord = $(window).scrollTop();
      $('.toggleMenu').removeClass('active');
      $('.mobile-only .responsiveMenu').hide().removeClass('active');
      if($('body.mobile-only').hasClass('no-scroll')){
        $('body').removeClass('no-scroll');
        $('body.mobile-only').css('position','').css('left','auto').css('right','auto').css('top','auto');
        $(window).scrollTop($('.sticky-navigation').data('ycoord'));
      }
    });
    $('.open-bullets').on('click', function() {
      var $btn = $(this),
          $container = $(this).closest('.open-container-bullets'),
          $comments = $container.find('.open-slide-bullets');
      $comments.stop().slideToggle('fast', function () {
        $comments.toggleClass('active', $btn.is(':visible'));
        $('.open-bullets').toggleClass('active');
      });
    });
    $(function() {
      var a = $('.currencies'),
          g = a.find('select'),
          e = a.find('a'),
          b = a.find('ul'),
          c = b.find('a');
      c.click(function(i) {
        i.stopPropagation();
        e.text($(this).data('symbol')).removeClass('active');
        g.find('option[value="' + $(this).data('code') + '"]').prop('selected', 'selected');
        b.hide();
        g.change();
      });
      $('.currency-selector select').change(function() {
        $('#ajaxBusy').show();
        var form = $(this);
        setTimeout(function() {
          form.parents('form').submit();
        }, 1);
      });
      $('li a,li input').focus( function () {
        if ($(this).parents('li.parent-level').hasClass('isDesktop')) {
          $(this).parents('li.parent-level').addClass('focused').find('ul').attr('aria-hidden','false');
        }
      }).blur(function(){
        $(this).parents('li').removeClass('focused').find('ul').attr('aria-hidden','true');
      }).hover(function () {
        $(this).parents('li').removeClass('focused').find('ul').attr('aria-hidden','true');
      });
    });
    theme.open_slide($container);
    theme.live_search();
    $(window).on('load', function(){
      setTimeout(function(){
        if ( $('body').attr('id') == 'challenge' || location.pathname == '/challenge' ) {
          document.location.hash = 'challenge';
          $('html, body').scrollTop(0);
        }
      }, 150);
    });
    HeaderSection.prototype.onSelect = function(evt) {
      theme.adjustMenu();
    };
  }
  return HeaderSection;
})();
theme.Filter = (function() {
  function Filter(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id'),
        FilterForm = '.filter-form-' + sectionId;
    for (i = 0; i < 4; i++) {
      $(FilterForm + ' #select_' + i).each(function() {
        var g = $(this).find('select'),
            e = $(this).find('a.styledSelect'),
            b = $(this).find('ul.options'),
            c = b.find('a');
        e.click(function(i) {
          i.stopPropagation();
          $('a.styledSelect').not(this).next('ul.options').hide().removeClass('active');
          var $comments = $(this).next(b);
          $comments.stop().slideToggle('fast', function () {
            $(this).toggleClass('active');
          });
        });
        c.click(function(i) {
          i.stopPropagation();
          e.text($(this).text()).removeClass('active');
          g.find('option').prop('selected', false);
          g.find('option[value="' + $(this).attr('rel') + '"][data-id="' + $(this).attr('data-id') + '"]').prop('selected', 'selected');
          b.hide();
          g.change();
        });
        $(document).click(function() {
          e.removeClass('active');
          b.hide()
        })
      })
    };
    $(FilterForm + ' #directory_label_0_' + sectionId).on('change', function(){
      var val = $(this).find('option:selected').val();
      $(FilterForm + ' .tag-filter').removeClass('last');
      $(FilterForm + ' .directory_label_0 .first').removeClass('hidden');
      $(this).addClass('last');
      if (val === '') {
        $(FilterForm + ' span.tag-select').addClass('disabled');
        $(FilterForm + ' .tag-base').val('').attr('disabled', true);
        for (i = 1; i < 4; i++) {
          var select = $(FilterForm + ' .directory_label_' + i + ' .first').attr('data-select');
          $(FilterForm + ' .directory_label_' + i + ' .first').val('').html(select);
        };
      } else {
        $(FilterForm + ' .select .error').hide();
        $(FilterForm + ' span.tag-select').removeClass('disabled').addClass('enabled');
        $(FilterForm + ' .tag-base').val('').attr('disabled', false);
        for (i = 1; i < 4; i++) {
          var group = $(FilterForm + ' .directory_label_' + i + ' .tag-base .item[data-collection='+$(this).find(':selected').attr('data-id')+']').data('group');
          if (group === undefined) {
            $(FilterForm + ' span.directory_label_' + i + '.tag-select').addClass('disabled');
            $(FilterForm + ' .directory_label_' + i + ' .tag-base').val('').attr('disabled', true);
            $(FilterForm + ' .directory_label_' + i + ' .first').val('').html(theme.language.layout_general_unavailable);
            $(FilterForm + ' .directory_label_' + i + ' .styledSelect').attr('data-id', theme.language.layout_general_unavailable);
            } else {
            $(FilterForm + ' .directory_label_' + i + ' .first').val('').html(group + '...');
            $(FilterForm + ' .directory_label_' + i + '.basic .first').html(theme.language.layout_general_next + '...');
            $(FilterForm + ' .directory_label_' + i + ' .styledSelect').attr('data-id', group + '...');
          };
        };
        $(FilterForm + ' .tag-base .item').addClass('hidden');
        $(FilterForm + ' .tag-base .first').addClass('hidden');
        $(FilterForm + ' .tag-base .item[data-collection='+$(this).find(':selected').attr('data-id')+']').removeClass('hidden');
      }
    });
    $(FilterForm + ' .directory_label_1 .tag-base').on('change', function(){
      $(FilterForm + ' .child .tag-base').val('');
      $(FilterForm + ' .infant .tag-base').val('');
      var collval = $(FilterForm + ' #directory_label_0_' + sectionId).find('option:selected').val(),
          idval = $(this).find('option:selected').data('id'),
          idval2 = $(this).find('option:selected').data('id2'),
          idhandle = $(this).find('option:selected').val(),
          filters = [];
          $.each($(FilterForm + ' .tag-filter option:selected'), function(){
            filters.push($(this).val());
          });
      $(FilterForm + ' .tag-filter').removeClass('last');
      $(FilterForm + ' .directory_label_1 .first').removeClass('hidden');
      $(this).addClass('last');
      if ($(this).hasClass('advanced')) {
      var url = (filters.join('').slice(1,-1));
      $.ajax({
        type: 'GET',
        data: {},
        dataType: 'text',
        url: url + '?view=do_not_use',
        async:true,
        success: function(data) {
          var tag_data = data,
              child = FilterForm + ' .child',
              infant = FilterForm + ' .infant';
          $(child + ' .tag-base .item[data-id='+idval+']').each(function() {
            var data_handle = $(this).data('handle');
            if (data.indexOf(data_handle) > -1) {
              $(this).removeClass('hidden');
            } else {
              $(this).addClass('hidden');
            };
          });
          if ($(child + ' .tag-base .item[data-id='+idval+']').not('.hidden').length) {
            var data_group = $(child + ' .tag-base .item[data-id='+idval+']').not('.hidden').data('group');
            $(child + '.tag-select').removeClass('disabled').addClass('enabled');
            $(child + ' .tag-base' ).val('').attr('disabled', false);
            $(child + ' .first').val('').html(data_group + '...');
            $(child + ' .styledSelect').attr('data-id', data_group + '...');
            $(child + ' .first').addClass('hidden');
          } else {
            $(child + ' .tag-base' ).val('').val('').attr('disabled', true);
            $(child + '.tag-select').removeClass('enabled').addClass('disabled');
            $(child + ' .first').val('').html(theme.language.layout_general_unavailable);
            $(child + ' .styledSelect').attr('data-id', theme.language.layout_general_unavailable);
          };
          if ($(infant + ' .tag-base .item[data-id='+idval+']').not('.hidden').length) {
            var data_group = $(infant + ' .tag-base .item[data-id='+idval+']').not('.hidden').data('group');
            $(infant + '.tag-select').removeClass('disabled').addClass('enabled');
            $(infant + ' .tag-base' ).val('').attr('disabled', false);
            $(infant + ' .first').val('').html(data_group + '...');
            $(infant + ' .styledSelect').attr('data-id', data_group + '...');
            $(infant + ' .first').addClass('hidden');
          } else {
            $(infant + ' .tag-base' ).val('').val('').attr('disabled', true);
            $(infant + '.tag-select').removeClass('enabled').addClass('disabled');
            $(infant + ' .first').val('').html(theme.language.layout_general_unavailable);
            $(infant + ' .styledSelect').attr('data-id', theme.language.layout_general_unavailable);
          };
        }
      });
      } else {
        var child = FilterForm + ' .child';
          $(child + ' .tag-base .item[data-id='+idval+']').each(function() {
            if ($(this).data('id2') === idval2) {
              $(this).removeClass('hidden');
            } else {
              $(this).addClass('hidden');
            };
          });
          if ($(child + ' .tag-base .item[data-id='+idval+']').not('.hidden').length) {
            var data_group = $(child + ' .tag-base .item[data-id='+idval+']').not('.hidden').data('group');
            $(child + '.tag-select').removeClass('disabled').addClass('enabled');
            $(child + ' .tag-base' ).val('').attr('disabled', false);
            $(child + ' .first').val('').html(data_group + '...');
            $(child + '.basic .first').html(theme.language.layout_general_next + '...');
            $(child + ' .styledSelect').attr('data-id', data_group + '...');
          } else {
            $(child + ' .tag-base' ).val('').val('').attr('disabled', true);
            $(child + '.tag-select').removeClass('enabled').addClass('disabled');
            $(child + ' .first').val('').html(theme.language.layout_general_unavailable);
            $(child + ' .styledSelect').attr('data-id', theme.language.layout_general_unavailable);
          };
      }
    });
    $(FilterForm + ' .directory_label_2 .tag-base').on('change', function(){
      $(FilterForm + ' .infant .tag-base').val('');
      var collval = $(FilterForm + ' #directory_label_0_' + sectionId).find('option:selected').val(),
          idval = $(this).find('option:selected').data('id'),
          firstidhandle = $(FilterForm + ' .directory_label_1 .tag-base.tag-filter').find('option:selected').val(),
          idhandle = $(this).find('option:selected').val(),
          filters = [];
          $.each($(FilterForm + ' .tag-filter option:selected'), function(){
            filters.push($(this).val());
          });
      $(FilterForm + ' .tag-filter').removeClass('last');
      $(FilterForm + ' .directory_label_2 .first').removeClass('hidden');
      $(this).addClass('last');
      if ($(this).hasClass('advanced')) {
        var url = (filters.join('').slice(1,-1));
        $.ajax({
          type: 'GET',
          data: {},
          dataType: 'text',
          url: url + '?view=do_not_use',
          async:true,
          success: function(data) {
            var tag_data = data,
                infant = FilterForm + ' .infant';
            $(infant + ' .tag-base .item[data-id='+idval+']').each(function() {
              var data_handle = $(this).data('handle');
              if (data.indexOf(data_handle) > -1) {
                $(this).removeClass('hidden');
              } else {
                $(this).addClass('hidden');
              };
            });
            if ($(infant + ' .tag-base .item[data-id='+idval+']').not('.hidden').length) {
              var data_group = $(infant + ' .tag-base .item[data-id='+idval+']').not('.hidden').data('group');
              $(infant + '.tag-select').removeClass('disabled').addClass('enabled');
              $(infant + ' .tag-base' ).val('').attr('disabled', false);
              $(infant + ' .first').val('').html(data_group + '...');
              $(infant + ' .styledSelect').attr('data-id', data_group + '...');
              $(infant + ' .first').addClass('hidden');
            } else {
              $(infant + ' .tag-base' ).val('').val('').attr('disabled', true);
              $(infant + '.tag-select').removeClass('enabled').addClass('disabled');
              $(infant + ' .first').val('').html(theme.language.layout_general_unavailable);
              $(infant + ' .styledSelect').attr('data-id', theme.language.layout_general_unavailable);
            };
          }
        });
      }
    });
    $(FilterForm + ' .directory_label_3 .tag-base').on('change', function(){
      $(FilterForm + ' .directory_label_3 .first').removeClass('hidden');
    });
    $(FilterForm + ' .advanced.btn').click(function(){
      var filters = [];
      $.each($(FilterForm + ' .tag-filter option:selected'), function(){
        filters.push($(this).val());
      });
      if(document.getElementById('directory_label_0_' + sectionId).selectedIndex == 0)
      {
        $(FilterForm + ' .select .error').show();
      } else {
        window.location = (filters.join('').slice(1,-1) + '#collection');
        $(FilterForm + ' .select .error').hide();
      }
    });
    $(FilterForm + ' .basic.btn').click(function(){
      var filters = [];
      $(FilterForm + ' .tag-filter.last option:selected'), function(){
        filters.push($(this).val());
      };
      if(document.getElementById('directory_label_0_' + sectionId).selectedIndex == 0)
      {
        $(FilterForm + ' .select .error').show();
      } else {
        window.location = ($(FilterForm + ' .tag-filter.last option:selected').val() + '#collection');
        $(FilterForm + ' .select .error').hide();
      }
    });
  }
  return Filter;
})();
theme.HomeCollection = (function() {
  function HomeCollection(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.quick_view($container);
    theme.ajax_cart();
    theme.swiper_carousel($container);
  }
  return HomeCollection;
})();
theme.HomeCollectionsList = (function() {
  function HomeCollectionsList(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.swiper_carousel($container);
    HomeCollectionsList.prototype.onBlockSelect = function(evt) {
      var sectionId = this.sectionId,
          mySwiperIndex = $(evt.target).data('swiper-slide-index');
      if ($('#swiper-carousel-'+sectionId).hasClass('swiper-enabled')) {
        var mySwiper = document.querySelector('#swiper-carousel-'+sectionId).swiper;
        mySwiper.slideToLoop(mySwiperIndex, 300);
      } else if ($('#swiper-carousel-'+sectionId+'-grid').hasClass('swiper-enabled')) {
        var mySwiperGrid = document.querySelector('#swiper-carousel-'+sectionId+'-grid').swiper;
        mySwiperGrid.slideToLoop(mySwiperIndex, 300);
      }
    };
  }
  return HomeCollectionsList;
})();
theme.HomeCollectionsGrid = (function() {
  function HomeCollectionsGrid(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.swiper_carousel($container);
    HomeCollectionsGrid.prototype.onBlockSelect = function(evt) {
      var sectionId = this.sectionId,
          mySwiperIndex = $(evt.target).data('swiper-slide-index');
      if ($('#swiper-carousel-'+sectionId+'-grid').hasClass('swiper-enabled')) {
        var mySwiperGrid = document.querySelector('#swiper-carousel-'+sectionId+'-grid').swiper;
        mySwiperGrid.slideToLoop(mySwiperIndex, 300);
      }
    };
  }
  return HomeCollectionsGrid;
})();
theme.HomeCollectionsTabbed = (function() {
  function HomeCollectionsTabbed(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.quick_view($container);
    theme.ajax_cart();
    theme.tabs($container);
    theme.swiper_carousel_loop($container);
    HomeCollectionsTabbed.prototype.onBlockSelect = function(evt) {
      var sectionId = this.sectionId,
          tabActive = $(evt.target),
          tabbodyActive = $(tabActive.attr('href')),
          mySwiperIndex = $(evt.target).data('swiper-slide-index'),
          mySwiper = document.querySelector('#swiper-tabs-'+sectionId).swiper;
      $('#swiper-tabs-'+sectionId+' .title').removeClass('active');
      $('.tab-body-id-'+sectionId).addClass('hide').attr('aria-hidden','true').find('a,.tabindex').attr('tabindex','-1');
      tabActive.addClass('active');
      tabbodyActive.removeClass('hide').attr('aria-hidden','false').find('a,.tabindex').attr('tabindex','0');
      mySwiper.slideTo(mySwiperIndex, 300);
    };
  }
  return HomeCollectionsTabbed;
})();
theme.HomeBlog = (function() {
  function HomeBlog(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.swiper_carousel($container);
  }
  return HomeBlog;
})();
theme.HomeSlideshow = (function() {
  function HomeSlideshow(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id'),
        Carousel = this.Carousel = $('#slideshow-carousel-'+sectionId),
        autorotate = this.autorotate = Carousel.data('swiper-autorotate'),
        pagination = '#swiper-pagination-'+sectionId,
        next = '#swiper-button-next-'+sectionId,
        prev = '#swiper-button-prev-'+sectionId;
    $(function() {
      var mySwiper = new Swiper (Carousel, {
        preloadImages: false,
        lazy: true,
        autoHeight: true,
        centeredSlides: true,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        loop: true,
        autoplay: autorotate,
        speed: 800,
         navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        slidesPerView: 1
      });
    });
    HomeSlideshow.prototype.onBlockSelect = function(evt) {
      var sectionId = this.sectionId,
          mySwiperIndex = $(evt.target).data('swiper-slide-index');
      if ($('#slideshow-'+sectionId).hasClass('swiper-enabled')) {
        var mySwiperGrid = document.querySelector('#slideshow-carousel-'+sectionId).swiper;
        mySwiperGrid.slideToLoop(mySwiperIndex, 300);
      }
    };
  }
  return HomeSlideshow;
})();
theme.HomeMap = (function() {
  var apiStatus = null;
  var mapsToLoad = [];
  function HomeMap(container) {
    var $container = this.$container = $(container),
        map_key = $container.data('section-key');
    if (typeof map_key !== 'string' || map_key === '') {
      return;
    }
    if (apiStatus === 'loaded') {
      var self = this;
      var $script = $('script[src*="' + map_key + '&"]');
      if ($script.length === 0) {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + map_key).then(
          function() {
            apiStatus = 'loaded';
            self.createMap();
          }
        );
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);
      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + map_key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }
  function initAllMaps() {
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }
  function geolocate($map) {
    var deferred = $.Deferred(),
        geocoder = new google.maps.Geocoder(),
        address = $map.data('section-address');
    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }
      deferred.resolve(results);
    });
    return deferred;
  }
  HomeMap.prototype = _.assignIn({}, HomeMap.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-box'),
          map_container = this.$container.find('.map-container'),
          map_loading = this.$container.find('.fancybox-loading'),
          map_zoom = $map.data('section-zoom');
      return geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: map_zoom,
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          },
              map = (this.map = new google.maps.Map($map[0], mapOptions)),
              center = (this.center = map.getCenter()),
              marker = new google.maps.Marker({
                map: map,
                position: center
              });
          google.maps.event.addDomListener(window, 'resize', function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          });
        }.bind(this)
      )
      .fail(function() {
        $(map_container).removeClass('no-background');
        $(map_loading).hide();
      });
    }
  });
  return HomeMap;
})();
theme.HomeInsta = (function() {
  function HomeInsta(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id'),
        userId = $container.data('user-id'),
        accessToken = $container.data('access-token'),
        sortBy = $container.data('sort-by'),
        imgLimit = $container.data('img-limit'),
        imgRes = $container.data('img-res'),
        imgHash = $container.data('img-hash'),
        cols = $container.data('cols');
    $(function() {
      var userFeed = new Instafeed({
        get: 'user',
        userId: userId,
        accessToken: accessToken,
        sortBy: sortBy,
        resolution: imgRes,
        limit: imgLimit,
        filter: function(image) {
          if(!imgHash) {
            return image;
          } else {
            return image.tags.indexOf(imgHash) >= 0;
          }
        },
        target: 'instafeed-' + sectionId,
        success: function(response) {
          $('#instafeed-' + sectionId + '-msg').hide();
          $('#instafeed-' + sectionId + '-grid').hide();
        },
        error: function(response) {
          $('#instafeed-' + sectionId + '-msg').show();
          $('#instafeed-' + sectionId + '-grid').hide();
        },
        template: '<div class="' + cols + ' brands relative bottompad-quarter"><a href="{{link}}" target="_blank"><img src="{{image}}" /><span class="icon icon-instagram insta"></span></a></div>'
      });
      if(userFeed.options.accessToken){
        userFeed.run();
      }
    });
  }
  return HomeInsta;
})();
theme.HomeSearch = (function() {
  function HomeSearch(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
  }
  return HomeSearch;
})();
theme.FooterSection = (function() {
  function FooterSection(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.open_slide($container);
    theme.add_this();
  }
  return FooterSection;
})();
theme.Collection = (function() {
  function Collection(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id'),
        stickyHeight = $('.sticky-navigation-container.sticky').outerHeight();
    if (stickyHeight === undefined) {
      var stickyHeightTotal = 0;
    } else {
      var stickyHeightTotal = stickyHeight;
    }
    var filter = {
      length:function (e) {
        $('.filter ul').each(function() {
          var items = $(this).find('li').length;
          if (items > 5) {
            $('li', this).eq(4).nextAll().hide().addClass('toggleable');
            $(this).append('<li class="open-more-container"><a href="javascript:void(0)" class="open-more" title="Open" aria-controls="Open More" role="button" aria-label="Open">' + theme.language.collections_sidebar_more + '</a></li>');
          }
        });
        $('.filter ul .open-more').on('click', function(e) {
          var $btn = $(this),
              $container = $(this).closest('ul'),
              $top = $(this).closest('.filter'),
              $comments = $container.children('li.toggleable');
          $comments.slideToggle(300);
          if ($(this).hasClass('less')) {
            $(this).text(theme.language.collections_sidebar_more).removeClass('less');
            if($top.position().top < $(window).scrollTop()){
              $('html, body').animate({ scrollTop: $top.offset().top -stickyHeightTotal}, 300);
            }
          } else {
            $(this).text(theme.language.collections_sidebar_less).addClass('less');
          }
          e.preventDefault();
        });
      }
    };
    //	https://gist.github.com/davelowensohn/98b386c58ba09c00fa552e00a47d93ab#file-gistfile1-html-L125
    var check = {
      cart:function (e) {
        $.getJSON('/cart.js', function(response) {
          var items = response.items,
              updateFlag = null;
          for (i = 0, len = items.length; i < len; i++) {
            let thisItem = items[i],
                thisQty = thisItem.quantity,
                thisId = thisItem.id,
                targetInput = $('input#updates_' + thisId) || null;
            if (targetInput.length) {
              targetInput.val(thisQty);
              updateFlag = true;
              $('#error_' + thisId).show().html(theme.language.collections_general_update_cart_label_message);
              $.ajax({
                type: 'GET',
                data: {},
                complete: function (data) {
                  $('#cart-count-desktop').html($('#cart-count-desktop', data.responseText).html());
                  $('#cart-count-mobile').html($('#cart-count-mobile', data.responseText).html());
                  $('.cartCountSelector').html($('.cartCountSelector', data.responseText).html());
                }
              });
            }
          }
          if (updateFlag) {
            $('.add-to-cart').val(theme.language.collections_general_update_cart);
            $('.cart-animation').show().html(theme.language.collections_general_update_cart_message + '&nbsp;<a href="/cart" title="Cart">' + theme.language.products_product_ajax_view + '</a>');
          }
          return;
        });
      }
    };

    // creating a closure to be called from a function that lives outside of theme.Collection
    // this will get called on the Quick Order page after searching
    theme.Collection.checkCart = check.cart;

    var ajaxLightLoadPage = function (url) {
      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        complete: function (data) {
          check.cart();
          $('#cart-count-desktop').html($('#cart-count-desktop', data.responseText).html());
          $('#cart-count-mobile').html($('#cart-count-mobile', data.responseText).html());
          history.replaceState({
            page: url
          }, url, url);
        }
      });
    };
    var order = {
      form:function (e) {
        var btownCartData = JSON.parse($('[data-btown-cart]').text());

        $('form.collection-form[id=add-item-form]').submit(function(e){
          e.preventDefault();
          var total = 0,
              newSurchargeQtyInCart = 0;
          $('input.quantity').each(function(){
            var qty = parseFloat($(this).val());
            total = qty + total;
            if($(this).attr('data-product-type') == 'yes'){
              var variant_id = $(this).attr('id').replace('updates_', '').toString();
              var surchargeItemIndex = btownCartData.variants.indexOf(variant_id);
              if(surchargeItemIndex < 0){
                btownCartData.variants.push(variant_id);
                surchargeItemIndex = btownCartData.variants.indexOf(variant_id);
              }
              btownCartData.quantity[surchargeItemIndex] = qty; // set new quantity for line item
              newSurchargeQtyInCart = calculateTotalInArray(btownCartData.quantity);
            }
          });

          if (total > 0) {
            var updates = {};
            $('input.quantity').each(function() {
              var qty = parseInt($(this).val(), 10) || 0;
              var variantId = $(this).attr('id').replace('updates_', '');
              updates[variantId] = qty;
            });

            var surchargeQty = (newSurchargeQtyInCart == 0 || newSurchargeQtyInCart > SURCHARGE_CUTOFF) ? 0 : 1;
            updates[SURCHARGE_VARIANT_ID] = surchargeQty;

            var payload = {updates: updates};
            if (typeof customerIsProvider !== 'undefined' && customerIsProvider) {
              payload.attributes = {provider_customer: '1'};
            }

            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              contentType: 'application/json',
              dataType: 'json',
              data: JSON.stringify(payload),
              success: function(cart) {
              $('[data-btown-cart]').text(JSON.stringify(btownCartData));
              if (typeof window.ensureProviderCartAttribute === 'function') {
                window.ensureProviderCartAttribute();
              }
              var el = document.getElementById('form-add-to-cart');
              el.value = theme.language.products_product_ajax_adding;
              setTimeout(function(){
                el.value = theme.language.products_product_add_to_cart;
              }, 1000);
              $('#cart-animation').show().html(theme.language.products_product_ajax_added + '&nbsp;<a href="/cart" title="Cart">' + theme.language.products_product_ajax_view + '</a>');
              },
              error: function() {
                var dataToPost = (newSurchargeQtyInCart == 0 || newSurchargeQtyInCart > SURCHARGE_CUTOFF) ? $('form.collection-form[id=add-item-form]').serialize() + '&updates['+SURCHARGE_VARIANT_ID+']=0'
                                                                                                      : $('form.collection-form[id=add-item-form]').serialize() + '&updates['+SURCHARGE_VARIANT_ID+']=1';
                if (typeof customerIsProvider !== 'undefined' && customerIsProvider) {
                  dataToPost += '&attributes[provider_customer]=1';
                }
                $.post($('form.collection-form[id=add-item-form]').attr('action'), dataToPost);
              }
            });
            ajaxLightLoadPage();
          };
        });
      }
    };
    var coll = {
      options:function (e) {
        $('.open-filter').on('click', function() {
          var $btn = $(this),
              $container = $(this).closest('.open-container-filter'),
              $comments = $container.children('.open-slide-filter');
            $comments.stop().slideToggle('fast', function () {
            $comments.toggleClass('active', $btn.is(':visible'));
            $btn.toggleClass('active');
          });
        });
        $('.filter li a')
        .mouseenter(function () {
          $(this).addClass('hover');
        })
        .mouseleave(function() {
          $(this).removeClass('hover');
        });
      }
    };
    var ajaxLoadPage = function (url) {
      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        beforeSend: function () {
          $('#ajaxBusy').show();
        },
        complete: function (data) {
          check.cart();
          $('#collection').html($('#collection', data.responseText).html());
          $('.breadcrumbs').html($('.breadcrumbs', data.responseText).html());
          $('.sortBy').html($('.sortBy', data.responseText).html());
          $('#filters').html($('#filters', data.responseText).html());
          $('#cart-count-desktop').html($('#cart-count-desktop', data.responseText).html());
          $('#cart-count-mobile').html($('#cart-count-mobile', data.responseText).html());
          theme.qtyinput_quantity($container);
          theme.quick_view($container);
          theme.wrap_options();
          filter.length();
          coll.options();
          order.form();
          theme.ajax_cart();
          $('#ajaxBusy').hide();
          history.replaceState({
            page: url
          }, url, url);
          $('#responsiveMenu a').each(function () {
            if (window.location.href.indexOf(this.href) > -1) {
              $(this).addClass('active').attr('aria-current','page')
            } else {
              $(this).removeClass('active').removeAttr('aria-current')
            }
          })
          $('html, body').animate({ scrollTop: $('#collection').offset().top -stickyHeightTotal}, 900);
        }
      });
    };
    filter.length();
    check.cart();
    theme.swiper_carousel($container);
    theme.qtyinput_quantity($container);
    theme.quick_view($container);
    theme.wrap_options();
    theme.open_slide($container);
    theme.smooth_scroll();
    coll.options();
    order.form();
    theme.ajax_cart();
    //	Based on https://vyeung.wordpress.com/2013/09/05/advanced-ajax-shopify-collection-tags-filter/
    var popped = ('state' in window.history && window.history.state !== null),
        initialURL = location.href;
    $(window).bind('popstate', function (e) {
      var initialPop = !popped && location.href == initialURL;
      popped = true;
      if (initialPop) {
        return;
      }
    });
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    $('.sorting').on('change', 'select.sortBy', function(e) {
      Shopify.queryParams.sort_by = $(this).val();
      var targetUrl = '?' + $.param(Shopify.queryParams).replace(/\+/g, '%20');
      ajaxLoadPage(targetUrl);
    });
    $('#filters').on('click', '.paginateBy', function(e) {
      Shopify.queryParams.view = $(this).text();
      var targetUrl = '?' + $.param(Shopify.queryParams).replace(/\+/g, '%20');
      ajaxLoadPage(targetUrl);
    });
    $('#filters').on('click', 'li.advanced-filter a', function (e) {
      e.preventDefault();
      var targetUrl = $(this).attr('href');
      ajaxLoadPage(targetUrl);
    });
    $('#filters').on('change', '.tag-filters select', function(e) {
      e.preventDefault();
      var targetUrl = $(this).val();
      ajaxLoadPage(targetUrl);
    });
    $('#filters').on('change', '.dropdown select', function(e) {
      if ($(this).val()) {
        location.href = $(this).val();
      }
      else {
        location.href = '/collections/all';
      }
    });
  }
  return Collection;
})();
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id'),
        productId = this.productId = $container.attr('data-product-id');
    Shopify.Products.recordRecentlyViewed();
    theme.product_options($container);
    theme.qtyinput_quantity($container);
    theme.swiper_carousel($container);
    theme.swiper_carousel_loop($container);
    theme.quick_view($container);
    theme.ajax_cart();
    theme.wrap_options();
    theme.smooth_scroll();
    theme.tabs($container);
    theme.add_this();
    var loadProductRecommendationsIntoSection = function() {
      var productRecommendationsSection = document.querySelector('.product-recommendations');
      if (productRecommendationsSection === null) {
        $('.loading').addClass('hidden');
        $('.related-product-loop').removeClass('hidden');
        return;
      }
      var productId = productRecommendationsSection.dataset.productId;
      var limit = productRecommendationsSection.dataset.limit;
      var requestUrl = '/recommendations/products?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;
      var request = new XMLHttpRequest();
      request.open('GET', requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement('div');
          container.innerHTML = request.response;
          productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML;
          if (productRecommendationsSection.children.length < 2) {
            $('#recommended').addClass('hidden')
          }
          $('.loading').addClass('hidden');
          $('.related-product-loop').removeClass('hidden');
          theme.swiper_carousel_loop($container);
        }
      };
      request.send();
    };
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === 'product-recommendations') {
        loadProductRecommendationsIntoSection();
      }
    });
    loadProductRecommendationsIntoSection();
    Product.prototype.onBlockSelect = function(evt) {
      $('.title').removeClass('active');
      $('.tab-body').addClass('hide').attr('aria-hidden','true').find('a,.tabindex').attr('tabindex','-1');
      var sectionId = this.sectionId,
          tab = $(evt.target).attr('aria-controls',evt.detail.blockId),
          tabbody = $(tab.attr('href')),
          mySwiperIndex = $(evt.target).data('swiper-slide-index'),
          mySwiper = document.querySelector('#swiper-tabs-'+sectionId).swiper;
      tab.addClass('active');
      tabbody.removeClass('hide').attr('aria-hidden','false').find('a,.tabindex').attr('tabindex','0');
      mySwiper.slideTo(mySwiperIndex, 300);
    };
  }
  return Product;
})();
theme.Cart = (function() {
  function findProviderPriceCents(tags, sku) {
    if (!tags || !sku) {
      return null;
    }

    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      if (tag.indexOf('provider--') !== 0) {
        continue;
      }

      var parts = tag.split('--');
      if (parts.length !== 3 || parts[1] !== sku) {
        continue;
      }

      var price = parseFloat(parts[2]);
      if (!isFinite(price)) {
        continue;
      }

      return Math.round(price * 100);
    }

    return null;
  }

  function resolveMissingProviderCartRows(done) {
    if (typeof customerIsProvider === 'undefined' || !customerIsProvider) {
      if (done) {
        done();
      }
      return;
    }

    var $rows = $('.item-row.product-id').filter(function() {
      return $(this).find('.cart-practitioner-price').length === 0;
    });

    if (!$rows.length) {
      if (done) {
        done();
      }
      return;
    }

    var pending = 0;

    $rows.each(function() {
      var $row = $(this);
      var href = $row.find('a[href*="/products/"]').first().attr('href');
      if (!href) {
        return;
      }

      var handle = href.split('/products/')[1];
      if (!handle) {
        return;
      }

      handle = handle.split('?')[0].split('#')[0];
      var sku = $row.find('.item-qty').attr('data-product-sku');
      var qty = parseInt($row.find('.item-qty').val(), 10) || 1;
      pending += 1;

      $.getJSON('/products/' + handle + '.js').done(function(product) {
        var variant = null;
        var unitCents = null;

        if (sku) {
          for (var v = 0; v < product.variants.length; v++) {
            if (product.variants[v].sku === sku) {
              variant = product.variants[v];
              break;
            }
          }
        }

        if (!variant && product.variants.length) {
          variant = product.variants[0];
          sku = variant.sku;
        }

        if (variant && sku) {
          unitCents = findProviderPriceCents(product.tags, sku);
        }

        if (unitCents !== null && variant) {
          $row.append(
            '<span class="cart-practitioner-price" style="display:none"' +
            ' data-practitioner-price="' + unitCents + '"' +
            ' data-quantity="' + qty + '"' +
            ' data-retail-unit="' + variant.price + '"' +
            ' data-retail-line="' + (variant.price * qty) + '"></span>'
          );
        }
      }).always(function() {
        pending -= 1;
        if (pending <= 0 && done) {
          done();
        }
      });
    });

    if (pending === 0 && done) {
      done();
    }
  }

  function applyProviderCartPricing() {
    if (typeof customerIsProvider === 'undefined' || !customerIsProvider) {
      return;
    }

    var providerTotal = 0;
    var hasProviderPricing = false;

    $('.item-row.product-id').each(function() {
      var $row = $(this);
      var $data = $row.find('.cart-practitioner-price').first();

      if (!$data.length) {
        return;
      }

      hasProviderPricing = true;
      var unitCents = parseInt($data.data('practitionerPrice'), 10);
      var qty = parseInt($data.data('quantity'), 10) || 1;
      var retailUnitCents = parseInt($data.data('retailUnit'), 10) || 0;
      var retailLineCents = parseInt($data.data('retailLine'), 10) || 0;
      var lineCents = unitCents * qty;
      providerTotal += lineCents;

      var unitHtml =
        '<span class="wholesale-price--form-row">' + Shopify.formatMoney(unitCents, theme.moneyFormat) + '</span>' +
        '<span class="product-price product-price--form-row">' + Shopify.formatMoney(retailUnitCents, theme.moneyFormat) + '</span>';
      var lineHtml =
        Shopify.formatMoney(lineCents, theme.moneyFormat) + ' <del>' + Shopify.formatMoney(retailLineCents, theme.moneyFormat) + '</del>';

      $row.find('.price-preview-hidden .offers .price-field').html(unitHtml);
      $row.find('.offers.hidden .price-field').first().html(unitHtml);
      $row.find('.total-item-hidden h5').html('<span class="total-item">' + lineHtml + '</span>');
      $row.find('h5.hidden.total-item').html("total: " + '<span class="total-item">' + lineHtml + '</span>');
    });

    if (hasProviderPricing) {
      $('#total-cart-top, #total-cart-bottom').html(Shopify.formatMoney(providerTotal, theme.moneyFormat));
    }
  }

  function parseMoneyToCents(text) {
    var digits = String(text || '').replace(/[^\d.]/g, '');
    var amount = parseFloat(digits);
    if (!isFinite(amount)) {
      return 0;
    }
    return Math.round(amount * 100);
  }

  function Cart(container) {
    var btownCartData = JSON.parse($('[data-btown-cart]').text());
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.qtyinput_quantity($container);
    Shopify.Products.showRecentlyViewed()
    theme.recently_viewed();
    resolveMissingProviderCartRows(applyProviderCartPricing);
    if (typeof window.ensureProviderCartAttribute === 'function') {
      window.ensureProviderCartAttribute();
    }
    function colour(e) {
      e.preventDefault();
      var this_item = $(this).closest('.item'),
          variant_id = this_item.data('product-id'),
          qty =  this_item.find('.item-qty').val(),
          this_item_total = this_item.find('.total-price-item'),
          this_item_sale = this_item.find('.total-sale-item'),
          this_item_compare = this_item.find('.total-sale-item').data('sale'),
          this_item_discount = this_item.find('.total-discount-item'),
          this_item_line_discount = this_item.find('.discount-amt'),
          cartCountSelector = $('.cartCountSelector'),
          cartTotalSelector = $('.cartTotalSelector');
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: qty,
          id: variant_id
        },
        success: function(cart) {
          var surchargeItemIndex = btownCartData.variants.indexOf(variant_id.toString());
          if(surchargeItemIndex >= 0){
            btownCartData.quantity[surchargeItemIndex] = qty; // set new quantity for line item
            newSurchargeQtyInCart = calculateTotalInArray(btownCartData.quantity);
            var surchargeProductQty = (newSurchargeQtyInCart == 0 || newSurchargeQtyInCart > SURCHARGE_CUTOFF) ? 0 : 1;
            updateSurchargeProduct(surchargeProductQty);
          }
          var $shop_currency = '';
          var value = $(cartCountSelector).html(),
          ajaxLoadPage = function (url) {
            $.ajax({
              type: 'GET',
              url: url || window.location.pathname + window.location.search,
              data: {},
              complete: function (data) {
                $('#cart-count-desktop').html($('#cart-count-desktop', data.responseText).html());
                $('#cart-count-mobile').html($('#cart-count-mobile', data.responseText).html());
                $('#cart-table').html($('#cart-table', data.responseText).html());
                theme.qtyinput_quantity($container);
                resolveMissingProviderCartRows(applyProviderCartPricing);
                if (typeof window.ensureProviderCartAttribute === 'function') {
                  window.ensureProviderCartAttribute();
                }
                history.replaceState({
                  page: url
                }, url, url);
              }
            });
          }
          ajaxLoadPage(window.location.pathname + window.location.search);

          if (qty != '') {
            if (qty == 0) {
              ajaxLoadPage();
              this_item.remove();
              if (cart.item_count == 0) {
                $('#cart-table .form').remove();
                $('#cart-table .empty-form').removeClass('hidden');
                $(cartCountSelector).addClass('hidden');
              }
            } else {
              ajaxLoadPage();
              $.each(cart.items,function(index,row) {
                if ( variant_id == row.key ) {
                  if ((this_item_compare * row.quantity) > row.final_line_price) {
                    this_item_sale.html(Shopify.formatMoney(row.final_line_price, theme.moneyFormat) + ' <del>' + Shopify.formatMoney(this_item_compare * row.quantity, theme.moneyFormat) + '</del>');
                  } else if (row.original_line_price != row.final_line_price) {
                    this_item_discount.html(Shopify.formatMoney(row.final_line_price, theme.moneyFormat) + ' <del>' + Shopify.formatMoney(row.original_line_price, theme.moneyFormat) + '</del>');
                    this_item_line_discount.html('...');
                    $('.discount-cart').html('...');
                  } else {
                    this_item_total.html(Shopify.formatMoney(row.original_line_price, theme.moneyFormat));
                  }
                }
              });
            }
          }
          if (cartCountSelector && $(cartCountSelector).length) {
            var value = $(cartCountSelector).html() || '0';
            $(cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count));
          }
          if (cartTotalSelector && $(cartTotalSelector).length) {
            if (typeof customerIsProvider === 'undefined' || !customerIsProvider) {
              if (typeof Currency !== 'undefined' && typeof Currency.moneyFormats !== 'undefined') {
                var newCurrency = '';
                if ($('[name="currencies"]').length) {
                  newCurrency = $('[name="currencies"]').val();
                }
                else if ($('#currencies span.selected').length) {
                  newCurrency = $('#currencies span.selected').attr('data-currency');
                }
                if (newCurrency) {
                  $(cartTotalSelector).html('<span class=money>' + Shopify.formatMoney(Currency.convert(cart.total_price, $shop_currency, newCurrency).replace(/((\,00)|(\.00))$/g, ''), Currency.money_format[newCurrency]) + '</span>');
                }
                else {
                  $(cartTotalSelector).html(Shopify.formatMoney(cart.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
                }
              }
              else {
                $(cartTotalSelector).html(Shopify.formatMoney(cart.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
              }
            }
          };
          if (typeof customerIsProvider === 'undefined' || !customerIsProvider) {
            $('#total-cart-top,#total-cart-bottom').html(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
          } else {
            applyProviderCartPricing();
          }
          $('#cart-total').html(Shopify.formatMoney(cart.original_total_price, theme.moneyFormat));
          $('.discount-cart').html('...');
        }
      });
    }
    function updateSurchargeProduct(quantity){
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data:      'updates['+SURCHARGE_VARIANT_ID+']='+quantity,
        dataType: 'json',
        success: function () {
        },
        error: function (request, status, error) {
            console.log(error);
        }
      });
    }
    $('#cart-table').on('change, mouseup, keyup', '.item-qty', colour).on('change, click', '.qtybtn', colour);
  }
  return Cart;
})();
theme.Blog = (function() {
  function Blog(container) {
    theme.add_this();
  }
  return Blog;
})();
theme.Contact = (function() {
  function Contact(container) {
    var form_send = theme.language.contact_form_send;
    $('#honeypot').html('<input class="btn standard-width bottompad" type="submit" value="' + theme.language.contact_form_send + '" id="contactFormSubmit" />');
    $('form').submit(function() {
      if ($('input[type="text"]#contactFormNumber').val().length > 0) {
        return false;
      }
    });
  }
  return Contact;
})();
theme.Password = (function() {
  function Password(container) {
    let vh = window.innerHeight;
    $('.password,.password-page').css({ height: vh + 'px' });
    $(window).bind('resize orientationchange', function() {
      let vh = window.innerHeight;
    $('.password,.password-page').css({ height: vh + 'px' });
    });
    theme.add_this();
  }
  return Password;
})();
theme.NotFound = (function() {
  function NotFound(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $container.attr('data-section-id');
    theme.swiper_carousel_loop($container);
    theme.quick_view($container);
  }
  return NotFound;
})();
$(function() {
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('filter-section', theme.Filter);
  sections.register('home-collection', theme.HomeCollection);
  sections.register('home-collections-list', theme.HomeCollectionsList);
  sections.register('home-collections-grid', theme.HomeCollectionsGrid);
  sections.register('home-collections-tabbed', theme.HomeCollectionsTabbed);
  sections.register('home-blog-list', theme.HomeBlog);
  sections.register('home-slideshow', theme.HomeSlideshow);
  sections.register('home-map', theme.HomeMap);
  sections.register('home-insta', theme.HomeInsta);
  sections.register('home-search', theme.HomeSearch);
  sections.register('footer-section', theme.FooterSection);
  sections.register('collection-page', theme.Collection);
  sections.register('product-page', theme.Product);
  sections.register('cart-page', theme.Cart);
  sections.register('blog-page', theme.Blog);
  sections.register('page-contact', theme.Contact);
  sections.register('password-page', theme.Password);
  sections.register('error-page', theme.NotFound);
  $('form').each(function() {
   $(this).validate();
  });
  function addLoadEvent(func) {var oldonload = window.onload;if (typeof window.onload != 'function') {window.onload = func;} else {window.onload = function() {if (oldonload) {oldonload();}func();}}}addLoadEvent(function(){outdatedBrowser({bgColor: '#900',color: '#ffffff',lowerThan: 'transform',languagePath: ''})});
  theme.smooth_scroll();
  theme.wrap_options();
});
theme.adjustMenu();
theme.recently_viewed();
theme.customerTemplates = (function() {
  function toggleRecoverPasswordForm() {
    $('#recover_password').toggleClass('hidden');
    $('#customer_login').toggleClass('hidden');
  }
  function initEventListeners() {
    $('#recover_password_btn,#customer_login_btn').on('click', function(e) {
      e.preventDefault();
      toggleRecoverPasswordForm();
    });
  }
  function resetPasswordSuccess() {
    if ($('#recover-email').hasClass('reset-success')) {
      $('#resetSuccess').removeClass('hidden');
    }
    if ($('#recover-email').hasClass('reset-error')) {
      $('#recover_password').removeClass('hidden');
      $('#customer_login').addClass('hidden');
    };
  }
  function customerAddressForm() {
    var $newAddressForm = $('#add_address');
    if (!$newAddressForm.length) {
      return;
    }
    if (Shopify) {
      new Shopify.CountryProvinceSelector(
        'address_country_new',
        'address_province_new',
        {
          hideElement: 'address_province_container_new'
        }
      );
    }
    $('.address_country_option').each(function() {
      var formId = $(this).data('form-id'),
          countrySelector = 'address_country_' + formId,
          provinceSelector = 'address_province_' + formId,
          containerSelector = 'address_province_container_' + formId;
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
  }
  return {
    init: function() {
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();
theme.init = function() {
   theme.customerTemplates.init();
}
$(theme.init);
//	Cookie plugin | Copyright (c) 2006 Klaus Hartl (stilbuero.de) | Dual licensed under the MIT and GPL licenses: http://www.opensource.org/licenses/mit-license.php & http://www.gnu.org/licenses/gpl.html
jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};
//	Zoom 1.7.20 | license: MIT | http://www.jacklmoore.com/zoom
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,r,a,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(a=c,r=u):(a=d.outerWidth(),r=d.outerHeight()),m=(e.width-c)/a,l=(e.height-u)/r,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,r),0),t=Math.max(Math.min(t,a),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),r=document.createElement("img"),a=o(r),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,r.onload=null,a.remove()}.bind(this,i.style.position,i.style.overflow)),r.onload=function(){function t(t){f.init(),f.move(t),a.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(r):!1)}function n(){a.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(r):!1)}var f=o.zoom(i,u,r,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(r)},r.setAttribute("role","presentation"),r.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);
//	jQuery Validation Plugin - v1.18.0 - 9/9/2018 | https://jqueryvalidation.org/ | Copyright (c) 2018 Jörn Zaefferer | Licensed MIT
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.on("click.validate",":submit",function(b){c.submitButton=b.currentTarget,a(this).hasClass("cancel")&&(c.cancelSubmit=!0),void 0!==a(this).attr("formnovalidate")&&(c.cancelSubmit=!0)}),this.on("submit.validate",function(b){function d(){var d,e;return c.submitButton&&(c.settings.submitHandler||c.formSubmitted)&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)),!(c.settings.submitHandler&&!c.settings.debug)||(e=c.settings.submitHandler.call(c,c.currentForm,b),d&&d.remove(),void 0!==e&&e)}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){var b,c,d;return a(this[0]).is("form")?b=this.validate().form():(d=[],b=!0,c=a(this[0].form).validate(),this.each(function(){b=c.element(this)&&b,b||(d=d.concat(c.errorList))}),c.errorList=d),b},rules:function(b,c){var d,e,f,g,h,i,j=this[0];if(null!=j&&(!j.form&&j.isContentEditable&&(j.form=this.closest("form")[0],j.name=this.attr("name")),null!=j.form)){if(b)switch(d=a.data(j.form,"validator").settings,e=d.rules,f=a.validator.staticRules(j),b){case"add":a.extend(f,a.validator.normalizeRule(c)),delete f.messages,e[j.name]=f,c.messages&&(d.messages[j.name]=a.extend(d.messages[j.name],c.messages));break;case"remove":return c?(i={},a.each(c.split(/\s/),function(a,b){i[b]=f[b],delete f[b]}),i):(delete e[j.name],f)}return g=a.validator.normalizeRules(a.extend({},a.validator.classRules(j),a.validator.attributeRules(j),a.validator.dataRules(j),a.validator.staticRules(j)),j),g.required&&(h=g.required,delete g.required,g=a.extend({required:h},g)),g.remote&&(h=g.remote,delete g.remote,g=a.extend(g,{remote:h})),g}}}),a.extend(a.expr.pseudos||a.expr[":"],{blank:function(b){return!a.trim(""+a(b).val())},filled:function(b){var c=a(b).val();return null!==c&&!!a.trim(""+c)},unchecked:function(b){return!a(b).prop("checked")}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:void 0===c?b:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",pendingClass:"pending",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(a)))},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(b,c){var d=[16,17,18,20,35,36,37,38,39,40,45,144,225];9===c.which&&""===this.elementValue(b)||a.inArray(c.keyCode,d)!==-1||(b.name in this.submitted||b.name in this.invalid)&&this.element(b)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d):a(b).addClass(c).removeClass(d)},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d):a(b).removeClass(c).addClass(d)}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:theme.language.general_validation_required,remote:theme.language.general_validation_fix_field,email:theme.language.general_validation_valid_email,url:theme.language.general_validation_valid_url,date:theme.language.general_validation_valid_date,dateISO:theme.language.general_validation_valid_iso,number:theme.language.general_validation_valid_number,digits:theme.language.general_validation_only_digits,equalTo:theme.language.general_validation_same_value,maxlength:a.validator.format(theme.language.general_validation_characters_exceed + " {0}"),minlength:a.validator.format(theme.language.general_validation_characters_min + " {0}"),rangelength:a.validator.format(theme.language.general_validation_characters_range + " {0}-{1}"),range:a.validator.format(theme.language.general_validation_value_range + " {0}-{1}"),max:a.validator.format(theme.language.general_validation_value_less + " {0}"),min:a.validator.format(theme.language.general_validation_value_greater + " {0}"),step:a.validator.format(theme.language.general_validation_multiple + " {0}")},autoCreateRanges:!1,prototype:{init:function(){function b(b){if(!this.form&&this.isContentEditable&&(this.form=a(this).closest("form")[0],this.name=a(this).attr("name")),d===this.form){var c=a.data(this.form,"validator"),e="on"+b.type.replace(/^validate/,""),f=c.settings;f[e]&&!a(this).is(f.ignore)&&f[e].call(c,this,b)}}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c,d=this.currentForm,e=this.groups={};a.each(this.settings.groups,function(b,c){"string"==typeof c&&(c=c.split(/\s/)),a.each(c,function(a,c){e[c]=b})}),c=this.settings.rules,a.each(c,function(b,d){c[b]=a.validator.normalizeRule(d)}),a(this.currentForm).on("focusin.validate focusout.validate keyup.validate",":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']",b).on("click.validate","select, option, [type='radio'], [type='checkbox']",b),this.settings.invalidHandler&&a(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler)},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){var c,d,e=this.clean(b),f=this.validationTargetFor(e),g=this,h=!0;return void 0===f?delete this.invalid[e.name]:(this.prepareElement(f),this.currentElements=a(f),d=this.groups[f.name],d&&a.each(this.groups,function(a,b){b===d&&a!==f.name&&(e=g.validationTargetFor(g.clean(g.findByName(a))),e&&e.name in g.invalid&&(g.currentElements.push(e),h=g.check(e)&&h))}),c=this.check(f)!==!1,h=h&&c,c?this.invalid[f.name]=!1:this.invalid[f.name]=!0,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),a(b).attr("aria-invalid",!c)),h},showErrors:function(b){if(b){var c=this;a.extend(this.errorMap,b),this.errorList=a.map(this.errorMap,function(a,b){return{message:a,element:c.findByName(b)[0]}}),this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.invalid={},this.submitted={},this.prepareForm(),this.hideErrors();var b=this.elements().removeData("previousValue").removeAttr("aria-invalid");this.resetElements(b)},resetElements:function(a){var b;if(this.settings.unhighlight)for(b=0;a[b];b++)this.settings.unhighlight.call(this,a[b],this.settings.errorClass,""),this.findByName(a[b].name).removeClass(this.settings.validClass);else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b,c=0;for(b in a)void 0!==a[b]&&null!==a[b]&&a[b]!==!1&&c++;return c},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(a){a.not(this.containers).text(""),this.addWrapper(a).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function(){var d=this.name||a(this).attr("name");return!d&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.isContentEditable&&(this.form=a(this).closest("form")[0],this.name=d),this.form===b.currentForm&&(!(d in c||!b.objectLength(a(this).rules()))&&(c[d]=!0,!0))})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.split(" ").join(".");return a(this.settings.errorElement+"."+b,this.errorContext)},resetInternals:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([])},reset:function(){this.resetInternals(),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c,d,e=a(b),f=b.type;return"radio"===f||"checkbox"===f?this.findByName(b.name).filter(":checked").val():"number"===f&&"undefined"!=typeof b.validity?b.validity.badInput?"NaN":e.val():(c=b.isContentEditable?e.text():e.val(),"file"===f?"C:\\fakepath\\"===c.substr(0,12)?c.substr(12):(d=c.lastIndexOf("/"),d>=0?c.substr(d+1):(d=c.lastIndexOf("\\"),d>=0?c.substr(d+1):c)):"string"==typeof c?c.replace(/\r/g,""):c)},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d,e,f,g=a(b).rules(),h=a.map(g,function(a,b){return b}).length,i=!1,j=this.elementValue(b);"function"==typeof g.normalizer?f=g.normalizer:"function"==typeof this.settings.normalizer&&(f=this.settings.normalizer),f&&(j=f.call(b,j),delete g.normalizer);for(d in g){e={method:d,parameters:g[d]};try{if(c=a.validator.methods[d].call(this,j,b,e.parameters),"dependency-mismatch"===c&&1===h){i=!0;continue}if(i=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,e),!1}catch(k){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+b.id+", check the '"+e.method+"' method.",k),k instanceof TypeError&&(k.message+=".  Exception occurred when checking element "+b.id+", check the '"+e.method+"' method."),k}}if(!i)return this.objectLength(g)&&this.successList.push(b),!0},customDataMessage:function(b,c){return a(b).data("msg"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase())||a(b).data("msg")},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a]},defaultMessage:function(b,c){"string"==typeof c&&(c={method:c});var d=this.findDefined(this.customMessage(b.name,c.method),this.customDataMessage(b,c.method),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c.method],"<strong>Warning: No message defined for "+b.name+"</strong>"),e=/\$?\{(\d+)\}/g;return"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),d},formatAndAdd:function(a,b){var c=this.defaultMessage(a,b);this.errorList.push({message:c,element:a,method:b.method}),this.errorMap[a.name]=c,this.submitted[a.name]=c},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b,c;for(a=0;this.errorList[a];a++)c=this.errorList[a],this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d,e,f,g,h=this.errorsFor(b),i=this.idOrName(b),j=a(b).attr("aria-describedby");h.length?(h.removeClass(this.settings.validClass).addClass(this.settings.errorClass),h.html(c)):(h=a("<"+this.settings.errorElement+">").attr("id",i+"-error").addClass(this.settings.errorClass).html(c||""),d=h,this.settings.wrapper&&(d=h.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(d):this.settings.errorPlacement?this.settings.errorPlacement.call(this,d,a(b)):d.insertAfter(b),h.is("label")?h.attr("for",i):0===h.parents("label[for='"+this.escapeCssMeta(i)+"']").length&&(f=h.attr("id"),j?j.match(new RegExp("\\b"+this.escapeCssMeta(f)+"\\b"))||(j+=" "+f):j=f,a(b).attr("aria-describedby",j),e=this.groups[b.name],e&&(g=this,a.each(g.groups,function(b,c){c===e&&a("[name='"+g.escapeCssMeta(b)+"']",g.currentForm).attr("aria-describedby",h.attr("id"))})))),!c&&this.settings.success&&(h.text(""),"string"==typeof this.settings.success?h.addClass(this.settings.success):this.settings.success(h,b)),this.toShow=this.toShow.add(h)},errorsFor:function(b){var c=this.escapeCssMeta(this.idOrName(b)),d=a(b).attr("aria-describedby"),e="label[for='"+c+"'], label[for='"+c+"'] *";return d&&(e=e+", #"+this.escapeCssMeta(d).replace(/\s+/g,", #")),this.errors().filter(e)},escapeCssMeta:function(a){return a.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g,"\\$1")},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(b){return this.checkable(b)&&(b=this.findByName(b.name)),a(b).not(this.settings.ignore)[0]},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+this.escapeCssMeta(b)+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return!this.dependTypes[typeof a]||this.dependTypes[typeof a](a,b)},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(b){this.pending[b.name]||(this.pendingRequest++,a(b).addClass(this.settings.pendingClass),this.pending[b.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],a(b).removeClass(this.settings.pendingClass),c&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(a(this.currentForm).submit(),this.submitButton&&a("input:hidden[name='"+this.submitButton.name+"']",this.currentForm).remove(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b,c){return c="string"==typeof c&&c||"remote",a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,{method:c})})},destroy:function(){this.resetForm(),a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur").find(".validate-lessThan-blur").off(".validate-lessThan").removeClass("validate-lessThan-blur").find(".validate-lessThanEqual-blur").off(".validate-lessThanEqual").removeClass("validate-lessThanEqual-blur").find(".validate-greaterThanEqual-blur").off(".validate-greaterThanEqual").removeClass("validate-greaterThanEqual-blur").find(".validate-greaterThan-blur").off(".validate-greaterThan").removeClass("validate-greaterThan-blur")}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},normalizeAttributeRule:function(a,b,c,d){/min|max|step/.test(c)&&(null===b||/number|range|text/.test(b))&&(d=Number(d),isNaN(d)&&(d=void 0)),d||0===d?a[c]=d:b===c&&"range"!==b&&(a[c]=!0)},attributeRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)"required"===c?(d=b.getAttribute(c),""===d&&(d=!0),d=!!d):d=f.attr(c),this.normalizeAttributeRule(e,g,c,d);return e.maxlength&&/-1|2147483647|524288/.test(e.maxlength)&&delete e.maxlength,e},dataRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)d=f.data("rule"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase()),""===d&&(d=!0),this.normalizeAttributeRule(e,g,c,d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0===e.param||e.param:(a.data(c.form,"validator").resetElements(a(c)),delete b[d])}}),a.each(b,function(d,e){b[d]=a.isFunction(e)&&"normalizer"!==d?e(c):e}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength","range"],function(){var c;b[this]&&(a.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(c=b[this].replace(/[\[\]]/g,"").split(/[\s,]+/),b[this]=[Number(c[0]),Number(c[1])]))}),a.validator.autoCreateRanges&&(null!=b.min&&null!=b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),null!=b.minlength&&null!=b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:void 0!==b&&null!==b&&b.length>0},email:function(a,b){return this.optional(b)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a)},url:function(a,b){return this.optional(b)||/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(a)},date:function(){var a=!1;return function(b,c){return a||(a=!0,this.settings.debug&&window.console&&console.warn("The `date` method is deprecated and will be removed in version '2.0.0'.\nPlease don't use it, since it relies on the Date constructor, which\nbehaves very differently across browsers and locales. Use `dateISO`\ninstead or one of the locale specific methods in `localizations/`\nand `additional-methods.js`.")),this.optional(c)||!/Invalid|NaN/.test(new Date(b).toString())}}(),dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a)},number:function(a,b){return this.optional(b)||/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},minlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d},maxlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e<=d},rangelength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d[0]&&e<=d[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||a<=c},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},step:function(b,c,d){var e,f=a(c).attr("type"),g="Step attribute on input type "+f+" is not supported.",h=["text","number","range"],i=new RegExp("\\b"+f+"\\b"),j=f&&!i.test(h.join()),k=function(a){var b=(""+a).match(/(?:\.(\d+))?$/);return b&&b[1]?b[1].length:0},l=function(a){return Math.round(a*Math.pow(10,e))},m=!0;if(j)throw new Error(g);return e=k(d),(k(b)>e||l(b)%l(d)!==0)&&(m=!1),this.optional(c)||m},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.not(".validate-equalTo-blur").length&&e.addClass("validate-equalTo-blur").on("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()},remote:function(b,c,d,e){if(this.optional(c))return"dependency-mismatch";e="string"==typeof e&&e||"remote";var f,g,h,i=this.previousValue(c,e);return this.settings.messages[c.name]||(this.settings.messages[c.name]={}),i.originalMessage=i.originalMessage||this.settings.messages[c.name][e],this.settings.messages[c.name][e]=i.message,d="string"==typeof d&&{url:d}||d,h=a.param(a.extend({data:b},d.data)),i.old===h?i.valid:(i.old=h,f=this,this.startRequest(c),g={},g[c.name]=b,a.ajax(a.extend(!0,{mode:"abort",port:"validate"+c.name,dataType:"json",data:g,context:f.currentForm,success:function(a){var d,g,h,j=a===!0||"true"===a;f.settings.messages[c.name][e]=i.originalMessage,j?(h=f.formSubmitted,f.resetInternals(),f.toHide=f.errorsFor(c),f.formSubmitted=h,f.successList.push(c),f.invalid[c.name]=!1,f.showErrors()):(d={},g=a||f.defaultMessage(c,{method:e,parameters:b}),d[c.name]=i.message=g,f.invalid[c.name]=!0,f.showErrors(d)),i.valid=j,f.stopRequest(c,j)}},d)),"pending")}}});var b,c={};return a.ajaxPrefilter?a.ajaxPrefilter(function(a,b,d){var e=a.port;"abort"===a.mode&&(c[e]&&c[e].abort(),c[e]=d)}):(b=a.ajax,a.ajax=function(d){var e=("mode"in d?d:a.ajaxSettings).mode,f=("port"in d?d:a.ajaxSettings).port;return"abort"===e?(c[f]&&c[f].abort(),c[f]=b.apply(this,arguments),c[f]):b.apply(this,arguments)}),a});
//	Outdated Browser | Version: 1.1.2 - 2015 | author: Burocratik | website: http://www.burocratik.com
var outdatedBrowser=function(t){function o(t){s.style.opacity=t/100,s.style.filter="alpha(opacity="+t+")"}function e(t){o(t),1==t&&(s.style.display="block"),100==t&&(u=!0)}function r(){var t=document.getElementById("btnCloseUpdateBrowser"),o=document.getElementById("btnUpdateBrowser");s.style.backgroundColor=bkgColor,s.style.color=txtColor,s.children[0].style.color=txtColor,s.children[1].style.color=txtColor,o.style.color=txtColor,o.style.borderColor&&(o.style.borderColor=txtColor),t.style.color=txtColor,t.onmousedown=function(){return s.style.display="none",!1},o.onmouseover=function(){this.style.color=bkgColor,this.style.backgroundColor=txtColor},o.onmouseout=function(){this.style.color=txtColor,this.style.backgroundColor=bkgColor}}function l(){var t=!1;if(window.XMLHttpRequest)t=new XMLHttpRequest;else if(window.ActiveXObject)try{t=new ActiveXObject("Msxml2.XMLHTTP")}catch(o){try{t=new ActiveXObject("Microsoft.XMLHTTP")}catch(o){t=!1}}return t}function a(t){var o=l();return o&&(o.onreadystatechange=function(){n(o)},o.open("GET",t,!0),o.send(null)),!1}function n(t){var o=document.getElementById("outdated");return 4==t.readyState&&(o.innerHTML=200==t.status||304==t.status?t.responseText:d,r()),!1}var s=document.getElementById("outdated");this.defaultOpts={bgColor:"#f25648",color:"#ffffff",lowerThan:"transform",languagePath:"../outdatedbrowser/lang/en.html"},t?("IE8"==t.lowerThan||"borderSpacing"==t.lowerThan?t.lowerThan="borderSpacing":"IE9"==t.lowerThan||"boxShadow"==t.lowerThan?t.lowerThan="boxShadow":"IE10"==t.lowerThan||"transform"==t.lowerThan||""==t.lowerThan||"undefined"==typeof t.lowerThan?t.lowerThan="transform":("IE11"==t.lowerThan||"borderImage"==t.lowerThan)&&(t.lowerThan="borderImage"),this.defaultOpts.bgColor=t.bgColor,this.defaultOpts.color=t.color,this.defaultOpts.lowerThan=t.lowerThan,this.defaultOpts.languagePath=t.languagePath,bkgColor=this.defaultOpts.bgColor,txtColor=this.defaultOpts.color,cssProp=this.defaultOpts.lowerThan,languagePath=this.defaultOpts.languagePath):(bkgColor=this.defaultOpts.bgColor,txtColor=this.defaultOpts.color,cssProp=this.defaultOpts.lowerThan,languagePath=this.defaultOpts.languagePath);var u=!0,i=function(){var t=document.createElement("div"),o="Khtml Ms O Moz Webkit".split(" "),e=o.length;return function(r){if(r in t.style)return!0;for(r=r.replace(/^[a-z]/,function(t){return t.toUpperCase()});e--;)if(o[e]+r in t.style)return!0;return!1}}();if(!i(""+cssProp)){if(u&&"1"!==s.style.opacity){u=!1;for(var c=1;100>=c;c++)setTimeout(function(t){return function(){e(t)}}(c),8*c)}" "===languagePath||0==languagePath.length?r():a(languagePath);var d='<h6>' + theme.language.general_validation_browser_oodate + '</h6><p>' + theme.language.general_validation_browser_msg +' <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/">' + theme.language.general_validation_browser_update + ' </a></p><p class="last"><a href="#" id="btnCloseUpdateBrowser" title="' + theme.language.general_validation_close + '">&times;</a></p>'}};


// // // // // // // // // // // // // // //
// Quick Order Page Search Functionality  //
// // // // // // // // // // // // // // //

  // store the customer search input
  var customerSearch = {
    input: "",
    anyMatch: false
  }

  // graphQL call to shopify storefront to get product info
  // this is used in a promise chain to recursively get all products from a collection
  function ajaxCall(cursor) {
    // console.log('CURSOR', cursor);

    return $.ajax({
      url : 'https://biotics-research.myshopify.com/api/graphql.json',
      type : 'POST',
      headers: {
        "x-shopify-storefront-access-token": "87e2dbce4bf47fd66a880d5897c44f29",
        "content-type": "application/json"
      },
      data: JSON.stringify({
        query: 'query ($cursor: String) {\n'+
          'collectionByHandle(handle: "quick-order") {\n'+
            'products(first: 25, after: $cursor) {\n'+
              'pageInfo {\n'+
                'hasNextPage\n'+
                'hasPreviousPage\n'+
              '}\n'+
              'edges {\n'+
                'cursor\n'+
                'node {\n'+
                  'title\n'+
                  'handle\n'+
                  'tags\n'+
                  'variants(first: 10) {\n'+
                    'edges {\n'+
                      'node {\n'+
                        'id\n'+
                        'title\n'+
                        'sku\n'+
                        'priceV2 {\n'+
                          'amount\n'+
                        '}\n'+
                        'image {\n'+
                          'altText\n'+
                          'transformedSrc(maxWidth: 200)\n'+
                        '}\n'+
                        'availableForSale\n'+
                      '}\n'+
                    '}\n'+
                  '}\n'+
                '}\n'+
              '}\n'+
            '}\n'+
          '}\n'+
        '}',
        variables: {
          "cursor": cursor
        }
      }),
      error: function(error) {
        console.log("ERROR", error);
      }
    });
  };


  // generates a big chunk of HTML which is used for outputing rows of product info to the page
  function buildProductHtml(product, variantCount, hasMultipleVariants) {
    var decodedId = atob(product.node.variants.edges[variantCount-1].node.id);
    var splitDecoded = decodedId.split("/");
    var id = splitDecoded[splitDecoded.length-1];
    var variantTitle = "";
    var variantTitleCode = "";
    var getVariantPrice = product.node.variants.edges[variantCount-1].node.priceV2.amount;
    var variantPrice = parseFloat(getVariantPrice).toFixed(2);
    var cost = "";
    var costCode = "";
    var quantityCode = "";
    var hasSurcharge = "no";
    var inventoryQty = variantInventory.quantity;
    var inventoryCode = "";

    if (customerIsLoggedIn && customerIsProvider) {
      if (product.node.tags.length > 0) {
        product.node.tags.forEach(function(tag) {
          if (tag.indexOf("provider--") >= 0) {
            var splitTag = tag.split("--");
            if (splitTag.length > 2) {
              var getSku = splitTag[1];
              if(getSku == product.node.variants.edges[variantCount-1].node.sku) {
                var getCost = splitTag[2];
                cost = parseFloat(getCost).toFixed(2);
              }
            };
          };
        });
      };

      if ( toString(cost).length > 0 ) {
        costCode = 
          '<span class="wholesale-price--form-row">$'+cost+'</span>'+
          '<span class="product-price product-price--form-row">$'+variantPrice+'</span>';
      };
    }
    else if (product.node.variants.edges[variantCount-1].node.priceV2.amount > 0) {
      cost = variantPrice;
      costCode = '<span class="variant-price--form-row">$'+cost+'</span>';
    }
    else {
      cost = variantPrice;
      costCode = '<span style="display:none">$'+cost+'</span><span>Free</span>';
    };

    if (hasMultipleVariants) {
      variantTitle = product.node.variants.edges[variantCount-1].node.title;
    };

    if (variantTitle.length > 0) {
      variantTitleCode = 
        ' <div class="item-logistics">'+
        '   <h6>'+
        '     <span class="variants">'+variantTitle+'</span>'+
        '   </h6>'+
        ' </div>';
    };

    if (product.node.tags.length > 0) {
      product.node.tags.forEach(function(tag) {
        if (tag.indexOf("has-surcharge") >= 0) {
          hasSurcharge = "yes";
        };
      });
    };

    if (variantInventory.management == "shopify" && variantInventory.policy != "continue") {
      inventoryCode = 'max="'+inventoryQty+'"';
    }

    if (product.node.variants.edges[variantCount-1].node.availableForSale == true) {
      quantityCode = 
        ' <span class="quantity form">'+
        '   <button type="button" class="icon icon-minus btn qtybtn qtyminus_multi--filtered text-center" field="updates_'+id+'" price-field="price_'+id+'" aria-label="Subtract"></button>'+
        '   <input data-product-type="'+hasSurcharge+'" name="updates['+id+']" onfocus="this.select()" tabindex="1" type="number" inputmode="numeric" pattern="[0-9]*" value="0" min="0" class="quantity field item-qty text-center" field="error_'+id+'" id="updates_'+id+'" '+inventoryCode+'/>'+
        '   <input type="hidden" id="price_'+id+'" class="price-totals" price="'+cost+'" value="0" aria-hidden="true" tabindex="-1" />'+
        '   <button type="button" class="icon icon-plus btn qtybtn qtyplus_multi--filtered text-center" field="updates_'+id+'" price-field="price_'+id+'" aria-label="Add"></button>'+
        '   <label class="stock error hidden" id="error_'+id+'"></label>'+
        ' </span>';
    }
    else {
      quantityCode = 
        ' <h5 class="offers">'+
        '   <span class="price-preview price price-field">'+
        '     Sold Out'+
        '   </span>'+
        ' </h5>';
    };

    var html = 
        '<div id="variant_'+id+'" class="testtest33 item product-id item-row table-center clearfix" field="'+id+'">'+
        ' <div class="product-thumb item-thumb two title-align title-align-left">'+
        '   <div class="relative">'+
        '     <a href="/products/'+product.node.handle+'" title="View the '+product.node.title+'" class="img-align">'+
        '       <img src="'+product.node.variants.edges[variantCount-1].node.image.transformedSrc+'" alt="'+product.node.title+'" class="img-align vertical"'+
        '     </a>'+
        '   </div>'+
        ' </div>'+
        ' <span class="item-details half">'+
        '   <div class="four">'+
        '     <div class="item-title"><h5><a href="/products/'+product.node.handle+'" title="'+product.node.title+'">'+product.node.title+'</a></h5></div>'+
        '       <h5 class="offers hidden">'+
        '         <span class="price-preview price price-field">'+
        '           '+costCode+
        '         </span>'+
        '       </h5>'+
        '     '+variantTitleCode+
        '   </div>'+
        '   <div class="three text-center price-preview-hidden">'+
        '     <h5 class="offers">'+
        '       <span class="price-preview price price-field form-row-price-container">'+
        '         '+costCode+
        '       </span>'+
        '     </h5>'+
        '   </div>'+
        '   <div class="three text-center">'+
        '     '+quantityCode+
        '   </div>'+
        ' </span>'+
        ' <input type="hidden" name="id" value="'+id+'" aria-hidden="true" tabindex="-1">'+
        '</div>';
    
    return html;
  };


  // init a promise for the graphql call
  function getProducts(cursor) {
    return ajaxCall(cursor).then(function(response) {
      // console.log('RESP', response);

      // loop through the array of products returned from the graphQL query response
      response.data.collectionByHandle.products.edges.map(function(product, i) {

        // enter this condition block if product title contains the search input that the customer typed in
        if ( product.node.title.toLowerCase().includes(customerSearch.input) ) {

          // disable loader
          $(".qo-loader-container").hide();

          customerSearch.anyMatch = true;

          // check for multiple variants
          var hasMultipleVariants = product.node.variants.edges.length > 1 ? true : false;

          if (!hasMultipleVariants) {
            // if only one variant, then build the html and then output to the page
            var productHtml = buildProductHtml(product, 1, hasMultipleVariants);
            $('#jshook_products_container').append(productHtml);
          }
          else {

            // if multiple variants, enter this block and loop over them and build the html and then output them to the page

            // set up a counter, containing the number of variants, to be used in the while loop below
            var variantCount = product.node.variants.edges.length;

            while (variantCount > 0) {
              var productHtml = buildProductHtml(product, variantCount, hasMultipleVariants);
              $('#jshook_products_container').append(productHtml);
              variantCount--;
            };
          };
        };
        
      });

      // this condition block is used to recursively call the graphQL query
      // the graphQL query is using pagination, and when it reaches the last page it returns a message to done()
      if (response.data.collectionByHandle.products.pageInfo.hasNextPage == false) {
        // return response.data.collectionByHandle.products.edges;
        return "Products are done loading.";
      }
      else {

        // enable loader
        $(".qo-loader-container").show();

        // if there are still more pages to paginate through then recursively call the query
        var cursor = response.data.collectionByHandle.products.edges[response.data.collectionByHandle.products.edges.length-1].cursor;
        return getProducts(cursor);
      }
    });
  };


  // create a promise
  function getAllProducts() {
    return getProducts();
  };


  function validInput(searchInput) {
    // console.log('INPUT', textInput);
    var valid = true;
    // get input field and check
    return valid;
  };

  function showErrorMessage() {
    // we can add a customizer setting for custom message 
  };



  $(document).ready(function() {

    // $('#quick_order_search_form').submit(function(event) {
    //   event.preventDefault();

    //   // grab the input that the customer entered itno the search field
    //   var searchInput = $('#search_input').val();
    //   customerSearch.input = searchInput.toLowerCase();

    //   // do search if valid input
    //   if( validInput(searchInput) ) {

    //     // remove pagination
    //     $("#jshook-pagination").remove();

    //     // remove products
    //     $('#jshook_products_container').empty();

    //     // enable loader
    //     $(".qo-loader-container").show();

    //     // last step in the pomise chain
    //     getAllProducts().done(function(data) {
    //       // console.log(data);

    //       if (!customerSearch.anyMatch) {

    //         // disable loader
    //         $(".qo-loader-container").hide();

    //         $("#jshook_products_container").html("<p style='text-align: center; padding: 35px 7px;'>No product titles match what you searched for. Please search again.</p>");
    //       }
    //       else {

    //         // disable loader
    //         $(".qo-loader-container").hide();

    //         // call nested function inside of theme.Collection() to update UI with cart quantity and tooltip
    //         theme.Collection.checkCart();

    //         // reset customer search flag
    //         customerSearch.anyMatch = false;
    //       };
    //     });
    //   }
    //   // else show some error message
    //   else{
    //     showErrorMessage();
    //   };
    // });
    if (window.location.pathname.indexOf('/collections/quick-order') !== -1 || window.location.pathname.indexOf('/collections/shop') !== -1) {
      return;
    }

    $('#quick_order_search_form').submit(function(event) {
    event.preventDefault();

    // Get the value of the search input and convert it to lowercase
      var searchInput = $('#search_input').val().toLowerCase().replace(/[^\w\d]/g, ''); 
      $("#jshook_products_container").find('.errorProductSearch').hide();
    var dataSearch = $(document).find('.product-id[datatitle*="'+ searchInput +'"]').length;
    $("#jshook-pagination").hide();
   // enable loader
      $(".qo-loader-container").show();
    setTimeout(function() {
   // disable loader
        $(".qo-loader-container").hide();
      }, 1500);
    // Remove the 'active' class from all elements with the class 'product-id'
    $('.bioticsItem').removeClass('active').hide();
    if(dataSearch > 0){  
    // Find the element with the matching datatitle and add the 'active' class
    $(document).find('.bioticsItem[datatitle*="'+ searchInput +'"]').addClass('active').show();   
    }else if(searchInput == ''){
       $("#jshook_products_container").find('.errorProductSearch').show();
    }
    else{
       $("#jshook_products_container").find('.errorProductSearch').show();
    }
    });
  });